"use strict"; // tslint:disable

/**
 * Kiolyn POS API
 * Kiolyn POS API
 *
 * The version of the OpenAPI document: v2
 * Contact: chinh@willbe.vn
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.SuperAdminApi = exports.SuperAdminApiFactory = exports.SuperAdminApiFp = exports.SuperAdminApiAxiosParamCreator = exports.SubscriptionApi = exports.SubscriptionApiFactory = exports.SubscriptionApiFp = exports.SubscriptionApiAxiosParamCreator = exports.StoreApi = exports.StoreApiFactory = exports.StoreApiFp = exports.StoreApiAxiosParamCreator = exports.StatusBoardApi = exports.StatusBoardApiFactory = exports.StatusBoardApiFp = exports.StatusBoardApiAxiosParamCreator = exports.StationApi = exports.StationApiFactory = exports.StationApiFp = exports.StationApiAxiosParamCreator = exports.ShopOrderApi = exports.ShopOrderApiFactory = exports.ShopOrderApiFp = exports.ShopOrderApiAxiosParamCreator = exports.ShopItemApi = exports.ShopItemApiFactory = exports.ShopItemApiFp = exports.ShopItemApiAxiosParamCreator = exports.ShopApi = exports.ShopApiFactory = exports.ShopApiFp = exports.ShopApiAxiosParamCreator = exports.SettingsApi = exports.SettingsApiFactory = exports.SettingsApiFp = exports.SettingsApiAxiosParamCreator = exports.ScreenApi = exports.ScreenApiFactory = exports.ScreenApiFp = exports.ScreenApiAxiosParamCreator = exports.ReportApi = exports.ReportApiFactory = exports.ReportApiFp = exports.ReportApiAxiosParamCreator = exports.RefundCodeApi = exports.RefundCodeApiFactory = exports.RefundCodeApiFp = exports.RefundCodeApiAxiosParamCreator = exports.PromotionApi = exports.PromotionApiFactory = exports.PromotionApiFp = exports.PromotionApiAxiosParamCreator = exports.PromoCodeApi = exports.PromoCodeApiFactory = exports.PromoCodeApiFp = exports.PromoCodeApiAxiosParamCreator = exports.PrinterApi = exports.PrinterApiFactory = exports.PrinterApiFp = exports.PrinterApiAxiosParamCreator = exports.PasswordApi = exports.PasswordApiFactory = exports.PasswordApiFp = exports.PasswordApiAxiosParamCreator = exports.OrderingApi = exports.OrderingApiFactory = exports.OrderingApiFp = exports.OrderingApiAxiosParamCreator = exports.OrderApi = exports.OrderApiFactory = exports.OrderApiFp = exports.OrderApiAxiosParamCreator = exports.OnlineOrderApi = exports.OnlineOrderApiFactory = exports.OnlineOrderApiFp = exports.OnlineOrderApiAxiosParamCreator = exports.ModifierApi = exports.ModifierApiFactory = exports.ModifierApiFp = exports.ModifierApiAxiosParamCreator = exports.MetaApi = exports.MetaApiFactory = exports.MetaApiFp = exports.MetaApiAxiosParamCreator = exports.MerchantApi = exports.MerchantApiFactory = exports.MerchantApiFp = exports.MerchantApiAxiosParamCreator = exports.MenuTemplateApi = exports.MenuTemplateApiFactory = exports.MenuTemplateApiFp = exports.MenuTemplateApiAxiosParamCreator = exports.MapsApi = exports.MapsApiFactory = exports.MapsApiFp = exports.MapsApiAxiosParamCreator = exports.KitchenReceiptTemplateApi = exports.KitchenReceiptTemplateApiFactory = exports.KitchenReceiptTemplateApiFp = exports.KitchenReceiptTemplateApiAxiosParamCreator = exports.KitchenDisplayApi = exports.KitchenDisplayApiFactory = exports.KitchenDisplayApiFp = exports.KitchenDisplayApiAxiosParamCreator = exports.KioskApi = exports.KioskApiFactory = exports.KioskApiFp = exports.KioskApiAxiosParamCreator = exports.ItemApi = exports.ItemApiFactory = exports.ItemApiFp = exports.ItemApiAxiosParamCreator = exports.InvoiceApi = exports.InvoiceApiFactory = exports.InvoiceApiFp = exports.InvoiceApiAxiosParamCreator = exports.ImageApi = exports.ImageApiFactory = exports.ImageApiFp = exports.ImageApiAxiosParamCreator = exports.GiftcardApi = exports.GiftcardApiFactory = exports.GiftcardApiFp = exports.GiftcardApiAxiosParamCreator = exports.GcgroupApi = exports.GcgroupApiFactory = exports.GcgroupApiFp = exports.GcgroupApiAxiosParamCreator = exports.GalleryApi = exports.GalleryApiFactory = exports.GalleryApiFp = exports.GalleryApiAxiosParamCreator = exports.EmployeeApi = exports.EmployeeApiFactory = exports.EmployeeApiFp = exports.EmployeeApiAxiosParamCreator = exports.DeliveryApi = exports.DeliveryApiFactory = exports.DeliveryApiFp = exports.DeliveryApiAxiosParamCreator = exports.CustomerApi = exports.CustomerApiFactory = exports.CustomerApiFp = exports.CustomerApiAxiosParamCreator = exports.CcdeviceApi = exports.CcdeviceApiFactory = exports.CcdeviceApiFp = exports.CcdeviceApiAxiosParamCreator = exports.CategoryApi = exports.CategoryApiFactory = exports.CategoryApiFp = exports.CategoryApiAxiosParamCreator = exports.BillingApi = exports.BillingApiFactory = exports.BillingApiFp = exports.BillingApiAxiosParamCreator = exports.AuthApi = exports.AuthApiFactory = exports.AuthApiFp = exports.AuthApiAxiosParamCreator = exports.AudioApi = exports.AudioApiFactory = exports.AudioApiFp = exports.AudioApiAxiosParamCreator = exports.AreaApi = exports.AreaApiFactory = exports.AreaApiFp = exports.AreaApiAxiosParamCreator = exports.AppSettingsApi = exports.AppSettingsApiFactory = exports.AppSettingsApiFp = exports.AppSettingsApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.ActivationApi = exports.ActivationApiFactory = exports.ActivationApiFp = exports.ActivationApiAxiosParamCreator = void 0;

var globalImportUrl = require("url");

var axios_1 = require("axios"); // Some imports not used depending on template conditions
// @ts-ignore


var base_1 = require("./base");
/**
 * ActivationApi - axios parameter creator
 * @export
 */


exports.ActivationApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a activation with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteActivation: function deleteActivation(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteActivation.');
      }

      var localVarPath = "/activation/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * List activation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listActivation: function listActivation(options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/activation";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create activation
     * @param {Station} Station
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveActivation: function saveActivation(Station, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'Station' is not null or undefined


      if (Station === null || Station === undefined) {
        throw new base_1.RequiredError('Station', 'Required parameter Station was null or undefined when calling saveActivation.');
      }

      var localVarPath = "/activation";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Station !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Station !== undefined ? Station : {}) : Station || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ActivationApi - functional programming interface
 * @export
 */


exports.ActivationApiFp = function (configuration) {
  return {
    /**
     * Delete a activation with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteActivation: function deleteActivation(id, options) {
      var localVarAxiosArgs = exports.ActivationApiAxiosParamCreator(configuration).deleteActivation(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * List activation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listActivation: function listActivation(options) {
      var localVarAxiosArgs = exports.ActivationApiAxiosParamCreator(configuration).listActivation(options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create activation
     * @param {Station} Station
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveActivation: function saveActivation(Station, options) {
      var localVarAxiosArgs = exports.ActivationApiAxiosParamCreator(configuration).saveActivation(Station, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * ActivationApi - factory interface
 * @export
 */


exports.ActivationApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a activation with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteActivation: function deleteActivation(id, options) {
      return exports.ActivationApiFp(configuration).deleteActivation(id, options)(axios, basePath);
    },

    /**
     * List activation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listActivation: function listActivation(options) {
      return exports.ActivationApiFp(configuration).listActivation(options)(axios, basePath);
    },

    /**
     * Update/Create activation
     * @param {Station} Station
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveActivation: function saveActivation(Station, options) {
      return exports.ActivationApiFp(configuration).saveActivation(Station, options)(axios, basePath);
    }
  };
};
/**
 * ActivationApi - object-oriented interface
 * @export
 * @class ActivationApi
 * @extends {BaseAPI}
 */


var ActivationApi =
/** @class */
function (_super) {
  __extends(ActivationApi, _super);

  function ActivationApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a activation with given id
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActivationApi
   */


  ActivationApi.prototype.deleteActivation = function (id, options) {
    return exports.ActivationApiFp(this.configuration).deleteActivation(id, options)(this.axios, this.basePath);
  };
  /**
   * List activation
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActivationApi
   */


  ActivationApi.prototype.listActivation = function (options) {
    return exports.ActivationApiFp(this.configuration).listActivation(options)(this.axios, this.basePath);
  };
  /**
   * Update/Create activation
   * @param {Station} Station
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActivationApi
   */


  ActivationApi.prototype.saveActivation = function (Station, options) {
    return exports.ActivationApiFp(this.configuration).saveActivation(Station, options)(this.axios, this.basePath);
  };

  return ActivationApi;
}(base_1.BaseAPI);

exports.ActivationApi = ActivationApi;
/**
 * AdminApi - axios parameter creator
 * @export
 */

exports.AdminApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a admin with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAdmin: function deleteAdmin(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteAdmin.');
      }

      var localVarPath = "/v2/admin/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Admin\'s Account
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminAccount: function getAdminAccount(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getAdminAccount.');
      }

      var localVarPath = "/v2/admin/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * List Admin\'s Accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAdminAccounts: function listAdminAccounts(options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/v2/admin";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create Admin
     * @param {Admin} Admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveAdmin: function saveAdmin(Admin, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'Admin' is not null or undefined


      if (Admin === null || Admin === undefined) {
        throw new base_1.RequiredError('Admin', 'Required parameter Admin was null or undefined when calling saveAdmin.');
      }

      var localVarPath = "/v2/admin";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Admin !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Admin !== undefined ? Admin : {}) : Admin || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Verify admin\'s passkey
     * @param {InlineObject7} InlineObject7
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyPasskey: function verifyPasskey(InlineObject7, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'InlineObject7' is not null or undefined


      if (InlineObject7 === null || InlineObject7 === undefined) {
        throw new base_1.RequiredError('InlineObject7', 'Required parameter InlineObject7 was null or undefined when calling verifyPasskey.');
      }

      var localVarPath = "/v2/admin/verify-passkey";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof InlineObject7 !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(InlineObject7 !== undefined ? InlineObject7 : {}) : InlineObject7 || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AdminApi - functional programming interface
 * @export
 */


exports.AdminApiFp = function (configuration) {
  return {
    /**
     * Delete a admin with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAdmin: function deleteAdmin(id, options) {
      var localVarAxiosArgs = exports.AdminApiAxiosParamCreator(configuration).deleteAdmin(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Admin\'s Account
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminAccount: function getAdminAccount(id, options) {
      var localVarAxiosArgs = exports.AdminApiAxiosParamCreator(configuration).getAdminAccount(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * List Admin\'s Accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAdminAccounts: function listAdminAccounts(options) {
      var localVarAxiosArgs = exports.AdminApiAxiosParamCreator(configuration).listAdminAccounts(options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create Admin
     * @param {Admin} Admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveAdmin: function saveAdmin(Admin, options) {
      var localVarAxiosArgs = exports.AdminApiAxiosParamCreator(configuration).saveAdmin(Admin, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Verify admin\'s passkey
     * @param {InlineObject7} InlineObject7
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyPasskey: function verifyPasskey(InlineObject7, options) {
      var localVarAxiosArgs = exports.AdminApiAxiosParamCreator(configuration).verifyPasskey(InlineObject7, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * AdminApi - factory interface
 * @export
 */


exports.AdminApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a admin with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAdmin: function deleteAdmin(id, options) {
      return exports.AdminApiFp(configuration).deleteAdmin(id, options)(axios, basePath);
    },

    /**
     * Admin\'s Account
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminAccount: function getAdminAccount(id, options) {
      return exports.AdminApiFp(configuration).getAdminAccount(id, options)(axios, basePath);
    },

    /**
     * List Admin\'s Accounts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAdminAccounts: function listAdminAccounts(options) {
      return exports.AdminApiFp(configuration).listAdminAccounts(options)(axios, basePath);
    },

    /**
     * Update/Create Admin
     * @param {Admin} Admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveAdmin: function saveAdmin(Admin, options) {
      return exports.AdminApiFp(configuration).saveAdmin(Admin, options)(axios, basePath);
    },

    /**
     * Verify admin\'s passkey
     * @param {InlineObject7} InlineObject7
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyPasskey: function verifyPasskey(InlineObject7, options) {
      return exports.AdminApiFp(configuration).verifyPasskey(InlineObject7, options)(axios, basePath);
    }
  };
};
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */


var AdminApi =
/** @class */
function (_super) {
  __extends(AdminApi, _super);

  function AdminApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a admin with given id
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */


  AdminApi.prototype.deleteAdmin = function (id, options) {
    return exports.AdminApiFp(this.configuration).deleteAdmin(id, options)(this.axios, this.basePath);
  };
  /**
   * Admin\'s Account
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */


  AdminApi.prototype.getAdminAccount = function (id, options) {
    return exports.AdminApiFp(this.configuration).getAdminAccount(id, options)(this.axios, this.basePath);
  };
  /**
   * List Admin\'s Accounts
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */


  AdminApi.prototype.listAdminAccounts = function (options) {
    return exports.AdminApiFp(this.configuration).listAdminAccounts(options)(this.axios, this.basePath);
  };
  /**
   * Update/Create Admin
   * @param {Admin} Admin
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */


  AdminApi.prototype.saveAdmin = function (Admin, options) {
    return exports.AdminApiFp(this.configuration).saveAdmin(Admin, options)(this.axios, this.basePath);
  };
  /**
   * Verify admin\'s passkey
   * @param {InlineObject7} InlineObject7
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AdminApi
   */


  AdminApi.prototype.verifyPasskey = function (InlineObject7, options) {
    return exports.AdminApiFp(this.configuration).verifyPasskey(InlineObject7, options)(this.axios, this.basePath);
  };

  return AdminApi;
}(base_1.BaseAPI);

exports.AdminApi = AdminApi;
/**
 * AppSettingsApi - axios parameter creator
 * @export
 */

exports.AppSettingsApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get App Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAppSettings: function getAppSettings(options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/v2/app-settings";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update appSettings
     * @param {AppSettings} AppSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveAppSettings: function saveAppSettings(AppSettings, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'AppSettings' is not null or undefined


      if (AppSettings === null || AppSettings === undefined) {
        throw new base_1.RequiredError('AppSettings', 'Required parameter AppSettings was null or undefined when calling saveAppSettings.');
      }

      var localVarPath = "/v2/app-settings";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof AppSettings !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(AppSettings !== undefined ? AppSettings : {}) : AppSettings || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AppSettingsApi - functional programming interface
 * @export
 */


exports.AppSettingsApiFp = function (configuration) {
  return {
    /**
     * Get App Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAppSettings: function getAppSettings(options) {
      var localVarAxiosArgs = exports.AppSettingsApiAxiosParamCreator(configuration).getAppSettings(options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update appSettings
     * @param {AppSettings} AppSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveAppSettings: function saveAppSettings(AppSettings, options) {
      var localVarAxiosArgs = exports.AppSettingsApiAxiosParamCreator(configuration).saveAppSettings(AppSettings, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * AppSettingsApi - factory interface
 * @export
 */


exports.AppSettingsApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Get App Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAppSettings: function getAppSettings(options) {
      return exports.AppSettingsApiFp(configuration).getAppSettings(options)(axios, basePath);
    },

    /**
     * Update appSettings
     * @param {AppSettings} AppSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveAppSettings: function saveAppSettings(AppSettings, options) {
      return exports.AppSettingsApiFp(configuration).saveAppSettings(AppSettings, options)(axios, basePath);
    }
  };
};
/**
 * AppSettingsApi - object-oriented interface
 * @export
 * @class AppSettingsApi
 * @extends {BaseAPI}
 */


var AppSettingsApi =
/** @class */
function (_super) {
  __extends(AppSettingsApi, _super);

  function AppSettingsApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Get App Settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AppSettingsApi
   */


  AppSettingsApi.prototype.getAppSettings = function (options) {
    return exports.AppSettingsApiFp(this.configuration).getAppSettings(options)(this.axios, this.basePath);
  };
  /**
   * Update appSettings
   * @param {AppSettings} AppSettings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AppSettingsApi
   */


  AppSettingsApi.prototype.saveAppSettings = function (AppSettings, options) {
    return exports.AppSettingsApiFp(this.configuration).saveAppSettings(AppSettings, options)(this.axios, this.basePath);
  };

  return AppSettingsApi;
}(base_1.BaseAPI);

exports.AppSettingsApi = AppSettingsApi;
/**
 * AreaApi - axios parameter creator
 * @export
 */

exports.AreaApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a area with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteArea: function deleteArea(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteArea.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteArea.');
      }

      var localVarPath = "/area/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * return pdf
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAreaTablePdf: function getAreaTablePdf(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getAreaTablePdf.');
      }

      var localVarPath = "/area/{id}/export-pdf-table".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the customers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAreas: function listAreas(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listAreas.');
      }

      var localVarPath = "/area/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the area with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadArea: function loadArea(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadArea.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadArea.');
      }

      var localVarPath = "/area/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create area
     * @param {string} storeid The store id to get data from
     * @param {Area} Area
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveArea: function saveArea(storeid, Area, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveArea.');
      } // verify required parameter 'Area' is not null or undefined


      if (Area === null || Area === undefined) {
        throw new base_1.RequiredError('Area', 'Required parameter Area was null or undefined when calling saveArea.');
      }

      var localVarPath = "/area/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Area !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Area !== undefined ? Area : {}) : Area || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AreaApi - functional programming interface
 * @export
 */


exports.AreaApiFp = function (configuration) {
  return {
    /**
     * Delete a area with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteArea: function deleteArea(storeid, id, options) {
      var localVarAxiosArgs = exports.AreaApiAxiosParamCreator(configuration).deleteArea(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * return pdf
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAreaTablePdf: function getAreaTablePdf(id, options) {
      var localVarAxiosArgs = exports.AreaApiAxiosParamCreator(configuration).getAreaTablePdf(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the customers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAreas: function listAreas(storeid, options) {
      var localVarAxiosArgs = exports.AreaApiAxiosParamCreator(configuration).listAreas(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the area with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadArea: function loadArea(storeid, id, options) {
      var localVarAxiosArgs = exports.AreaApiAxiosParamCreator(configuration).loadArea(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create area
     * @param {string} storeid The store id to get data from
     * @param {Area} Area
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveArea: function saveArea(storeid, Area, options) {
      var localVarAxiosArgs = exports.AreaApiAxiosParamCreator(configuration).saveArea(storeid, Area, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * AreaApi - factory interface
 * @export
 */


exports.AreaApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a area with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteArea: function deleteArea(storeid, id, options) {
      return exports.AreaApiFp(configuration).deleteArea(storeid, id, options)(axios, basePath);
    },

    /**
     * return pdf
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAreaTablePdf: function getAreaTablePdf(id, options) {
      return exports.AreaApiFp(configuration).getAreaTablePdf(id, options)(axios, basePath);
    },

    /**
     * Return all the customers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listAreas: function listAreas(storeid, options) {
      return exports.AreaApiFp(configuration).listAreas(storeid, options)(axios, basePath);
    },

    /**
     * Return the area with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadArea: function loadArea(storeid, id, options) {
      return exports.AreaApiFp(configuration).loadArea(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create area
     * @param {string} storeid The store id to get data from
     * @param {Area} Area
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveArea: function saveArea(storeid, Area, options) {
      return exports.AreaApiFp(configuration).saveArea(storeid, Area, options)(axios, basePath);
    }
  };
};
/**
 * AreaApi - object-oriented interface
 * @export
 * @class AreaApi
 * @extends {BaseAPI}
 */


var AreaApi =
/** @class */
function (_super) {
  __extends(AreaApi, _super);

  function AreaApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a area with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AreaApi
   */


  AreaApi.prototype.deleteArea = function (storeid, id, options) {
    return exports.AreaApiFp(this.configuration).deleteArea(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * return pdf
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AreaApi
   */


  AreaApi.prototype.getAreaTablePdf = function (id, options) {
    return exports.AreaApiFp(this.configuration).getAreaTablePdf(id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the customers belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AreaApi
   */


  AreaApi.prototype.listAreas = function (storeid, options) {
    return exports.AreaApiFp(this.configuration).listAreas(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the area with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AreaApi
   */


  AreaApi.prototype.loadArea = function (storeid, id, options) {
    return exports.AreaApiFp(this.configuration).loadArea(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create area
   * @param {string} storeid The store id to get data from
   * @param {Area} Area
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AreaApi
   */


  AreaApi.prototype.saveArea = function (storeid, Area, options) {
    return exports.AreaApiFp(this.configuration).saveArea(storeid, Area, options)(this.axios, this.basePath);
  };

  return AreaApi;
}(base_1.BaseAPI);

exports.AreaApi = AreaApi;
/**
 * AudioApi - axios parameter creator
 * @export
 */

exports.AudioApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Return audio from text
     * @param {string} storeid The store id to get data from
     * @param {string} text
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    textToSpeech: function textToSpeech(storeid, text, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling textToSpeech.');
      } // verify required parameter 'text' is not null or undefined


      if (text === null || text === undefined) {
        throw new base_1.RequiredError('text', 'Required parameter text was null or undefined when calling textToSpeech.');
      }

      var localVarPath = "/app/audio/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};

      if (text !== undefined) {
        localVarQueryParameter['text'] = text;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AudioApi - functional programming interface
 * @export
 */


exports.AudioApiFp = function (configuration) {
  return {
    /**
     * Return audio from text
     * @param {string} storeid The store id to get data from
     * @param {string} text
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    textToSpeech: function textToSpeech(storeid, text, options) {
      var localVarAxiosArgs = exports.AudioApiAxiosParamCreator(configuration).textToSpeech(storeid, text, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * AudioApi - factory interface
 * @export
 */


exports.AudioApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Return audio from text
     * @param {string} storeid The store id to get data from
     * @param {string} text
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    textToSpeech: function textToSpeech(storeid, text, options) {
      return exports.AudioApiFp(configuration).textToSpeech(storeid, text, options)(axios, basePath);
    }
  };
};
/**
 * AudioApi - object-oriented interface
 * @export
 * @class AudioApi
 * @extends {BaseAPI}
 */


var AudioApi =
/** @class */
function (_super) {
  __extends(AudioApi, _super);

  function AudioApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Return audio from text
   * @param {string} storeid The store id to get data from
   * @param {string} text
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AudioApi
   */


  AudioApi.prototype.textToSpeech = function (storeid, text, options) {
    return exports.AudioApiFp(this.configuration).textToSpeech(storeid, text, options)(this.axios, this.basePath);
  };

  return AudioApi;
}(base_1.BaseAPI);

exports.AudioApi = AudioApi;
/**
 * AuthApi - axios parameter creator
 * @export
 */

exports.AuthApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Sin in an online user
     * @param {OnlineUser} OnlineUser The Online User sign in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signinUser: function signinUser(OnlineUser, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'OnlineUser' is not null or undefined


      if (OnlineUser === null || OnlineUser === undefined) {
        throw new base_1.RequiredError('OnlineUser', 'Required parameter OnlineUser was null or undefined when calling signinUser.');
      }

      var localVarPath = "/app/auth/signin";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof OnlineUser !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(OnlineUser !== undefined ? OnlineUser : {}) : OnlineUser || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Sign up an online user
     * @param {string} storeid The store id to get data from
     * @param {OnlineUser} OnlineUser The Online User to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signupUser: function signupUser(storeid, OnlineUser, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling signupUser.');
      } // verify required parameter 'OnlineUser' is not null or undefined


      if (OnlineUser === null || OnlineUser === undefined) {
        throw new base_1.RequiredError('OnlineUser', 'Required parameter OnlineUser was null or undefined when calling signupUser.');
      }

      var localVarPath = "/app/auth/{storeid}/signup".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof OnlineUser !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(OnlineUser !== undefined ? OnlineUser : {}) : OnlineUser || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * AuthApi - functional programming interface
 * @export
 */


exports.AuthApiFp = function (configuration) {
  return {
    /**
     * Sin in an online user
     * @param {OnlineUser} OnlineUser The Online User sign in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signinUser: function signinUser(OnlineUser, options) {
      var localVarAxiosArgs = exports.AuthApiAxiosParamCreator(configuration).signinUser(OnlineUser, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Sign up an online user
     * @param {string} storeid The store id to get data from
     * @param {OnlineUser} OnlineUser The Online User to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signupUser: function signupUser(storeid, OnlineUser, options) {
      var localVarAxiosArgs = exports.AuthApiAxiosParamCreator(configuration).signupUser(storeid, OnlineUser, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * AuthApi - factory interface
 * @export
 */


exports.AuthApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Sin in an online user
     * @param {OnlineUser} OnlineUser The Online User sign in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signinUser: function signinUser(OnlineUser, options) {
      return exports.AuthApiFp(configuration).signinUser(OnlineUser, options)(axios, basePath);
    },

    /**
     * Sign up an online user
     * @param {string} storeid The store id to get data from
     * @param {OnlineUser} OnlineUser The Online User to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    signupUser: function signupUser(storeid, OnlineUser, options) {
      return exports.AuthApiFp(configuration).signupUser(storeid, OnlineUser, options)(axios, basePath);
    }
  };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */


var AuthApi =
/** @class */
function (_super) {
  __extends(AuthApi, _super);

  function AuthApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Sin in an online user
   * @param {OnlineUser} OnlineUser The Online User sign in
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */


  AuthApi.prototype.signinUser = function (OnlineUser, options) {
    return exports.AuthApiFp(this.configuration).signinUser(OnlineUser, options)(this.axios, this.basePath);
  };
  /**
   * Sign up an online user
   * @param {string} storeid The store id to get data from
   * @param {OnlineUser} OnlineUser The Online User to be created
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */


  AuthApi.prototype.signupUser = function (storeid, OnlineUser, options) {
    return exports.AuthApiFp(this.configuration).signupUser(storeid, OnlineUser, options)(this.axios, this.basePath);
  };

  return AuthApi;
}(base_1.BaseAPI);

exports.AuthApi = AuthApi;
/**
 * BillingApi - axios parameter creator
 * @export
 */

exports.BillingApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Return result delete billing report
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillingReport: function deleteBillingReport(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteBillingReport.');
      }

      var localVarPath = "/v2/billing/reports/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * data billing station
     * @param {string} [name] filter by store name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingStation: function loadBillingStation(name, options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/v2/billing/station";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * data billing subscription
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingStationByStore: function loadBillingStationByStore(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadBillingStationByStore.');
      }

      var localVarPath = "/v2/store/{storeid}/billing/station".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * data billing subscription
     * @param {string} storeid The store id to get data from
     * @param {string} [date] filter by date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingSubscription: function loadBillingSubscription(storeid, date, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadBillingSubscription.');
      }

      var localVarPath = "/v2/store/{storeid}/billing/subscription".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] = date;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * data billing subscription
     * @param {string} [date] filter by date
     * @param {string} [name] filter by store name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportBilling: function reportBilling(date, name, options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/v2/billing/reports";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] = date;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create Billing Report
     * @param {BillingReport} BillingReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveBillingReport: function saveBillingReport(BillingReport, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'BillingReport' is not null or undefined


      if (BillingReport === null || BillingReport === undefined) {
        throw new base_1.RequiredError('BillingReport', 'Required parameter BillingReport was null or undefined when calling saveBillingReport.');
      }

      var localVarPath = "/v2/billing/reports";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof BillingReport !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(BillingReport !== undefined ? BillingReport : {}) : BillingReport || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * BillingApi - functional programming interface
 * @export
 */


exports.BillingApiFp = function (configuration) {
  return {
    /**
     * Return result delete billing report
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillingReport: function deleteBillingReport(id, options) {
      var localVarAxiosArgs = exports.BillingApiAxiosParamCreator(configuration).deleteBillingReport(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * data billing station
     * @param {string} [name] filter by store name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingStation: function loadBillingStation(name, options) {
      var localVarAxiosArgs = exports.BillingApiAxiosParamCreator(configuration).loadBillingStation(name, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * data billing subscription
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingStationByStore: function loadBillingStationByStore(storeid, options) {
      var localVarAxiosArgs = exports.BillingApiAxiosParamCreator(configuration).loadBillingStationByStore(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * data billing subscription
     * @param {string} storeid The store id to get data from
     * @param {string} [date] filter by date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingSubscription: function loadBillingSubscription(storeid, date, options) {
      var localVarAxiosArgs = exports.BillingApiAxiosParamCreator(configuration).loadBillingSubscription(storeid, date, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * data billing subscription
     * @param {string} [date] filter by date
     * @param {string} [name] filter by store name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportBilling: function reportBilling(date, name, options) {
      var localVarAxiosArgs = exports.BillingApiAxiosParamCreator(configuration).reportBilling(date, name, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create Billing Report
     * @param {BillingReport} BillingReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveBillingReport: function saveBillingReport(BillingReport, options) {
      var localVarAxiosArgs = exports.BillingApiAxiosParamCreator(configuration).saveBillingReport(BillingReport, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * BillingApi - factory interface
 * @export
 */


exports.BillingApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Return result delete billing report
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteBillingReport: function deleteBillingReport(id, options) {
      return exports.BillingApiFp(configuration).deleteBillingReport(id, options)(axios, basePath);
    },

    /**
     * data billing station
     * @param {string} [name] filter by store name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingStation: function loadBillingStation(name, options) {
      return exports.BillingApiFp(configuration).loadBillingStation(name, options)(axios, basePath);
    },

    /**
     * data billing subscription
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingStationByStore: function loadBillingStationByStore(storeid, options) {
      return exports.BillingApiFp(configuration).loadBillingStationByStore(storeid, options)(axios, basePath);
    },

    /**
     * data billing subscription
     * @param {string} storeid The store id to get data from
     * @param {string} [date] filter by date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingSubscription: function loadBillingSubscription(storeid, date, options) {
      return exports.BillingApiFp(configuration).loadBillingSubscription(storeid, date, options)(axios, basePath);
    },

    /**
     * data billing subscription
     * @param {string} [date] filter by date
     * @param {string} [name] filter by store name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportBilling: function reportBilling(date, name, options) {
      return exports.BillingApiFp(configuration).reportBilling(date, name, options)(axios, basePath);
    },

    /**
     * Update/Create Billing Report
     * @param {BillingReport} BillingReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveBillingReport: function saveBillingReport(BillingReport, options) {
      return exports.BillingApiFp(configuration).saveBillingReport(BillingReport, options)(axios, basePath);
    }
  };
};
/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */


var BillingApi =
/** @class */
function (_super) {
  __extends(BillingApi, _super);

  function BillingApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Return result delete billing report
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */


  BillingApi.prototype.deleteBillingReport = function (id, options) {
    return exports.BillingApiFp(this.configuration).deleteBillingReport(id, options)(this.axios, this.basePath);
  };
  /**
   * data billing station
   * @param {string} [name] filter by store name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */


  BillingApi.prototype.loadBillingStation = function (name, options) {
    return exports.BillingApiFp(this.configuration).loadBillingStation(name, options)(this.axios, this.basePath);
  };
  /**
   * data billing subscription
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */


  BillingApi.prototype.loadBillingStationByStore = function (storeid, options) {
    return exports.BillingApiFp(this.configuration).loadBillingStationByStore(storeid, options)(this.axios, this.basePath);
  };
  /**
   * data billing subscription
   * @param {string} storeid The store id to get data from
   * @param {string} [date] filter by date
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */


  BillingApi.prototype.loadBillingSubscription = function (storeid, date, options) {
    return exports.BillingApiFp(this.configuration).loadBillingSubscription(storeid, date, options)(this.axios, this.basePath);
  };
  /**
   * data billing subscription
   * @param {string} [date] filter by date
   * @param {string} [name] filter by store name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */


  BillingApi.prototype.reportBilling = function (date, name, options) {
    return exports.BillingApiFp(this.configuration).reportBilling(date, name, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create Billing Report
   * @param {BillingReport} BillingReport
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillingApi
   */


  BillingApi.prototype.saveBillingReport = function (BillingReport, options) {
    return exports.BillingApiFp(this.configuration).saveBillingReport(BillingReport, options)(this.axios, this.basePath);
  };

  return BillingApi;
}(base_1.BaseAPI);

exports.BillingApi = BillingApi;
/**
 * CategoryApi - axios parameter creator
 * @export
 */

exports.CategoryApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a category with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCategory: function deleteCategory(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteCategory.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteCategory.');
      }

      var localVarPath = "/category/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the customers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCategories: function listCategories(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listCategories.');
      }

      var localVarPath = "/category/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the category buckets belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCategoryBuckets: function listCategoryBuckets(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listCategoryBuckets.');
      }

      var localVarPath = "/category/{storeid}/allbuckets".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the category types belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCategoryTypes: function listCategoryTypes(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listCategoryTypes.');
      }

      var localVarPath = "/category/{storeid}/alltypes".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the category with id, name and items count
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listWithItemCount: function listWithItemCount(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listWithItemCount.');
      }

      var localVarPath = "/category/{storeid}/itemcount".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the category with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadCategory: function loadCategory(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadCategory.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadCategory.');
      }

      var localVarPath = "/category/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create category
     * @param {string} storeid The store id to get data from
     * @param {Category} Category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveCategory: function saveCategory(storeid, Category, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveCategory.');
      } // verify required parameter 'Category' is not null or undefined


      if (Category === null || Category === undefined) {
        throw new base_1.RequiredError('Category', 'Required parameter Category was null or undefined when calling saveCategory.');
      }

      var localVarPath = "/category/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Category !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Category !== undefined ? Category : {}) : Category || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CategoryApi - functional programming interface
 * @export
 */


exports.CategoryApiFp = function (configuration) {
  return {
    /**
     * Delete a category with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCategory: function deleteCategory(storeid, id, options) {
      var localVarAxiosArgs = exports.CategoryApiAxiosParamCreator(configuration).deleteCategory(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the customers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCategories: function listCategories(storeid, options) {
      var localVarAxiosArgs = exports.CategoryApiAxiosParamCreator(configuration).listCategories(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the category buckets belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCategoryBuckets: function listCategoryBuckets(storeid, options) {
      var localVarAxiosArgs = exports.CategoryApiAxiosParamCreator(configuration).listCategoryBuckets(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the category types belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCategoryTypes: function listCategoryTypes(storeid, options) {
      var localVarAxiosArgs = exports.CategoryApiAxiosParamCreator(configuration).listCategoryTypes(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the category with id, name and items count
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listWithItemCount: function listWithItemCount(storeid, options) {
      var localVarAxiosArgs = exports.CategoryApiAxiosParamCreator(configuration).listWithItemCount(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the category with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadCategory: function loadCategory(storeid, id, options) {
      var localVarAxiosArgs = exports.CategoryApiAxiosParamCreator(configuration).loadCategory(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create category
     * @param {string} storeid The store id to get data from
     * @param {Category} Category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveCategory: function saveCategory(storeid, Category, options) {
      var localVarAxiosArgs = exports.CategoryApiAxiosParamCreator(configuration).saveCategory(storeid, Category, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * CategoryApi - factory interface
 * @export
 */


exports.CategoryApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a category with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCategory: function deleteCategory(storeid, id, options) {
      return exports.CategoryApiFp(configuration).deleteCategory(storeid, id, options)(axios, basePath);
    },

    /**
     * Return all the customers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCategories: function listCategories(storeid, options) {
      return exports.CategoryApiFp(configuration).listCategories(storeid, options)(axios, basePath);
    },

    /**
     * Return all the category buckets belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCategoryBuckets: function listCategoryBuckets(storeid, options) {
      return exports.CategoryApiFp(configuration).listCategoryBuckets(storeid, options)(axios, basePath);
    },

    /**
     * Return all the category types belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCategoryTypes: function listCategoryTypes(storeid, options) {
      return exports.CategoryApiFp(configuration).listCategoryTypes(storeid, options)(axios, basePath);
    },

    /**
     * Return the category with id, name and items count
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listWithItemCount: function listWithItemCount(storeid, options) {
      return exports.CategoryApiFp(configuration).listWithItemCount(storeid, options)(axios, basePath);
    },

    /**
     * Return the category with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadCategory: function loadCategory(storeid, id, options) {
      return exports.CategoryApiFp(configuration).loadCategory(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create category
     * @param {string} storeid The store id to get data from
     * @param {Category} Category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveCategory: function saveCategory(storeid, Category, options) {
      return exports.CategoryApiFp(configuration).saveCategory(storeid, Category, options)(axios, basePath);
    }
  };
};
/**
 * CategoryApi - object-oriented interface
 * @export
 * @class CategoryApi
 * @extends {BaseAPI}
 */


var CategoryApi =
/** @class */
function (_super) {
  __extends(CategoryApi, _super);

  function CategoryApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a category with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */


  CategoryApi.prototype.deleteCategory = function (storeid, id, options) {
    return exports.CategoryApiFp(this.configuration).deleteCategory(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the customers belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */


  CategoryApi.prototype.listCategories = function (storeid, options) {
    return exports.CategoryApiFp(this.configuration).listCategories(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return all the category buckets belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */


  CategoryApi.prototype.listCategoryBuckets = function (storeid, options) {
    return exports.CategoryApiFp(this.configuration).listCategoryBuckets(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return all the category types belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */


  CategoryApi.prototype.listCategoryTypes = function (storeid, options) {
    return exports.CategoryApiFp(this.configuration).listCategoryTypes(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the category with id, name and items count
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */


  CategoryApi.prototype.listWithItemCount = function (storeid, options) {
    return exports.CategoryApiFp(this.configuration).listWithItemCount(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the category with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */


  CategoryApi.prototype.loadCategory = function (storeid, id, options) {
    return exports.CategoryApiFp(this.configuration).loadCategory(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create category
   * @param {string} storeid The store id to get data from
   * @param {Category} Category
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CategoryApi
   */


  CategoryApi.prototype.saveCategory = function (storeid, Category, options) {
    return exports.CategoryApiFp(this.configuration).saveCategory(storeid, Category, options)(this.axios, this.basePath);
  };

  return CategoryApi;
}(base_1.BaseAPI);

exports.CategoryApi = CategoryApi;
/**
 * CcdeviceApi - axios parameter creator
 * @export
 */

exports.CcdeviceApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a ccdevice with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCCDevice: function deleteCCDevice(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteCCDevice.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteCCDevice.');
      }

      var localVarPath = "/ccdevice/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the ccdevices belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCCDevices: function listCCDevices(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listCCDevices.');
      }

      var localVarPath = "/ccdevice/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the ccdevice with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadCCDevice: function loadCCDevice(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadCCDevice.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadCCDevice.');
      }

      var localVarPath = "/ccdevice/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create ccdevice
     * @param {string} storeid The store id to get data from
     * @param {CCDevice} CCDevice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveCCDevice: function saveCCDevice(storeid, CCDevice, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveCCDevice.');
      } // verify required parameter 'CCDevice' is not null or undefined


      if (CCDevice === null || CCDevice === undefined) {
        throw new base_1.RequiredError('CCDevice', 'Required parameter CCDevice was null or undefined when calling saveCCDevice.');
      }

      var localVarPath = "/ccdevice/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof CCDevice !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(CCDevice !== undefined ? CCDevice : {}) : CCDevice || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CcdeviceApi - functional programming interface
 * @export
 */


exports.CcdeviceApiFp = function (configuration) {
  return {
    /**
     * Delete a ccdevice with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCCDevice: function deleteCCDevice(storeid, id, options) {
      var localVarAxiosArgs = exports.CcdeviceApiAxiosParamCreator(configuration).deleteCCDevice(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the ccdevices belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCCDevices: function listCCDevices(storeid, options) {
      var localVarAxiosArgs = exports.CcdeviceApiAxiosParamCreator(configuration).listCCDevices(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the ccdevice with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadCCDevice: function loadCCDevice(storeid, id, options) {
      var localVarAxiosArgs = exports.CcdeviceApiAxiosParamCreator(configuration).loadCCDevice(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create ccdevice
     * @param {string} storeid The store id to get data from
     * @param {CCDevice} CCDevice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveCCDevice: function saveCCDevice(storeid, CCDevice, options) {
      var localVarAxiosArgs = exports.CcdeviceApiAxiosParamCreator(configuration).saveCCDevice(storeid, CCDevice, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * CcdeviceApi - factory interface
 * @export
 */


exports.CcdeviceApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a ccdevice with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCCDevice: function deleteCCDevice(storeid, id, options) {
      return exports.CcdeviceApiFp(configuration).deleteCCDevice(storeid, id, options)(axios, basePath);
    },

    /**
     * Return all the ccdevices belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCCDevices: function listCCDevices(storeid, options) {
      return exports.CcdeviceApiFp(configuration).listCCDevices(storeid, options)(axios, basePath);
    },

    /**
     * Return the ccdevice with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadCCDevice: function loadCCDevice(storeid, id, options) {
      return exports.CcdeviceApiFp(configuration).loadCCDevice(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create ccdevice
     * @param {string} storeid The store id to get data from
     * @param {CCDevice} CCDevice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveCCDevice: function saveCCDevice(storeid, CCDevice, options) {
      return exports.CcdeviceApiFp(configuration).saveCCDevice(storeid, CCDevice, options)(axios, basePath);
    }
  };
};
/**
 * CcdeviceApi - object-oriented interface
 * @export
 * @class CcdeviceApi
 * @extends {BaseAPI}
 */


var CcdeviceApi =
/** @class */
function (_super) {
  __extends(CcdeviceApi, _super);

  function CcdeviceApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a ccdevice with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CcdeviceApi
   */


  CcdeviceApi.prototype.deleteCCDevice = function (storeid, id, options) {
    return exports.CcdeviceApiFp(this.configuration).deleteCCDevice(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the ccdevices belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CcdeviceApi
   */


  CcdeviceApi.prototype.listCCDevices = function (storeid, options) {
    return exports.CcdeviceApiFp(this.configuration).listCCDevices(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the ccdevice with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CcdeviceApi
   */


  CcdeviceApi.prototype.loadCCDevice = function (storeid, id, options) {
    return exports.CcdeviceApiFp(this.configuration).loadCCDevice(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create ccdevice
   * @param {string} storeid The store id to get data from
   * @param {CCDevice} CCDevice
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CcdeviceApi
   */


  CcdeviceApi.prototype.saveCCDevice = function (storeid, CCDevice, options) {
    return exports.CcdeviceApiFp(this.configuration).saveCCDevice(storeid, CCDevice, options)(this.axios, this.basePath);
  };

  return CcdeviceApi;
}(base_1.BaseAPI);

exports.CcdeviceApi = CcdeviceApi;
/**
 * CustomerApi - axios parameter creator
 * @export
 */

exports.CustomerApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a customer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCustomer: function deleteCustomer(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteCustomer.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteCustomer.');
      }

      var localVarPath = "/customer/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Delete multiple customers
     * @param {string} storeid The store id to get data from
     * @param {InlineObject1} InlineObject1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMultipleCustomers: function deleteMultipleCustomers(storeid, InlineObject1, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteMultipleCustomers.');
      } // verify required parameter 'InlineObject1' is not null or undefined


      if (InlineObject1 === null || InlineObject1 === undefined) {
        throw new base_1.RequiredError('InlineObject1', 'Required parameter InlineObject1 was null or undefined when calling deleteMultipleCustomers.');
      }

      var localVarPath = "/customer/{storeid}/delete".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof InlineObject1 !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(InlineObject1 !== undefined ? InlineObject1 : {}) : InlineObject1 || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Import customers by csv file and return an id to track import process.
     * @param {string} storeid The store id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importCustomer: function importCustomer(storeid, file, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling importCustomer.');
      }

      var localVarPath = "/customer/{storeid}/import".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      var localVarFormParams = new FormData(); // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the customers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCustomers: function listCustomers(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listCustomers.');
      }

      var localVarPath = "/customer/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the customer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadCustomer: function loadCustomer(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadCustomer.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadCustomer.');
      }

      var localVarPath = "/customer/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create customer
     * @param {string} storeid The store id to get data from
     * @param {Customer} Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveCustomer: function saveCustomer(storeid, Customer, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveCustomer.');
      } // verify required parameter 'Customer' is not null or undefined


      if (Customer === null || Customer === undefined) {
        throw new base_1.RequiredError('Customer', 'Required parameter Customer was null or undefined when calling saveCustomer.');
      }

      var localVarPath = "/customer/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Customer !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Customer !== undefined ? Customer : {}) : Customer || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * CustomerApi - functional programming interface
 * @export
 */


exports.CustomerApiFp = function (configuration) {
  return {
    /**
     * Delete a customer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCustomer: function deleteCustomer(storeid, id, options) {
      var localVarAxiosArgs = exports.CustomerApiAxiosParamCreator(configuration).deleteCustomer(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Delete multiple customers
     * @param {string} storeid The store id to get data from
     * @param {InlineObject1} InlineObject1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMultipleCustomers: function deleteMultipleCustomers(storeid, InlineObject1, options) {
      var localVarAxiosArgs = exports.CustomerApiAxiosParamCreator(configuration).deleteMultipleCustomers(storeid, InlineObject1, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Import customers by csv file and return an id to track import process.
     * @param {string} storeid The store id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importCustomer: function importCustomer(storeid, file, options) {
      var localVarAxiosArgs = exports.CustomerApiAxiosParamCreator(configuration).importCustomer(storeid, file, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the customers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCustomers: function listCustomers(storeid, options) {
      var localVarAxiosArgs = exports.CustomerApiAxiosParamCreator(configuration).listCustomers(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the customer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadCustomer: function loadCustomer(storeid, id, options) {
      var localVarAxiosArgs = exports.CustomerApiAxiosParamCreator(configuration).loadCustomer(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create customer
     * @param {string} storeid The store id to get data from
     * @param {Customer} Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveCustomer: function saveCustomer(storeid, Customer, options) {
      var localVarAxiosArgs = exports.CustomerApiAxiosParamCreator(configuration).saveCustomer(storeid, Customer, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * CustomerApi - factory interface
 * @export
 */


exports.CustomerApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a customer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCustomer: function deleteCustomer(storeid, id, options) {
      return exports.CustomerApiFp(configuration).deleteCustomer(storeid, id, options)(axios, basePath);
    },

    /**
     * Delete multiple customers
     * @param {string} storeid The store id to get data from
     * @param {InlineObject1} InlineObject1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMultipleCustomers: function deleteMultipleCustomers(storeid, InlineObject1, options) {
      return exports.CustomerApiFp(configuration).deleteMultipleCustomers(storeid, InlineObject1, options)(axios, basePath);
    },

    /**
     * Import customers by csv file and return an id to track import process.
     * @param {string} storeid The store id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importCustomer: function importCustomer(storeid, file, options) {
      return exports.CustomerApiFp(configuration).importCustomer(storeid, file, options)(axios, basePath);
    },

    /**
     * Return all the customers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listCustomers: function listCustomers(storeid, options) {
      return exports.CustomerApiFp(configuration).listCustomers(storeid, options)(axios, basePath);
    },

    /**
     * Return the customer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadCustomer: function loadCustomer(storeid, id, options) {
      return exports.CustomerApiFp(configuration).loadCustomer(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create customer
     * @param {string} storeid The store id to get data from
     * @param {Customer} Customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveCustomer: function saveCustomer(storeid, Customer, options) {
      return exports.CustomerApiFp(configuration).saveCustomer(storeid, Customer, options)(axios, basePath);
    }
  };
};
/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */


var CustomerApi =
/** @class */
function (_super) {
  __extends(CustomerApi, _super);

  function CustomerApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a customer with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */


  CustomerApi.prototype.deleteCustomer = function (storeid, id, options) {
    return exports.CustomerApiFp(this.configuration).deleteCustomer(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Delete multiple customers
   * @param {string} storeid The store id to get data from
   * @param {InlineObject1} InlineObject1
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */


  CustomerApi.prototype.deleteMultipleCustomers = function (storeid, InlineObject1, options) {
    return exports.CustomerApiFp(this.configuration).deleteMultipleCustomers(storeid, InlineObject1, options)(this.axios, this.basePath);
  };
  /**
   * Import customers by csv file and return an id to track import process.
   * @param {string} storeid The store id to get data from
   * @param {any} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */


  CustomerApi.prototype.importCustomer = function (storeid, file, options) {
    return exports.CustomerApiFp(this.configuration).importCustomer(storeid, file, options)(this.axios, this.basePath);
  };
  /**
   * Return all the customers belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */


  CustomerApi.prototype.listCustomers = function (storeid, options) {
    return exports.CustomerApiFp(this.configuration).listCustomers(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the customer with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */


  CustomerApi.prototype.loadCustomer = function (storeid, id, options) {
    return exports.CustomerApiFp(this.configuration).loadCustomer(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create customer
   * @param {string} storeid The store id to get data from
   * @param {Customer} Customer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */


  CustomerApi.prototype.saveCustomer = function (storeid, Customer, options) {
    return exports.CustomerApiFp(this.configuration).saveCustomer(storeid, Customer, options)(this.axios, this.basePath);
  };

  return CustomerApi;
}(base_1.BaseAPI);

exports.CustomerApi = CustomerApi;
/**
 * DeliveryApi - axios parameter creator
 * @export
 */

exports.DeliveryApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Return the delivery quote of a online order
     * @param {string} storeid The store id to get data from
     * @param {string} origin The pickup address of the online order
     * @param {string} destination The dropoff address of the online order
     * @param {string} [dropoff_time] The dropoff time of the online order
     * @param {number} [order_value] Total order this field for delivery DoorDash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuote: function getQuote(storeid, origin, destination, dropoff_time, order_value, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getQuote.');
      } // verify required parameter 'origin' is not null or undefined


      if (origin === null || origin === undefined) {
        throw new base_1.RequiredError('origin', 'Required parameter origin was null or undefined when calling getQuote.');
      } // verify required parameter 'destination' is not null or undefined


      if (destination === null || destination === undefined) {
        throw new base_1.RequiredError('destination', 'Required parameter destination was null or undefined when calling getQuote.');
      }

      var localVarPath = "/delivery/{storeid}/quote".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (origin !== undefined) {
        localVarQueryParameter['origin'] = origin;
      }

      if (destination !== undefined) {
        localVarQueryParameter['destination'] = destination;
      }

      if (dropoff_time !== undefined) {
        localVarQueryParameter['dropoff_time'] = dropoff_time;
      }

      if (order_value !== undefined) {
        localVarQueryParameter['order_value'] = order_value;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * DeliveryApi - functional programming interface
 * @export
 */


exports.DeliveryApiFp = function (configuration) {
  return {
    /**
     * Return the delivery quote of a online order
     * @param {string} storeid The store id to get data from
     * @param {string} origin The pickup address of the online order
     * @param {string} destination The dropoff address of the online order
     * @param {string} [dropoff_time] The dropoff time of the online order
     * @param {number} [order_value] Total order this field for delivery DoorDash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuote: function getQuote(storeid, origin, destination, dropoff_time, order_value, options) {
      var localVarAxiosArgs = exports.DeliveryApiAxiosParamCreator(configuration).getQuote(storeid, origin, destination, dropoff_time, order_value, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * DeliveryApi - factory interface
 * @export
 */


exports.DeliveryApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Return the delivery quote of a online order
     * @param {string} storeid The store id to get data from
     * @param {string} origin The pickup address of the online order
     * @param {string} destination The dropoff address of the online order
     * @param {string} [dropoff_time] The dropoff time of the online order
     * @param {number} [order_value] Total order this field for delivery DoorDash
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getQuote: function getQuote(storeid, origin, destination, dropoff_time, order_value, options) {
      return exports.DeliveryApiFp(configuration).getQuote(storeid, origin, destination, dropoff_time, order_value, options)(axios, basePath);
    }
  };
};
/**
 * DeliveryApi - object-oriented interface
 * @export
 * @class DeliveryApi
 * @extends {BaseAPI}
 */


var DeliveryApi =
/** @class */
function (_super) {
  __extends(DeliveryApi, _super);

  function DeliveryApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Return the delivery quote of a online order
   * @param {string} storeid The store id to get data from
   * @param {string} origin The pickup address of the online order
   * @param {string} destination The dropoff address of the online order
   * @param {string} [dropoff_time] The dropoff time of the online order
   * @param {number} [order_value] Total order this field for delivery DoorDash
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DeliveryApi
   */


  DeliveryApi.prototype.getQuote = function (storeid, origin, destination, dropoff_time, order_value, options) {
    return exports.DeliveryApiFp(this.configuration).getQuote(storeid, origin, destination, dropoff_time, order_value, options)(this.axios, this.basePath);
  };

  return DeliveryApi;
}(base_1.BaseAPI);

exports.DeliveryApi = DeliveryApi;
/**
 * EmployeeApi - axios parameter creator
 * @export
 */

exports.EmployeeApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete an employee with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEmployee: function deleteEmployee(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteEmployee.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteEmployee.');
      }

      var localVarPath = "/employee/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the current employee detail
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccount: function getAccount(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getAccount.');
      }

      var localVarPath = "/eaccount/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the employees belong to given store
     * @param {string} storeid The store id to get data from
     * @param {string} [status] Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listEmployees: function listEmployees(storeid, status, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listEmployees.');
      }

      var localVarPath = "/employee/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the employee with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadEmployee: function loadEmployee(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadEmployee.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadEmployee.');
      }

      var localVarPath = "/employee/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create employee
     * @param {string} storeid The store id to get data from
     * @param {Employee} Employee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveEmployee: function saveEmployee(storeid, Employee, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveEmployee.');
      } // verify required parameter 'Employee' is not null or undefined


      if (Employee === null || Employee === undefined) {
        throw new base_1.RequiredError('Employee', 'Required parameter Employee was null or undefined when calling saveEmployee.');
      }

      var localVarPath = "/employee/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Employee !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Employee !== undefined ? Employee : {}) : Employee || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the current employee detail
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccount: function updateAccount(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling updateAccount.');
      }

      var localVarPath = "/eaccount/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * EmployeeApi - functional programming interface
 * @export
 */


exports.EmployeeApiFp = function (configuration) {
  return {
    /**
     * Delete an employee with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEmployee: function deleteEmployee(storeid, id, options) {
      var localVarAxiosArgs = exports.EmployeeApiAxiosParamCreator(configuration).deleteEmployee(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the current employee detail
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccount: function getAccount(storeid, options) {
      var localVarAxiosArgs = exports.EmployeeApiAxiosParamCreator(configuration).getAccount(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the employees belong to given store
     * @param {string} storeid The store id to get data from
     * @param {string} [status] Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listEmployees: function listEmployees(storeid, status, options) {
      var localVarAxiosArgs = exports.EmployeeApiAxiosParamCreator(configuration).listEmployees(storeid, status, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the employee with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadEmployee: function loadEmployee(storeid, id, options) {
      var localVarAxiosArgs = exports.EmployeeApiAxiosParamCreator(configuration).loadEmployee(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create employee
     * @param {string} storeid The store id to get data from
     * @param {Employee} Employee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveEmployee: function saveEmployee(storeid, Employee, options) {
      var localVarAxiosArgs = exports.EmployeeApiAxiosParamCreator(configuration).saveEmployee(storeid, Employee, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the current employee detail
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccount: function updateAccount(storeid, options) {
      var localVarAxiosArgs = exports.EmployeeApiAxiosParamCreator(configuration).updateAccount(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * EmployeeApi - factory interface
 * @export
 */


exports.EmployeeApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete an employee with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEmployee: function deleteEmployee(storeid, id, options) {
      return exports.EmployeeApiFp(configuration).deleteEmployee(storeid, id, options)(axios, basePath);
    },

    /**
     * Return the current employee detail
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccount: function getAccount(storeid, options) {
      return exports.EmployeeApiFp(configuration).getAccount(storeid, options)(axios, basePath);
    },

    /**
     * Return all the employees belong to given store
     * @param {string} storeid The store id to get data from
     * @param {string} [status] Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listEmployees: function listEmployees(storeid, status, options) {
      return exports.EmployeeApiFp(configuration).listEmployees(storeid, status, options)(axios, basePath);
    },

    /**
     * Return the employee with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadEmployee: function loadEmployee(storeid, id, options) {
      return exports.EmployeeApiFp(configuration).loadEmployee(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create employee
     * @param {string} storeid The store id to get data from
     * @param {Employee} Employee
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveEmployee: function saveEmployee(storeid, Employee, options) {
      return exports.EmployeeApiFp(configuration).saveEmployee(storeid, Employee, options)(axios, basePath);
    },

    /**
     * Return the current employee detail
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccount: function updateAccount(storeid, options) {
      return exports.EmployeeApiFp(configuration).updateAccount(storeid, options)(axios, basePath);
    }
  };
};
/**
 * EmployeeApi - object-oriented interface
 * @export
 * @class EmployeeApi
 * @extends {BaseAPI}
 */


var EmployeeApi =
/** @class */
function (_super) {
  __extends(EmployeeApi, _super);

  function EmployeeApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete an employee with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmployeeApi
   */


  EmployeeApi.prototype.deleteEmployee = function (storeid, id, options) {
    return exports.EmployeeApiFp(this.configuration).deleteEmployee(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return the current employee detail
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmployeeApi
   */


  EmployeeApi.prototype.getAccount = function (storeid, options) {
    return exports.EmployeeApiFp(this.configuration).getAccount(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return all the employees belong to given store
   * @param {string} storeid The store id to get data from
   * @param {string} [status] Status
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmployeeApi
   */


  EmployeeApi.prototype.listEmployees = function (storeid, status, options) {
    return exports.EmployeeApiFp(this.configuration).listEmployees(storeid, status, options)(this.axios, this.basePath);
  };
  /**
   * Return the employee with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmployeeApi
   */


  EmployeeApi.prototype.loadEmployee = function (storeid, id, options) {
    return exports.EmployeeApiFp(this.configuration).loadEmployee(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create employee
   * @param {string} storeid The store id to get data from
   * @param {Employee} Employee
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmployeeApi
   */


  EmployeeApi.prototype.saveEmployee = function (storeid, Employee, options) {
    return exports.EmployeeApiFp(this.configuration).saveEmployee(storeid, Employee, options)(this.axios, this.basePath);
  };
  /**
   * Return the current employee detail
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmployeeApi
   */


  EmployeeApi.prototype.updateAccount = function (storeid, options) {
    return exports.EmployeeApiFp(this.configuration).updateAccount(storeid, options)(this.axios, this.basePath);
  };

  return EmployeeApi;
}(base_1.BaseAPI);

exports.EmployeeApi = EmployeeApi;
/**
 * GalleryApi - axios parameter creator
 * @export
 */

exports.GalleryApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a gallery with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    destroy: function destroy(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling destroy.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling destroy.');
      }

      var localVarPath = "/gallery/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the galleries belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list: function list(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling list.');
      }

      var localVarPath = "/gallery/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the gallery with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    load: function load(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling load.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling load.');
      }

      var localVarPath = "/gallery/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create gallery
     * @param {string} storeid The store id to get data from
     * @param {Gallery} Gallery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveOrUpdate: function saveOrUpdate(storeid, Gallery, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveOrUpdate.');
      } // verify required parameter 'Gallery' is not null or undefined


      if (Gallery === null || Gallery === undefined) {
        throw new base_1.RequiredError('Gallery', 'Required parameter Gallery was null or undefined when calling saveOrUpdate.');
      }

      var localVarPath = "/gallery/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Gallery !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Gallery !== undefined ? Gallery : {}) : Gallery || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * GalleryApi - functional programming interface
 * @export
 */


exports.GalleryApiFp = function (configuration) {
  return {
    /**
     * Delete a gallery with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    destroy: function destroy(storeid, id, options) {
      var localVarAxiosArgs = exports.GalleryApiAxiosParamCreator(configuration).destroy(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the galleries belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list: function list(storeid, options) {
      var localVarAxiosArgs = exports.GalleryApiAxiosParamCreator(configuration).list(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the gallery with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    load: function load(storeid, id, options) {
      var localVarAxiosArgs = exports.GalleryApiAxiosParamCreator(configuration).load(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create gallery
     * @param {string} storeid The store id to get data from
     * @param {Gallery} Gallery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveOrUpdate: function saveOrUpdate(storeid, Gallery, options) {
      var localVarAxiosArgs = exports.GalleryApiAxiosParamCreator(configuration).saveOrUpdate(storeid, Gallery, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * GalleryApi - factory interface
 * @export
 */


exports.GalleryApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a gallery with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    destroy: function destroy(storeid, id, options) {
      return exports.GalleryApiFp(configuration).destroy(storeid, id, options)(axios, basePath);
    },

    /**
     * Return all the galleries belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list: function list(storeid, options) {
      return exports.GalleryApiFp(configuration).list(storeid, options)(axios, basePath);
    },

    /**
     * Return the gallery with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    load: function load(storeid, id, options) {
      return exports.GalleryApiFp(configuration).load(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create gallery
     * @param {string} storeid The store id to get data from
     * @param {Gallery} Gallery
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveOrUpdate: function saveOrUpdate(storeid, Gallery, options) {
      return exports.GalleryApiFp(configuration).saveOrUpdate(storeid, Gallery, options)(axios, basePath);
    }
  };
};
/**
 * GalleryApi - object-oriented interface
 * @export
 * @class GalleryApi
 * @extends {BaseAPI}
 */


var GalleryApi =
/** @class */
function (_super) {
  __extends(GalleryApi, _super);

  function GalleryApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a gallery with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GalleryApi
   */


  GalleryApi.prototype.destroy = function (storeid, id, options) {
    return exports.GalleryApiFp(this.configuration).destroy(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the galleries belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GalleryApi
   */


  GalleryApi.prototype.list = function (storeid, options) {
    return exports.GalleryApiFp(this.configuration).list(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the gallery with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GalleryApi
   */


  GalleryApi.prototype.load = function (storeid, id, options) {
    return exports.GalleryApiFp(this.configuration).load(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create gallery
   * @param {string} storeid The store id to get data from
   * @param {Gallery} Gallery
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GalleryApi
   */


  GalleryApi.prototype.saveOrUpdate = function (storeid, Gallery, options) {
    return exports.GalleryApiFp(this.configuration).saveOrUpdate(storeid, Gallery, options)(this.axios, this.basePath);
  };

  return GalleryApi;
}(base_1.BaseAPI);

exports.GalleryApi = GalleryApi;
/**
 * GcgroupApi - axios parameter creator
 * @export
 */

exports.GcgroupApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a giftcard group with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGcGroup: function deleteGcGroup(merchantid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'merchantid' is not null or undefined


      if (merchantid === null || merchantid === undefined) {
        throw new base_1.RequiredError('merchantid', 'Required parameter merchantid was null or undefined when calling deleteGcGroup.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteGcGroup.');
      }

      var localVarPath = "/gcgroup/{merchantid}/{id}".replace("{" + "merchantid" + "}", encodeURIComponent(String(merchantid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all giftcard groups belong to given merchant
     * @param {string} merchantid The merchant id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGcGroups: function listGcGroups(merchantid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'merchantid' is not null or undefined


      if (merchantid === null || merchantid === undefined) {
        throw new base_1.RequiredError('merchantid', 'Required parameter merchantid was null or undefined when calling listGcGroups.');
      }

      var localVarPath = "/gcgroup/{merchantid}".replace("{" + "merchantid" + "}", encodeURIComponent(String(merchantid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the giftcard group with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadGcGroup: function loadGcGroup(merchantid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'merchantid' is not null or undefined


      if (merchantid === null || merchantid === undefined) {
        throw new base_1.RequiredError('merchantid', 'Required parameter merchantid was null or undefined when calling loadGcGroup.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadGcGroup.');
      }

      var localVarPath = "/gcgroup/{merchantid}/{id}".replace("{" + "merchantid" + "}", encodeURIComponent(String(merchantid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create giftcard groups
     * @param {string} merchantid The merchant id to get data from
     * @param {GcGroup} GcGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveGcGroup: function saveGcGroup(merchantid, GcGroup, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'merchantid' is not null or undefined


      if (merchantid === null || merchantid === undefined) {
        throw new base_1.RequiredError('merchantid', 'Required parameter merchantid was null or undefined when calling saveGcGroup.');
      } // verify required parameter 'GcGroup' is not null or undefined


      if (GcGroup === null || GcGroup === undefined) {
        throw new base_1.RequiredError('GcGroup', 'Required parameter GcGroup was null or undefined when calling saveGcGroup.');
      }

      var localVarPath = "/gcgroup/{merchantid}".replace("{" + "merchantid" + "}", encodeURIComponent(String(merchantid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof GcGroup !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(GcGroup !== undefined ? GcGroup : {}) : GcGroup || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * GcgroupApi - functional programming interface
 * @export
 */


exports.GcgroupApiFp = function (configuration) {
  return {
    /**
     * Delete a giftcard group with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGcGroup: function deleteGcGroup(merchantid, id, options) {
      var localVarAxiosArgs = exports.GcgroupApiAxiosParamCreator(configuration).deleteGcGroup(merchantid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all giftcard groups belong to given merchant
     * @param {string} merchantid The merchant id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGcGroups: function listGcGroups(merchantid, options) {
      var localVarAxiosArgs = exports.GcgroupApiAxiosParamCreator(configuration).listGcGroups(merchantid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the giftcard group with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadGcGroup: function loadGcGroup(merchantid, id, options) {
      var localVarAxiosArgs = exports.GcgroupApiAxiosParamCreator(configuration).loadGcGroup(merchantid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create giftcard groups
     * @param {string} merchantid The merchant id to get data from
     * @param {GcGroup} GcGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveGcGroup: function saveGcGroup(merchantid, GcGroup, options) {
      var localVarAxiosArgs = exports.GcgroupApiAxiosParamCreator(configuration).saveGcGroup(merchantid, GcGroup, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * GcgroupApi - factory interface
 * @export
 */


exports.GcgroupApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a giftcard group with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGcGroup: function deleteGcGroup(merchantid, id, options) {
      return exports.GcgroupApiFp(configuration).deleteGcGroup(merchantid, id, options)(axios, basePath);
    },

    /**
     * Return all giftcard groups belong to given merchant
     * @param {string} merchantid The merchant id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGcGroups: function listGcGroups(merchantid, options) {
      return exports.GcgroupApiFp(configuration).listGcGroups(merchantid, options)(axios, basePath);
    },

    /**
     * Return the giftcard group with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadGcGroup: function loadGcGroup(merchantid, id, options) {
      return exports.GcgroupApiFp(configuration).loadGcGroup(merchantid, id, options)(axios, basePath);
    },

    /**
     * Update/Create giftcard groups
     * @param {string} merchantid The merchant id to get data from
     * @param {GcGroup} GcGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveGcGroup: function saveGcGroup(merchantid, GcGroup, options) {
      return exports.GcgroupApiFp(configuration).saveGcGroup(merchantid, GcGroup, options)(axios, basePath);
    }
  };
};
/**
 * GcgroupApi - object-oriented interface
 * @export
 * @class GcgroupApi
 * @extends {BaseAPI}
 */


var GcgroupApi =
/** @class */
function (_super) {
  __extends(GcgroupApi, _super);

  function GcgroupApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a giftcard group with given id
   * @param {string} merchantid The merchant id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GcgroupApi
   */


  GcgroupApi.prototype.deleteGcGroup = function (merchantid, id, options) {
    return exports.GcgroupApiFp(this.configuration).deleteGcGroup(merchantid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all giftcard groups belong to given merchant
   * @param {string} merchantid The merchant id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GcgroupApi
   */


  GcgroupApi.prototype.listGcGroups = function (merchantid, options) {
    return exports.GcgroupApiFp(this.configuration).listGcGroups(merchantid, options)(this.axios, this.basePath);
  };
  /**
   * Return the giftcard group with given id
   * @param {string} merchantid The merchant id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GcgroupApi
   */


  GcgroupApi.prototype.loadGcGroup = function (merchantid, id, options) {
    return exports.GcgroupApiFp(this.configuration).loadGcGroup(merchantid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create giftcard groups
   * @param {string} merchantid The merchant id to get data from
   * @param {GcGroup} GcGroup
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GcgroupApi
   */


  GcgroupApi.prototype.saveGcGroup = function (merchantid, GcGroup, options) {
    return exports.GcgroupApiFp(this.configuration).saveGcGroup(merchantid, GcGroup, options)(this.axios, this.basePath);
  };

  return GcgroupApi;
}(base_1.BaseAPI);

exports.GcgroupApi = GcgroupApi;
/**
 * GiftcardApi - axios parameter creator
 * @export
 */

exports.GiftcardApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a giftcard with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGiftcard: function deleteGiftcard(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteGiftcard.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteGiftcard.');
      }

      var localVarPath = "/giftcard/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Delete a giftcard with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGiftcardByMerchant: function deleteGiftcardByMerchant(merchantid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'merchantid' is not null or undefined


      if (merchantid === null || merchantid === undefined) {
        throw new base_1.RequiredError('merchantid', 'Required parameter merchantid was null or undefined when calling deleteGiftcardByMerchant.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteGiftcardByMerchant.');
      }

      var localVarPath = "/merchant/giftcard/{merchantid}/{id}".replace("{" + "merchantid" + "}", encodeURIComponent(String(merchantid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Import giftcards by csv file and return an id to track import process.
     * @param {string} storeid The store id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importGiftcard: function importGiftcard(storeid, file, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling importGiftcard.');
      }

      var localVarPath = "/giftcard/{storeid}/import".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      var localVarFormParams = new FormData(); // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Import giftcards by csv file and return an id to track import process.
     * @param {string} merchantid The merchant id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importGiftcardByMerchant: function importGiftcardByMerchant(merchantid, file, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'merchantid' is not null or undefined


      if (merchantid === null || merchantid === undefined) {
        throw new base_1.RequiredError('merchantid', 'Required parameter merchantid was null or undefined when calling importGiftcardByMerchant.');
      }

      var localVarPath = "/merchant/giftcard/{merchantid}/import".replace("{" + "merchantid" + "}", encodeURIComponent(String(merchantid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      var localVarFormParams = new FormData(); // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the giftcards belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGiftcards: function listGiftcards(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listGiftcards.');
      }

      var localVarPath = "/giftcard/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the giftcards belong to given merchant id.
     * @param {string} merchantid The merchant id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGiftcardsByMerchant: function listGiftcardsByMerchant(merchantid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'merchantid' is not null or undefined


      if (merchantid === null || merchantid === undefined) {
        throw new base_1.RequiredError('merchantid', 'Required parameter merchantid was null or undefined when calling listGiftcardsByMerchant.');
      }

      var localVarPath = "/merchant/giftcard/{merchantid}".replace("{" + "merchantid" + "}", encodeURIComponent(String(merchantid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the giftcard with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadGiftcard: function loadGiftcard(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadGiftcard.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadGiftcard.');
      }

      var localVarPath = "/giftcard/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the giftcard with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadGiftcardByMerchant: function loadGiftcardByMerchant(merchantid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'merchantid' is not null or undefined


      if (merchantid === null || merchantid === undefined) {
        throw new base_1.RequiredError('merchantid', 'Required parameter merchantid was null or undefined when calling loadGiftcardByMerchant.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadGiftcardByMerchant.');
      }

      var localVarPath = "/merchant/giftcard/{merchantid}/{id}".replace("{" + "merchantid" + "}", encodeURIComponent(String(merchantid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create giftcard
     * @param {string} storeid The store id to get data from
     * @param {Giftcard} Giftcard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveGiftcard: function saveGiftcard(storeid, Giftcard, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveGiftcard.');
      } // verify required parameter 'Giftcard' is not null or undefined


      if (Giftcard === null || Giftcard === undefined) {
        throw new base_1.RequiredError('Giftcard', 'Required parameter Giftcard was null or undefined when calling saveGiftcard.');
      }

      var localVarPath = "/giftcard/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Giftcard !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Giftcard !== undefined ? Giftcard : {}) : Giftcard || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create giftcard by merhcna
     * @param {string} merchantid The merchant id to get data from
     * @param {Giftcard} Giftcard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveGiftcardByMerchantId: function saveGiftcardByMerchantId(merchantid, Giftcard, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'merchantid' is not null or undefined


      if (merchantid === null || merchantid === undefined) {
        throw new base_1.RequiredError('merchantid', 'Required parameter merchantid was null or undefined when calling saveGiftcardByMerchantId.');
      } // verify required parameter 'Giftcard' is not null or undefined


      if (Giftcard === null || Giftcard === undefined) {
        throw new base_1.RequiredError('Giftcard', 'Required parameter Giftcard was null or undefined when calling saveGiftcardByMerchantId.');
      }

      var localVarPath = "/merchant/giftcard/{merchantid}".replace("{" + "merchantid" + "}", encodeURIComponent(String(merchantid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Giftcard !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Giftcard !== undefined ? Giftcard : {}) : Giftcard || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * transfer giftcard to merchant
     * @param {string} merchantid The merchant id to get data from
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transferGiftcardToMerchant: function transferGiftcardToMerchant(merchantid, storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'merchantid' is not null or undefined


      if (merchantid === null || merchantid === undefined) {
        throw new base_1.RequiredError('merchantid', 'Required parameter merchantid was null or undefined when calling transferGiftcardToMerchant.');
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling transferGiftcardToMerchant.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling transferGiftcardToMerchant.');
      }

      var localVarPath = "/giftcard/{storeid}/{merchantid}/{id}".replace("{" + "merchantid" + "}", encodeURIComponent(String(merchantid))).replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * GiftcardApi - functional programming interface
 * @export
 */


exports.GiftcardApiFp = function (configuration) {
  return {
    /**
     * Delete a giftcard with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGiftcard: function deleteGiftcard(storeid, id, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).deleteGiftcard(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Delete a giftcard with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGiftcardByMerchant: function deleteGiftcardByMerchant(merchantid, id, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).deleteGiftcardByMerchant(merchantid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Import giftcards by csv file and return an id to track import process.
     * @param {string} storeid The store id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importGiftcard: function importGiftcard(storeid, file, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).importGiftcard(storeid, file, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Import giftcards by csv file and return an id to track import process.
     * @param {string} merchantid The merchant id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importGiftcardByMerchant: function importGiftcardByMerchant(merchantid, file, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).importGiftcardByMerchant(merchantid, file, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the giftcards belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGiftcards: function listGiftcards(storeid, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).listGiftcards(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the giftcards belong to given merchant id.
     * @param {string} merchantid The merchant id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGiftcardsByMerchant: function listGiftcardsByMerchant(merchantid, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).listGiftcardsByMerchant(merchantid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the giftcard with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadGiftcard: function loadGiftcard(storeid, id, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).loadGiftcard(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the giftcard with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadGiftcardByMerchant: function loadGiftcardByMerchant(merchantid, id, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).loadGiftcardByMerchant(merchantid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create giftcard
     * @param {string} storeid The store id to get data from
     * @param {Giftcard} Giftcard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveGiftcard: function saveGiftcard(storeid, Giftcard, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).saveGiftcard(storeid, Giftcard, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create giftcard by merhcna
     * @param {string} merchantid The merchant id to get data from
     * @param {Giftcard} Giftcard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveGiftcardByMerchantId: function saveGiftcardByMerchantId(merchantid, Giftcard, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).saveGiftcardByMerchantId(merchantid, Giftcard, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * transfer giftcard to merchant
     * @param {string} merchantid The merchant id to get data from
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transferGiftcardToMerchant: function transferGiftcardToMerchant(merchantid, storeid, id, options) {
      var localVarAxiosArgs = exports.GiftcardApiAxiosParamCreator(configuration).transferGiftcardToMerchant(merchantid, storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * GiftcardApi - factory interface
 * @export
 */


exports.GiftcardApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a giftcard with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGiftcard: function deleteGiftcard(storeid, id, options) {
      return exports.GiftcardApiFp(configuration).deleteGiftcard(storeid, id, options)(axios, basePath);
    },

    /**
     * Delete a giftcard with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteGiftcardByMerchant: function deleteGiftcardByMerchant(merchantid, id, options) {
      return exports.GiftcardApiFp(configuration).deleteGiftcardByMerchant(merchantid, id, options)(axios, basePath);
    },

    /**
     * Import giftcards by csv file and return an id to track import process.
     * @param {string} storeid The store id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importGiftcard: function importGiftcard(storeid, file, options) {
      return exports.GiftcardApiFp(configuration).importGiftcard(storeid, file, options)(axios, basePath);
    },

    /**
     * Import giftcards by csv file and return an id to track import process.
     * @param {string} merchantid The merchant id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importGiftcardByMerchant: function importGiftcardByMerchant(merchantid, file, options) {
      return exports.GiftcardApiFp(configuration).importGiftcardByMerchant(merchantid, file, options)(axios, basePath);
    },

    /**
     * Return all the giftcards belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGiftcards: function listGiftcards(storeid, options) {
      return exports.GiftcardApiFp(configuration).listGiftcards(storeid, options)(axios, basePath);
    },

    /**
     * Return all the giftcards belong to given merchant id.
     * @param {string} merchantid The merchant id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listGiftcardsByMerchant: function listGiftcardsByMerchant(merchantid, options) {
      return exports.GiftcardApiFp(configuration).listGiftcardsByMerchant(merchantid, options)(axios, basePath);
    },

    /**
     * Return the giftcard with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadGiftcard: function loadGiftcard(storeid, id, options) {
      return exports.GiftcardApiFp(configuration).loadGiftcard(storeid, id, options)(axios, basePath);
    },

    /**
     * Return the giftcard with given id
     * @param {string} merchantid The merchant id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadGiftcardByMerchant: function loadGiftcardByMerchant(merchantid, id, options) {
      return exports.GiftcardApiFp(configuration).loadGiftcardByMerchant(merchantid, id, options)(axios, basePath);
    },

    /**
     * Update/Create giftcard
     * @param {string} storeid The store id to get data from
     * @param {Giftcard} Giftcard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveGiftcard: function saveGiftcard(storeid, Giftcard, options) {
      return exports.GiftcardApiFp(configuration).saveGiftcard(storeid, Giftcard, options)(axios, basePath);
    },

    /**
     * Update/Create giftcard by merhcna
     * @param {string} merchantid The merchant id to get data from
     * @param {Giftcard} Giftcard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveGiftcardByMerchantId: function saveGiftcardByMerchantId(merchantid, Giftcard, options) {
      return exports.GiftcardApiFp(configuration).saveGiftcardByMerchantId(merchantid, Giftcard, options)(axios, basePath);
    },

    /**
     * transfer giftcard to merchant
     * @param {string} merchantid The merchant id to get data from
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    transferGiftcardToMerchant: function transferGiftcardToMerchant(merchantid, storeid, id, options) {
      return exports.GiftcardApiFp(configuration).transferGiftcardToMerchant(merchantid, storeid, id, options)(axios, basePath);
    }
  };
};
/**
 * GiftcardApi - object-oriented interface
 * @export
 * @class GiftcardApi
 * @extends {BaseAPI}
 */


var GiftcardApi =
/** @class */
function (_super) {
  __extends(GiftcardApi, _super);

  function GiftcardApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a giftcard with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.deleteGiftcard = function (storeid, id, options) {
    return exports.GiftcardApiFp(this.configuration).deleteGiftcard(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Delete a giftcard with given id
   * @param {string} merchantid The merchant id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.deleteGiftcardByMerchant = function (merchantid, id, options) {
    return exports.GiftcardApiFp(this.configuration).deleteGiftcardByMerchant(merchantid, id, options)(this.axios, this.basePath);
  };
  /**
   * Import giftcards by csv file and return an id to track import process.
   * @param {string} storeid The store id to get data from
   * @param {any} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.importGiftcard = function (storeid, file, options) {
    return exports.GiftcardApiFp(this.configuration).importGiftcard(storeid, file, options)(this.axios, this.basePath);
  };
  /**
   * Import giftcards by csv file and return an id to track import process.
   * @param {string} merchantid The merchant id to get data from
   * @param {any} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.importGiftcardByMerchant = function (merchantid, file, options) {
    return exports.GiftcardApiFp(this.configuration).importGiftcardByMerchant(merchantid, file, options)(this.axios, this.basePath);
  };
  /**
   * Return all the giftcards belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.listGiftcards = function (storeid, options) {
    return exports.GiftcardApiFp(this.configuration).listGiftcards(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return all the giftcards belong to given merchant id.
   * @param {string} merchantid The merchant id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.listGiftcardsByMerchant = function (merchantid, options) {
    return exports.GiftcardApiFp(this.configuration).listGiftcardsByMerchant(merchantid, options)(this.axios, this.basePath);
  };
  /**
   * Return the giftcard with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.loadGiftcard = function (storeid, id, options) {
    return exports.GiftcardApiFp(this.configuration).loadGiftcard(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return the giftcard with given id
   * @param {string} merchantid The merchant id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.loadGiftcardByMerchant = function (merchantid, id, options) {
    return exports.GiftcardApiFp(this.configuration).loadGiftcardByMerchant(merchantid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create giftcard
   * @param {string} storeid The store id to get data from
   * @param {Giftcard} Giftcard
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.saveGiftcard = function (storeid, Giftcard, options) {
    return exports.GiftcardApiFp(this.configuration).saveGiftcard(storeid, Giftcard, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create giftcard by merhcna
   * @param {string} merchantid The merchant id to get data from
   * @param {Giftcard} Giftcard
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.saveGiftcardByMerchantId = function (merchantid, Giftcard, options) {
    return exports.GiftcardApiFp(this.configuration).saveGiftcardByMerchantId(merchantid, Giftcard, options)(this.axios, this.basePath);
  };
  /**
   * transfer giftcard to merchant
   * @param {string} merchantid The merchant id to get data from
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GiftcardApi
   */


  GiftcardApi.prototype.transferGiftcardToMerchant = function (merchantid, storeid, id, options) {
    return exports.GiftcardApiFp(this.configuration).transferGiftcardToMerchant(merchantid, storeid, id, options)(this.axios, this.basePath);
  };

  return GiftcardApi;
}(base_1.BaseAPI);

exports.GiftcardApi = GiftcardApi;
/**
 * ImageApi - axios parameter creator
 * @export
 */

exports.ImageApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * upload image for a store
     * @param {string} storeid The store id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadImage: function uploadImage(storeid, file, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling uploadImage.');
      }

      var localVarPath = "/image/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      var localVarFormParams = new FormData(); // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ImageApi - functional programming interface
 * @export
 */


exports.ImageApiFp = function (configuration) {
  return {
    /**
     * upload image for a store
     * @param {string} storeid The store id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadImage: function uploadImage(storeid, file, options) {
      var localVarAxiosArgs = exports.ImageApiAxiosParamCreator(configuration).uploadImage(storeid, file, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * ImageApi - factory interface
 * @export
 */


exports.ImageApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * upload image for a store
     * @param {string} storeid The store id to get data from
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadImage: function uploadImage(storeid, file, options) {
      return exports.ImageApiFp(configuration).uploadImage(storeid, file, options)(axios, basePath);
    }
  };
};
/**
 * ImageApi - object-oriented interface
 * @export
 * @class ImageApi
 * @extends {BaseAPI}
 */


var ImageApi =
/** @class */
function (_super) {
  __extends(ImageApi, _super);

  function ImageApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * upload image for a store
   * @param {string} storeid The store id to get data from
   * @param {any} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImageApi
   */


  ImageApi.prototype.uploadImage = function (storeid, file, options) {
    return exports.ImageApiFp(this.configuration).uploadImage(storeid, file, options)(this.axios, this.basePath);
  };

  return ImageApi;
}(base_1.BaseAPI);

exports.ImageApi = ImageApi;
/**
 * InvoiceApi - axios parameter creator
 * @export
 */

exports.InvoiceApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a invoice with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvoice: function deleteInvoice(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteInvoice.');
      }

      var localVarPath = "/invoices/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     *
     * @param {number} [limit] limit size of page
     * @param {number} [page] page number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateInvoice: function generateInvoice(limit, page, options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/invoices/generate";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Generate invoice by id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateInvoiceById: function generateInvoiceById(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling generateInvoiceById.');
      }

      var localVarPath = "/invoices/generate/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * return invoice pdf
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoicePdf: function getInvoicePdf(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getInvoicePdf.');
      }

      var localVarPath = "/invoices/export-pdf/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     *
     * @param {number} [limit] limit size of page
     * @param {number} [page] page number
     * @param {string} [customerName] filter by customerName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listInvoice: function listInvoice(limit, page, customerName, options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/invoices";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (customerName !== undefined) {
        localVarQueryParameter['customerName'] = customerName;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * InvoiceApi - functional programming interface
 * @export
 */


exports.InvoiceApiFp = function (configuration) {
  return {
    /**
     * Delete a invoice with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvoice: function deleteInvoice(id, options) {
      var localVarAxiosArgs = exports.InvoiceApiAxiosParamCreator(configuration).deleteInvoice(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     *
     * @param {number} [limit] limit size of page
     * @param {number} [page] page number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateInvoice: function generateInvoice(limit, page, options) {
      var localVarAxiosArgs = exports.InvoiceApiAxiosParamCreator(configuration).generateInvoice(limit, page, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Generate invoice by id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateInvoiceById: function generateInvoiceById(id, options) {
      var localVarAxiosArgs = exports.InvoiceApiAxiosParamCreator(configuration).generateInvoiceById(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * return invoice pdf
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoicePdf: function getInvoicePdf(id, options) {
      var localVarAxiosArgs = exports.InvoiceApiAxiosParamCreator(configuration).getInvoicePdf(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     *
     * @param {number} [limit] limit size of page
     * @param {number} [page] page number
     * @param {string} [customerName] filter by customerName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listInvoice: function listInvoice(limit, page, customerName, options) {
      var localVarAxiosArgs = exports.InvoiceApiAxiosParamCreator(configuration).listInvoice(limit, page, customerName, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * InvoiceApi - factory interface
 * @export
 */


exports.InvoiceApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a invoice with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteInvoice: function deleteInvoice(id, options) {
      return exports.InvoiceApiFp(configuration).deleteInvoice(id, options)(axios, basePath);
    },

    /**
     *
     * @param {number} [limit] limit size of page
     * @param {number} [page] page number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateInvoice: function generateInvoice(limit, page, options) {
      return exports.InvoiceApiFp(configuration).generateInvoice(limit, page, options)(axios, basePath);
    },

    /**
     * Generate invoice by id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    generateInvoiceById: function generateInvoiceById(id, options) {
      return exports.InvoiceApiFp(configuration).generateInvoiceById(id, options)(axios, basePath);
    },

    /**
     * return invoice pdf
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInvoicePdf: function getInvoicePdf(id, options) {
      return exports.InvoiceApiFp(configuration).getInvoicePdf(id, options)(axios, basePath);
    },

    /**
     *
     * @param {number} [limit] limit size of page
     * @param {number} [page] page number
     * @param {string} [customerName] filter by customerName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listInvoice: function listInvoice(limit, page, customerName, options) {
      return exports.InvoiceApiFp(configuration).listInvoice(limit, page, customerName, options)(axios, basePath);
    }
  };
};
/**
 * InvoiceApi - object-oriented interface
 * @export
 * @class InvoiceApi
 * @extends {BaseAPI}
 */


var InvoiceApi =
/** @class */
function (_super) {
  __extends(InvoiceApi, _super);

  function InvoiceApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a invoice with given id
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */


  InvoiceApi.prototype.deleteInvoice = function (id, options) {
    return exports.InvoiceApiFp(this.configuration).deleteInvoice(id, options)(this.axios, this.basePath);
  };
  /**
   *
   * @param {number} [limit] limit size of page
   * @param {number} [page] page number
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */


  InvoiceApi.prototype.generateInvoice = function (limit, page, options) {
    return exports.InvoiceApiFp(this.configuration).generateInvoice(limit, page, options)(this.axios, this.basePath);
  };
  /**
   * Generate invoice by id
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */


  InvoiceApi.prototype.generateInvoiceById = function (id, options) {
    return exports.InvoiceApiFp(this.configuration).generateInvoiceById(id, options)(this.axios, this.basePath);
  };
  /**
   * return invoice pdf
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */


  InvoiceApi.prototype.getInvoicePdf = function (id, options) {
    return exports.InvoiceApiFp(this.configuration).getInvoicePdf(id, options)(this.axios, this.basePath);
  };
  /**
   *
   * @param {number} [limit] limit size of page
   * @param {number} [page] page number
   * @param {string} [customerName] filter by customerName
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvoiceApi
   */


  InvoiceApi.prototype.listInvoice = function (limit, page, customerName, options) {
    return exports.InvoiceApiFp(this.configuration).listInvoice(limit, page, customerName, options)(this.axios, this.basePath);
  };

  return InvoiceApi;
}(base_1.BaseAPI);

exports.InvoiceApi = InvoiceApi;
/**
 * ItemApi - axios parameter creator
 * @export
 */

exports.ItemApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a item with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteItem: function deleteItem(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteItem.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteItem.');
      }

      var localVarPath = "/item/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the items/categories belong to the given store that queried by name
     * @param {string} storeid The store id to get data from
     * @param {string} name The items/categories\&#39; name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMenu: function getMenu(storeid, name, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getMenu.');
      } // verify required parameter 'name' is not null or undefined


      if (name === null || name === undefined) {
        throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling getMenu.');
      }

      var localVarPath = "/item/{storeid}/byname/{name}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "name" + "}", encodeURIComponent(String(name)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the items belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listItems: function listItems(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listItems.');
      }

      var localVarPath = "/item/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the item with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadItem: function loadItem(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadItem.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadItem.');
      }

      var localVarPath = "/item/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create item
     * @param {string} storeid The store id to get data from
     * @param {Item} Item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveItem: function saveItem(storeid, Item, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveItem.');
      } // verify required parameter 'Item' is not null or undefined


      if (Item === null || Item === undefined) {
        throw new base_1.RequiredError('Item', 'Required parameter Item was null or undefined when calling saveItem.');
      }

      var localVarPath = "/item/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Item !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Item !== undefined ? Item : {}) : Item || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ItemApi - functional programming interface
 * @export
 */


exports.ItemApiFp = function (configuration) {
  return {
    /**
     * Delete a item with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteItem: function deleteItem(storeid, id, options) {
      var localVarAxiosArgs = exports.ItemApiAxiosParamCreator(configuration).deleteItem(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the items/categories belong to the given store that queried by name
     * @param {string} storeid The store id to get data from
     * @param {string} name The items/categories\&#39; name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMenu: function getMenu(storeid, name, options) {
      var localVarAxiosArgs = exports.ItemApiAxiosParamCreator(configuration).getMenu(storeid, name, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the items belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listItems: function listItems(storeid, options) {
      var localVarAxiosArgs = exports.ItemApiAxiosParamCreator(configuration).listItems(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the item with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadItem: function loadItem(storeid, id, options) {
      var localVarAxiosArgs = exports.ItemApiAxiosParamCreator(configuration).loadItem(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create item
     * @param {string} storeid The store id to get data from
     * @param {Item} Item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveItem: function saveItem(storeid, Item, options) {
      var localVarAxiosArgs = exports.ItemApiAxiosParamCreator(configuration).saveItem(storeid, Item, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * ItemApi - factory interface
 * @export
 */


exports.ItemApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a item with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteItem: function deleteItem(storeid, id, options) {
      return exports.ItemApiFp(configuration).deleteItem(storeid, id, options)(axios, basePath);
    },

    /**
     * Return all the items/categories belong to the given store that queried by name
     * @param {string} storeid The store id to get data from
     * @param {string} name The items/categories\&#39; name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMenu: function getMenu(storeid, name, options) {
      return exports.ItemApiFp(configuration).getMenu(storeid, name, options)(axios, basePath);
    },

    /**
     * Return all the items belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listItems: function listItems(storeid, options) {
      return exports.ItemApiFp(configuration).listItems(storeid, options)(axios, basePath);
    },

    /**
     * Return the item with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadItem: function loadItem(storeid, id, options) {
      return exports.ItemApiFp(configuration).loadItem(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create item
     * @param {string} storeid The store id to get data from
     * @param {Item} Item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveItem: function saveItem(storeid, Item, options) {
      return exports.ItemApiFp(configuration).saveItem(storeid, Item, options)(axios, basePath);
    }
  };
};
/**
 * ItemApi - object-oriented interface
 * @export
 * @class ItemApi
 * @extends {BaseAPI}
 */


var ItemApi =
/** @class */
function (_super) {
  __extends(ItemApi, _super);

  function ItemApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a item with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemApi
   */


  ItemApi.prototype.deleteItem = function (storeid, id, options) {
    return exports.ItemApiFp(this.configuration).deleteItem(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the items/categories belong to the given store that queried by name
   * @param {string} storeid The store id to get data from
   * @param {string} name The items/categories\&#39; name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemApi
   */


  ItemApi.prototype.getMenu = function (storeid, name, options) {
    return exports.ItemApiFp(this.configuration).getMenu(storeid, name, options)(this.axios, this.basePath);
  };
  /**
   * Return all the items belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemApi
   */


  ItemApi.prototype.listItems = function (storeid, options) {
    return exports.ItemApiFp(this.configuration).listItems(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the item with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemApi
   */


  ItemApi.prototype.loadItem = function (storeid, id, options) {
    return exports.ItemApiFp(this.configuration).loadItem(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create item
   * @param {string} storeid The store id to get data from
   * @param {Item} Item
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemApi
   */


  ItemApi.prototype.saveItem = function (storeid, Item, options) {
    return exports.ItemApiFp(this.configuration).saveItem(storeid, Item, options)(this.axios, this.basePath);
  };

  return ItemApi;
}(base_1.BaseAPI);

exports.ItemApi = ItemApi;
/**
 * KioskApi - axios parameter creator
 * @export
 */

exports.KioskApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * return all the available kiosks inside given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listKiosk: function listKiosk(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listKiosk.');
      }

      var localVarPath = "/app/store/{storeid}/kiosks".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * return a kiosk with detail information for ordering
     * @param {string} storeid The store id to get data from
     * @param {string} kioskid The kiosk station id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadKiosk: function loadKiosk(storeid, kioskid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadKiosk.');
      } // verify required parameter 'kioskid' is not null or undefined


      if (kioskid === null || kioskid === undefined) {
        throw new base_1.RequiredError('kioskid', 'Required parameter kioskid was null or undefined when calling loadKiosk.');
      }

      var localVarPath = "/app/store/{storeid}/kiosk/{kioskid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "kioskid" + "}", encodeURIComponent(String(kioskid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * KioskApi - functional programming interface
 * @export
 */


exports.KioskApiFp = function (configuration) {
  return {
    /**
     * return all the available kiosks inside given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listKiosk: function listKiosk(storeid, options) {
      var localVarAxiosArgs = exports.KioskApiAxiosParamCreator(configuration).listKiosk(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * return a kiosk with detail information for ordering
     * @param {string} storeid The store id to get data from
     * @param {string} kioskid The kiosk station id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadKiosk: function loadKiosk(storeid, kioskid, options) {
      var localVarAxiosArgs = exports.KioskApiAxiosParamCreator(configuration).loadKiosk(storeid, kioskid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * KioskApi - factory interface
 * @export
 */


exports.KioskApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * return all the available kiosks inside given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listKiosk: function listKiosk(storeid, options) {
      return exports.KioskApiFp(configuration).listKiosk(storeid, options)(axios, basePath);
    },

    /**
     * return a kiosk with detail information for ordering
     * @param {string} storeid The store id to get data from
     * @param {string} kioskid The kiosk station id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadKiosk: function loadKiosk(storeid, kioskid, options) {
      return exports.KioskApiFp(configuration).loadKiosk(storeid, kioskid, options)(axios, basePath);
    }
  };
};
/**
 * KioskApi - object-oriented interface
 * @export
 * @class KioskApi
 * @extends {BaseAPI}
 */


var KioskApi =
/** @class */
function (_super) {
  __extends(KioskApi, _super);

  function KioskApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * return all the available kiosks inside given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KioskApi
   */


  KioskApi.prototype.listKiosk = function (storeid, options) {
    return exports.KioskApiFp(this.configuration).listKiosk(storeid, options)(this.axios, this.basePath);
  };
  /**
   * return a kiosk with detail information for ordering
   * @param {string} storeid The store id to get data from
   * @param {string} kioskid The kiosk station id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KioskApi
   */


  KioskApi.prototype.loadKiosk = function (storeid, kioskid, options) {
    return exports.KioskApiFp(this.configuration).loadKiosk(storeid, kioskid, options)(this.axios, this.basePath);
  };

  return KioskApi;
}(base_1.BaseAPI);

exports.KioskApi = KioskApi;
/**
 * KitchenDisplayApi - axios parameter creator
 * @export
 */

exports.KitchenDisplayApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a kitchen display with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteKitchenDisplay: function deleteKitchenDisplay(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteKitchenDisplay.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteKitchenDisplay.');
      }

      var localVarPath = "/kitchendisplay/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the kitchen displays belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDSKitchenDisplays: function listDSKitchenDisplays(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listDSKitchenDisplays.');
      }

      var localVarPath = "/app/store/{storeid}/kitchen-displays".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the kitchen displays belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listKitchenDisplays: function listKitchenDisplays(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listKitchenDisplays.');
      }

      var localVarPath = "/kitchendisplay/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the kitchen display with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadDSKitchenDisplay: function loadDSKitchenDisplay(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadDSKitchenDisplay.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadDSKitchenDisplay.');
      }

      var localVarPath = "/app/store/{storeid}/kitchen-display/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the kitchen display with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadKitchenDisplay: function loadKitchenDisplay(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadKitchenDisplay.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadKitchenDisplay.');
      }

      var localVarPath = "/kitchendisplay/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create kitchen display
     * @param {string} storeid The store id to get data from
     * @param {KitchenDisplay} KitchenDisplay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveKitchenDisplay: function saveKitchenDisplay(storeid, KitchenDisplay, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveKitchenDisplay.');
      } // verify required parameter 'KitchenDisplay' is not null or undefined


      if (KitchenDisplay === null || KitchenDisplay === undefined) {
        throw new base_1.RequiredError('KitchenDisplay', 'Required parameter KitchenDisplay was null or undefined when calling saveKitchenDisplay.');
      }

      var localVarPath = "/kitchendisplay/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof KitchenDisplay !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(KitchenDisplay !== undefined ? KitchenDisplay : {}) : KitchenDisplay || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * KitchenDisplayApi - functional programming interface
 * @export
 */


exports.KitchenDisplayApiFp = function (configuration) {
  return {
    /**
     * Delete a kitchen display with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteKitchenDisplay: function deleteKitchenDisplay(storeid, id, options) {
      var localVarAxiosArgs = exports.KitchenDisplayApiAxiosParamCreator(configuration).deleteKitchenDisplay(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the kitchen displays belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDSKitchenDisplays: function listDSKitchenDisplays(storeid, options) {
      var localVarAxiosArgs = exports.KitchenDisplayApiAxiosParamCreator(configuration).listDSKitchenDisplays(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the kitchen displays belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listKitchenDisplays: function listKitchenDisplays(storeid, options) {
      var localVarAxiosArgs = exports.KitchenDisplayApiAxiosParamCreator(configuration).listKitchenDisplays(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the kitchen display with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadDSKitchenDisplay: function loadDSKitchenDisplay(storeid, id, options) {
      var localVarAxiosArgs = exports.KitchenDisplayApiAxiosParamCreator(configuration).loadDSKitchenDisplay(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the kitchen display with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadKitchenDisplay: function loadKitchenDisplay(storeid, id, options) {
      var localVarAxiosArgs = exports.KitchenDisplayApiAxiosParamCreator(configuration).loadKitchenDisplay(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create kitchen display
     * @param {string} storeid The store id to get data from
     * @param {KitchenDisplay} KitchenDisplay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveKitchenDisplay: function saveKitchenDisplay(storeid, KitchenDisplay, options) {
      var localVarAxiosArgs = exports.KitchenDisplayApiAxiosParamCreator(configuration).saveKitchenDisplay(storeid, KitchenDisplay, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * KitchenDisplayApi - factory interface
 * @export
 */


exports.KitchenDisplayApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a kitchen display with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteKitchenDisplay: function deleteKitchenDisplay(storeid, id, options) {
      return exports.KitchenDisplayApiFp(configuration).deleteKitchenDisplay(storeid, id, options)(axios, basePath);
    },

    /**
     * Return all the kitchen displays belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDSKitchenDisplays: function listDSKitchenDisplays(storeid, options) {
      return exports.KitchenDisplayApiFp(configuration).listDSKitchenDisplays(storeid, options)(axios, basePath);
    },

    /**
     * Return all the kitchen displays belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listKitchenDisplays: function listKitchenDisplays(storeid, options) {
      return exports.KitchenDisplayApiFp(configuration).listKitchenDisplays(storeid, options)(axios, basePath);
    },

    /**
     * Return the kitchen display with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadDSKitchenDisplay: function loadDSKitchenDisplay(storeid, id, options) {
      return exports.KitchenDisplayApiFp(configuration).loadDSKitchenDisplay(storeid, id, options)(axios, basePath);
    },

    /**
     * Return the kitchen display with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadKitchenDisplay: function loadKitchenDisplay(storeid, id, options) {
      return exports.KitchenDisplayApiFp(configuration).loadKitchenDisplay(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create kitchen display
     * @param {string} storeid The store id to get data from
     * @param {KitchenDisplay} KitchenDisplay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveKitchenDisplay: function saveKitchenDisplay(storeid, KitchenDisplay, options) {
      return exports.KitchenDisplayApiFp(configuration).saveKitchenDisplay(storeid, KitchenDisplay, options)(axios, basePath);
    }
  };
};
/**
 * KitchenDisplayApi - object-oriented interface
 * @export
 * @class KitchenDisplayApi
 * @extends {BaseAPI}
 */


var KitchenDisplayApi =
/** @class */
function (_super) {
  __extends(KitchenDisplayApi, _super);

  function KitchenDisplayApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a kitchen display with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KitchenDisplayApi
   */


  KitchenDisplayApi.prototype.deleteKitchenDisplay = function (storeid, id, options) {
    return exports.KitchenDisplayApiFp(this.configuration).deleteKitchenDisplay(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the kitchen displays belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KitchenDisplayApi
   */


  KitchenDisplayApi.prototype.listDSKitchenDisplays = function (storeid, options) {
    return exports.KitchenDisplayApiFp(this.configuration).listDSKitchenDisplays(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return all the kitchen displays belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KitchenDisplayApi
   */


  KitchenDisplayApi.prototype.listKitchenDisplays = function (storeid, options) {
    return exports.KitchenDisplayApiFp(this.configuration).listKitchenDisplays(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the kitchen display with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KitchenDisplayApi
   */


  KitchenDisplayApi.prototype.loadDSKitchenDisplay = function (storeid, id, options) {
    return exports.KitchenDisplayApiFp(this.configuration).loadDSKitchenDisplay(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return the kitchen display with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KitchenDisplayApi
   */


  KitchenDisplayApi.prototype.loadKitchenDisplay = function (storeid, id, options) {
    return exports.KitchenDisplayApiFp(this.configuration).loadKitchenDisplay(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create kitchen display
   * @param {string} storeid The store id to get data from
   * @param {KitchenDisplay} KitchenDisplay
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KitchenDisplayApi
   */


  KitchenDisplayApi.prototype.saveKitchenDisplay = function (storeid, KitchenDisplay, options) {
    return exports.KitchenDisplayApiFp(this.configuration).saveKitchenDisplay(storeid, KitchenDisplay, options)(this.axios, this.basePath);
  };

  return KitchenDisplayApi;
}(base_1.BaseAPI);

exports.KitchenDisplayApi = KitchenDisplayApi;
/**
 * KitchenReceiptTemplateApi - axios parameter creator
 * @export
 */

exports.KitchenReceiptTemplateApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a kitchen receipt template with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteKitchenReceiptTemplate: function deleteKitchenReceiptTemplate(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteKitchenReceiptTemplate.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteKitchenReceiptTemplate.');
      }

      var localVarPath = "/kreceipt-template/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the kitchen receipt templates belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listKitchenReceiptTemplates: function listKitchenReceiptTemplates(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listKitchenReceiptTemplates.');
      }

      var localVarPath = "/kreceipt-template/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the kitchen receipt template with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadKitchenReceiptTemplate: function loadKitchenReceiptTemplate(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadKitchenReceiptTemplate.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadKitchenReceiptTemplate.');
      }

      var localVarPath = "/kreceipt-template/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create kitchen receipt template
     * @param {string} storeid The store id to get data from
     * @param {KitchenReceiptTemplate} KitchenReceiptTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveKitchenReceiptTemplate: function saveKitchenReceiptTemplate(storeid, KitchenReceiptTemplate, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveKitchenReceiptTemplate.');
      } // verify required parameter 'KitchenReceiptTemplate' is not null or undefined


      if (KitchenReceiptTemplate === null || KitchenReceiptTemplate === undefined) {
        throw new base_1.RequiredError('KitchenReceiptTemplate', 'Required parameter KitchenReceiptTemplate was null or undefined when calling saveKitchenReceiptTemplate.');
      }

      var localVarPath = "/kreceipt-template/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof KitchenReceiptTemplate !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(KitchenReceiptTemplate !== undefined ? KitchenReceiptTemplate : {}) : KitchenReceiptTemplate || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * KitchenReceiptTemplateApi - functional programming interface
 * @export
 */


exports.KitchenReceiptTemplateApiFp = function (configuration) {
  return {
    /**
     * Delete a kitchen receipt template with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteKitchenReceiptTemplate: function deleteKitchenReceiptTemplate(storeid, id, options) {
      var localVarAxiosArgs = exports.KitchenReceiptTemplateApiAxiosParamCreator(configuration).deleteKitchenReceiptTemplate(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the kitchen receipt templates belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listKitchenReceiptTemplates: function listKitchenReceiptTemplates(storeid, options) {
      var localVarAxiosArgs = exports.KitchenReceiptTemplateApiAxiosParamCreator(configuration).listKitchenReceiptTemplates(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the kitchen receipt template with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadKitchenReceiptTemplate: function loadKitchenReceiptTemplate(storeid, id, options) {
      var localVarAxiosArgs = exports.KitchenReceiptTemplateApiAxiosParamCreator(configuration).loadKitchenReceiptTemplate(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create kitchen receipt template
     * @param {string} storeid The store id to get data from
     * @param {KitchenReceiptTemplate} KitchenReceiptTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveKitchenReceiptTemplate: function saveKitchenReceiptTemplate(storeid, KitchenReceiptTemplate, options) {
      var localVarAxiosArgs = exports.KitchenReceiptTemplateApiAxiosParamCreator(configuration).saveKitchenReceiptTemplate(storeid, KitchenReceiptTemplate, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * KitchenReceiptTemplateApi - factory interface
 * @export
 */


exports.KitchenReceiptTemplateApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a kitchen receipt template with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteKitchenReceiptTemplate: function deleteKitchenReceiptTemplate(storeid, id, options) {
      return exports.KitchenReceiptTemplateApiFp(configuration).deleteKitchenReceiptTemplate(storeid, id, options)(axios, basePath);
    },

    /**
     * Return all the kitchen receipt templates belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listKitchenReceiptTemplates: function listKitchenReceiptTemplates(storeid, options) {
      return exports.KitchenReceiptTemplateApiFp(configuration).listKitchenReceiptTemplates(storeid, options)(axios, basePath);
    },

    /**
     * Return the kitchen receipt template with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadKitchenReceiptTemplate: function loadKitchenReceiptTemplate(storeid, id, options) {
      return exports.KitchenReceiptTemplateApiFp(configuration).loadKitchenReceiptTemplate(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create kitchen receipt template
     * @param {string} storeid The store id to get data from
     * @param {KitchenReceiptTemplate} KitchenReceiptTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveKitchenReceiptTemplate: function saveKitchenReceiptTemplate(storeid, KitchenReceiptTemplate, options) {
      return exports.KitchenReceiptTemplateApiFp(configuration).saveKitchenReceiptTemplate(storeid, KitchenReceiptTemplate, options)(axios, basePath);
    }
  };
};
/**
 * KitchenReceiptTemplateApi - object-oriented interface
 * @export
 * @class KitchenReceiptTemplateApi
 * @extends {BaseAPI}
 */


var KitchenReceiptTemplateApi =
/** @class */
function (_super) {
  __extends(KitchenReceiptTemplateApi, _super);

  function KitchenReceiptTemplateApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a kitchen receipt template with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KitchenReceiptTemplateApi
   */


  KitchenReceiptTemplateApi.prototype.deleteKitchenReceiptTemplate = function (storeid, id, options) {
    return exports.KitchenReceiptTemplateApiFp(this.configuration).deleteKitchenReceiptTemplate(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the kitchen receipt templates belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KitchenReceiptTemplateApi
   */


  KitchenReceiptTemplateApi.prototype.listKitchenReceiptTemplates = function (storeid, options) {
    return exports.KitchenReceiptTemplateApiFp(this.configuration).listKitchenReceiptTemplates(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the kitchen receipt template with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KitchenReceiptTemplateApi
   */


  KitchenReceiptTemplateApi.prototype.loadKitchenReceiptTemplate = function (storeid, id, options) {
    return exports.KitchenReceiptTemplateApiFp(this.configuration).loadKitchenReceiptTemplate(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create kitchen receipt template
   * @param {string} storeid The store id to get data from
   * @param {KitchenReceiptTemplate} KitchenReceiptTemplate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof KitchenReceiptTemplateApi
   */


  KitchenReceiptTemplateApi.prototype.saveKitchenReceiptTemplate = function (storeid, KitchenReceiptTemplate, options) {
    return exports.KitchenReceiptTemplateApiFp(this.configuration).saveKitchenReceiptTemplate(storeid, KitchenReceiptTemplate, options)(this.axios, this.basePath);
  };

  return KitchenReceiptTemplateApi;
}(base_1.BaseAPI);

exports.KitchenReceiptTemplateApi = KitchenReceiptTemplateApi;
/**
 * MapsApi - axios parameter creator
 * @export
 */

exports.MapsApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * return list of areas matching with google map auto complete api
     * @param {string} place the place to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPlaces: function listPlaces(place, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'place' is not null or undefined


      if (place === null || place === undefined) {
        throw new base_1.RequiredError('place', 'Required parameter place was null or undefined when calling listPlaces.');
      }

      var localVarPath = "/places";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};

      if (place !== undefined) {
        localVarQueryParameter['place'] = place;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MapsApi - functional programming interface
 * @export
 */


exports.MapsApiFp = function (configuration) {
  return {
    /**
     * return list of areas matching with google map auto complete api
     * @param {string} place the place to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPlaces: function listPlaces(place, options) {
      var localVarAxiosArgs = exports.MapsApiAxiosParamCreator(configuration).listPlaces(place, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * MapsApi - factory interface
 * @export
 */


exports.MapsApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * return list of areas matching with google map auto complete api
     * @param {string} place the place to search for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPlaces: function listPlaces(place, options) {
      return exports.MapsApiFp(configuration).listPlaces(place, options)(axios, basePath);
    }
  };
};
/**
 * MapsApi - object-oriented interface
 * @export
 * @class MapsApi
 * @extends {BaseAPI}
 */


var MapsApi =
/** @class */
function (_super) {
  __extends(MapsApi, _super);

  function MapsApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * return list of areas matching with google map auto complete api
   * @param {string} place the place to search for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MapsApi
   */


  MapsApi.prototype.listPlaces = function (place, options) {
    return exports.MapsApiFp(this.configuration).listPlaces(place, options)(this.axios, this.basePath);
  };

  return MapsApi;
}(base_1.BaseAPI);

exports.MapsApi = MapsApi;
/**
 * MenuTemplateApi - axios parameter creator
 * @export
 */

exports.MenuTemplateApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Return the menu template with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {string} token authorization token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMenuTemplate: function loadMenuTemplate(storeid, id, token, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadMenuTemplate.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadMenuTemplate.');
      } // verify required parameter 'token' is not null or undefined


      if (token === null || token === undefined) {
        throw new base_1.RequiredError('token', 'Required parameter token was null or undefined when calling loadMenuTemplate.');
      }

      var localVarPath = "/menu-template/pdf/{storeid}/{id}/{token}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id))).replace("{" + "token" + "}", encodeURIComponent(String(token)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MenuTemplateApi - functional programming interface
 * @export
 */


exports.MenuTemplateApiFp = function (configuration) {
  return {
    /**
     * Return the menu template with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {string} token authorization token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMenuTemplate: function loadMenuTemplate(storeid, id, token, options) {
      var localVarAxiosArgs = exports.MenuTemplateApiAxiosParamCreator(configuration).loadMenuTemplate(storeid, id, token, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * MenuTemplateApi - factory interface
 * @export
 */


exports.MenuTemplateApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Return the menu template with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {string} token authorization token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMenuTemplate: function loadMenuTemplate(storeid, id, token, options) {
      return exports.MenuTemplateApiFp(configuration).loadMenuTemplate(storeid, id, token, options)(axios, basePath);
    }
  };
};
/**
 * MenuTemplateApi - object-oriented interface
 * @export
 * @class MenuTemplateApi
 * @extends {BaseAPI}
 */


var MenuTemplateApi =
/** @class */
function (_super) {
  __extends(MenuTemplateApi, _super);

  function MenuTemplateApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Return the menu template with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {string} token authorization token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenuTemplateApi
   */


  MenuTemplateApi.prototype.loadMenuTemplate = function (storeid, id, token, options) {
    return exports.MenuTemplateApiFp(this.configuration).loadMenuTemplate(storeid, id, token, options)(this.axios, this.basePath);
  };

  return MenuTemplateApi;
}(base_1.BaseAPI);

exports.MenuTemplateApi = MenuTemplateApi;
/**
 * MerchantApi - axios parameter creator
 * @export
 */

exports.MerchantApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get Merchant detail information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMerchantAccount: function loadMerchantAccount(options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/maccount";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update Merchant detail information.
     * @param {Merchant} Merchant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveMerchantAccount: function saveMerchantAccount(Merchant, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'Merchant' is not null or undefined


      if (Merchant === null || Merchant === undefined) {
        throw new base_1.RequiredError('Merchant', 'Required parameter Merchant was null or undefined when calling saveMerchantAccount.');
      }

      var localVarPath = "/maccount";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Merchant !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Merchant !== undefined ? Merchant : {}) : Merchant || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MerchantApi - functional programming interface
 * @export
 */


exports.MerchantApiFp = function (configuration) {
  return {
    /**
     * Get Merchant detail information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMerchantAccount: function loadMerchantAccount(options) {
      var localVarAxiosArgs = exports.MerchantApiAxiosParamCreator(configuration).loadMerchantAccount(options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update Merchant detail information.
     * @param {Merchant} Merchant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveMerchantAccount: function saveMerchantAccount(Merchant, options) {
      var localVarAxiosArgs = exports.MerchantApiAxiosParamCreator(configuration).saveMerchantAccount(Merchant, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * MerchantApi - factory interface
 * @export
 */


exports.MerchantApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Get Merchant detail information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMerchantAccount: function loadMerchantAccount(options) {
      return exports.MerchantApiFp(configuration).loadMerchantAccount(options)(axios, basePath);
    },

    /**
     * Update Merchant detail information.
     * @param {Merchant} Merchant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveMerchantAccount: function saveMerchantAccount(Merchant, options) {
      return exports.MerchantApiFp(configuration).saveMerchantAccount(Merchant, options)(axios, basePath);
    }
  };
};
/**
 * MerchantApi - object-oriented interface
 * @export
 * @class MerchantApi
 * @extends {BaseAPI}
 */


var MerchantApi =
/** @class */
function (_super) {
  __extends(MerchantApi, _super);

  function MerchantApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Get Merchant detail information.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantApi
   */


  MerchantApi.prototype.loadMerchantAccount = function (options) {
    return exports.MerchantApiFp(this.configuration).loadMerchantAccount(options)(this.axios, this.basePath);
  };
  /**
   * Update Merchant detail information.
   * @param {Merchant} Merchant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantApi
   */


  MerchantApi.prototype.saveMerchantAccount = function (Merchant, options) {
    return exports.MerchantApiFp(this.configuration).saveMerchantAccount(Merchant, options)(this.axios, this.basePath);
  };

  return MerchantApi;
}(base_1.BaseAPI);

exports.MerchantApi = MerchantApi;
/**
 * MetaApi - axios parameter creator
 * @export
 */

exports.MetaApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Return info about the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadInfo: function loadInfo(options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/info";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * MetaApi - functional programming interface
 * @export
 */


exports.MetaApiFp = function (configuration) {
  return {
    /**
     * Return info about the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadInfo: function loadInfo(options) {
      var localVarAxiosArgs = exports.MetaApiAxiosParamCreator(configuration).loadInfo(options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * MetaApi - factory interface
 * @export
 */


exports.MetaApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Return info about the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadInfo: function loadInfo(options) {
      return exports.MetaApiFp(configuration).loadInfo(options)(axios, basePath);
    }
  };
};
/**
 * MetaApi - object-oriented interface
 * @export
 * @class MetaApi
 * @extends {BaseAPI}
 */


var MetaApi =
/** @class */
function (_super) {
  __extends(MetaApi, _super);

  function MetaApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Return info about the API
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MetaApi
   */


  MetaApi.prototype.loadInfo = function (options) {
    return exports.MetaApiFp(this.configuration).loadInfo(options)(this.axios, this.basePath);
  };

  return MetaApi;
}(base_1.BaseAPI);

exports.MetaApi = MetaApi;
/**
 * ModifierApi - axios parameter creator
 * @export
 */

exports.ModifierApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a modifier with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteModifier: function deleteModifier(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteModifier.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteModifier.');
      }

      var localVarPath = "/modifier/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Import modifier options by csv file and return an id to track import process.
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importModifierOption: function importModifierOption(storeid, id, file, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling importModifierOption.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling importModifierOption.');
      }

      var localVarPath = "/modifier/{storeid}/{id}/import".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      var localVarFormParams = new FormData(); // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      localVarRequestOptions.data = localVarFormParams;
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the modifiers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listModifiers: function listModifiers(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listModifiers.');
      }

      var localVarPath = "/modifier/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the modifier with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadModifier: function loadModifier(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadModifier.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadModifier.');
      }

      var localVarPath = "/modifier/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create modifier
     * @param {string} storeid The store id to get data from
     * @param {Modifier} Modifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveModifier: function saveModifier(storeid, Modifier, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveModifier.');
      } // verify required parameter 'Modifier' is not null or undefined


      if (Modifier === null || Modifier === undefined) {
        throw new base_1.RequiredError('Modifier', 'Required parameter Modifier was null or undefined when calling saveModifier.');
      }

      var localVarPath = "/modifier/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Modifier !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Modifier !== undefined ? Modifier : {}) : Modifier || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ModifierApi - functional programming interface
 * @export
 */


exports.ModifierApiFp = function (configuration) {
  return {
    /**
     * Delete a modifier with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteModifier: function deleteModifier(storeid, id, options) {
      var localVarAxiosArgs = exports.ModifierApiAxiosParamCreator(configuration).deleteModifier(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Import modifier options by csv file and return an id to track import process.
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importModifierOption: function importModifierOption(storeid, id, file, options) {
      var localVarAxiosArgs = exports.ModifierApiAxiosParamCreator(configuration).importModifierOption(storeid, id, file, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the modifiers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listModifiers: function listModifiers(storeid, options) {
      var localVarAxiosArgs = exports.ModifierApiAxiosParamCreator(configuration).listModifiers(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the modifier with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadModifier: function loadModifier(storeid, id, options) {
      var localVarAxiosArgs = exports.ModifierApiAxiosParamCreator(configuration).loadModifier(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create modifier
     * @param {string} storeid The store id to get data from
     * @param {Modifier} Modifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveModifier: function saveModifier(storeid, Modifier, options) {
      var localVarAxiosArgs = exports.ModifierApiAxiosParamCreator(configuration).saveModifier(storeid, Modifier, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * ModifierApi - factory interface
 * @export
 */


exports.ModifierApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a modifier with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteModifier: function deleteModifier(storeid, id, options) {
      return exports.ModifierApiFp(configuration).deleteModifier(storeid, id, options)(axios, basePath);
    },

    /**
     * Import modifier options by csv file and return an id to track import process.
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {any} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importModifierOption: function importModifierOption(storeid, id, file, options) {
      return exports.ModifierApiFp(configuration).importModifierOption(storeid, id, file, options)(axios, basePath);
    },

    /**
     * Return all the modifiers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listModifiers: function listModifiers(storeid, options) {
      return exports.ModifierApiFp(configuration).listModifiers(storeid, options)(axios, basePath);
    },

    /**
     * Return the modifier with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadModifier: function loadModifier(storeid, id, options) {
      return exports.ModifierApiFp(configuration).loadModifier(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create modifier
     * @param {string} storeid The store id to get data from
     * @param {Modifier} Modifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveModifier: function saveModifier(storeid, Modifier, options) {
      return exports.ModifierApiFp(configuration).saveModifier(storeid, Modifier, options)(axios, basePath);
    }
  };
};
/**
 * ModifierApi - object-oriented interface
 * @export
 * @class ModifierApi
 * @extends {BaseAPI}
 */


var ModifierApi =
/** @class */
function (_super) {
  __extends(ModifierApi, _super);

  function ModifierApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a modifier with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModifierApi
   */


  ModifierApi.prototype.deleteModifier = function (storeid, id, options) {
    return exports.ModifierApiFp(this.configuration).deleteModifier(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Import modifier options by csv file and return an id to track import process.
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {any} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModifierApi
   */


  ModifierApi.prototype.importModifierOption = function (storeid, id, file, options) {
    return exports.ModifierApiFp(this.configuration).importModifierOption(storeid, id, file, options)(this.axios, this.basePath);
  };
  /**
   * Return all the modifiers belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModifierApi
   */


  ModifierApi.prototype.listModifiers = function (storeid, options) {
    return exports.ModifierApiFp(this.configuration).listModifiers(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the modifier with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModifierApi
   */


  ModifierApi.prototype.loadModifier = function (storeid, id, options) {
    return exports.ModifierApiFp(this.configuration).loadModifier(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create modifier
   * @param {string} storeid The store id to get data from
   * @param {Modifier} Modifier
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModifierApi
   */


  ModifierApi.prototype.saveModifier = function (storeid, Modifier, options) {
    return exports.ModifierApiFp(this.configuration).saveModifier(storeid, Modifier, options)(this.axios, this.basePath);
  };

  return ModifierApi;
}(base_1.BaseAPI);

exports.ModifierApi = ModifierApi;
/**
 * OnlineOrderApi - axios parameter creator
 * @export
 */

exports.OnlineOrderApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Return all online order
     * @param {string} storeid The store id to get data from
     * @param {string} [date] filter by date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listOnlineOrder: function listOnlineOrder(storeid, date, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listOnlineOrder.');
      }

      var localVarPath = "/v2/online-order/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] = date;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     *
     * @param {number} [limit] limit size of page
     * @param {number} [page] page number
     * @param {string} [date] filter by date
     * @param {string} [search] search customer, email or phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listOnlineOrderError: function listOnlineOrderError(limit, page, date, search, options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/online-order/error";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] = date;
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * OnlineOrderApi - functional programming interface
 * @export
 */


exports.OnlineOrderApiFp = function (configuration) {
  return {
    /**
     * Return all online order
     * @param {string} storeid The store id to get data from
     * @param {string} [date] filter by date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listOnlineOrder: function listOnlineOrder(storeid, date, options) {
      var localVarAxiosArgs = exports.OnlineOrderApiAxiosParamCreator(configuration).listOnlineOrder(storeid, date, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     *
     * @param {number} [limit] limit size of page
     * @param {number} [page] page number
     * @param {string} [date] filter by date
     * @param {string} [search] search customer, email or phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listOnlineOrderError: function listOnlineOrderError(limit, page, date, search, options) {
      var localVarAxiosArgs = exports.OnlineOrderApiAxiosParamCreator(configuration).listOnlineOrderError(limit, page, date, search, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * OnlineOrderApi - factory interface
 * @export
 */


exports.OnlineOrderApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Return all online order
     * @param {string} storeid The store id to get data from
     * @param {string} [date] filter by date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listOnlineOrder: function listOnlineOrder(storeid, date, options) {
      return exports.OnlineOrderApiFp(configuration).listOnlineOrder(storeid, date, options)(axios, basePath);
    },

    /**
     *
     * @param {number} [limit] limit size of page
     * @param {number} [page] page number
     * @param {string} [date] filter by date
     * @param {string} [search] search customer, email or phone
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listOnlineOrderError: function listOnlineOrderError(limit, page, date, search, options) {
      return exports.OnlineOrderApiFp(configuration).listOnlineOrderError(limit, page, date, search, options)(axios, basePath);
    }
  };
};
/**
 * OnlineOrderApi - object-oriented interface
 * @export
 * @class OnlineOrderApi
 * @extends {BaseAPI}
 */


var OnlineOrderApi =
/** @class */
function (_super) {
  __extends(OnlineOrderApi, _super);

  function OnlineOrderApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Return all online order
   * @param {string} storeid The store id to get data from
   * @param {string} [date] filter by date
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OnlineOrderApi
   */


  OnlineOrderApi.prototype.listOnlineOrder = function (storeid, date, options) {
    return exports.OnlineOrderApiFp(this.configuration).listOnlineOrder(storeid, date, options)(this.axios, this.basePath);
  };
  /**
   *
   * @param {number} [limit] limit size of page
   * @param {number} [page] page number
   * @param {string} [date] filter by date
   * @param {string} [search] search customer, email or phone
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OnlineOrderApi
   */


  OnlineOrderApi.prototype.listOnlineOrderError = function (limit, page, date, search, options) {
    return exports.OnlineOrderApiFp(this.configuration).listOnlineOrderError(limit, page, date, search, options)(this.axios, this.basePath);
  };

  return OnlineOrderApi;
}(base_1.BaseAPI);

exports.OnlineOrderApi = OnlineOrderApi;
/**
 * OrderApi - axios parameter creator
 * @export
 */

exports.OrderApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * load order by ID
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadOrderById: function loadOrderById(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadOrderById.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadOrderById.');
      }

      var localVarPath = "/order/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * OrderApi - functional programming interface
 * @export
 */


exports.OrderApiFp = function (configuration) {
  return {
    /**
     * load order by ID
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadOrderById: function loadOrderById(storeid, id, options) {
      var localVarAxiosArgs = exports.OrderApiAxiosParamCreator(configuration).loadOrderById(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * OrderApi - factory interface
 * @export
 */


exports.OrderApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * load order by ID
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadOrderById: function loadOrderById(storeid, id, options) {
      return exports.OrderApiFp(configuration).loadOrderById(storeid, id, options)(axios, basePath);
    }
  };
};
/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */


var OrderApi =
/** @class */
function (_super) {
  __extends(OrderApi, _super);

  function OrderApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * load order by ID
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderApi
   */


  OrderApi.prototype.loadOrderById = function (storeid, id, options) {
    return exports.OrderApiFp(this.configuration).loadOrderById(storeid, id, options)(this.axios, this.basePath);
  };

  return OrderApi;
}(base_1.BaseAPI);

exports.OrderApi = OrderApi;
/**
 * OrderingApi - axios parameter creator
 * @export
 */

exports.OrderingApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Return true if the order has been handled successfully. Use for submit order by websocket.
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkOrderStatus: function checkOrderStatus(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling checkOrderStatus.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling checkOrderStatus.');
      }

      var localVarPath = "/app/ordering/{storeid}/check-status/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the stores available for online ordering
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPublishedStores: function listPublishedStores(options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/app/ordering/stores";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Load order online detail
     * @param {string} storeid The store id to get data from
     * @param {string} orderId order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadOrder: function loadOrder(storeid, orderId, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadOrder.');
      } // verify required parameter 'orderId' is not null or undefined


      if (orderId === null || orderId === undefined) {
        throw new base_1.RequiredError('orderId', 'Required parameter orderId was null or undefined when calling loadOrder.');
      }

      var localVarPath = "/app/ol-order/{storeid}/{orderId}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "orderId" + "}", encodeURIComponent(String(orderId)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Load order online detail
     * @param {string} orderId order id
     * @param {string} storeId store id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadOrderForAppleWallet: function loadOrderForAppleWallet(orderId, storeId, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'orderId' is not null or undefined


      if (orderId === null || orderId === undefined) {
        throw new base_1.RequiredError('orderId', 'Required parameter orderId was null or undefined when calling loadOrderForAppleWallet.');
      } // verify required parameter 'storeId' is not null or undefined


      if (storeId === null || storeId === undefined) {
        throw new base_1.RequiredError('storeId', 'Required parameter storeId was null or undefined when calling loadOrderForAppleWallet.');
      }

      var localVarPath = "/app/ordering/apple-wallets/stores/{storeId}/orders/{orderId}".replace("{" + "orderId" + "}", encodeURIComponent(String(orderId))).replace("{" + "storeId" + "}", encodeURIComponent(String(storeId)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return a store menu for ordering
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPublishedStore: function loadPublishedStore(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadPublishedStore.');
      }

      var localVarPath = "/app/ordering/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Pay with apple wallet
     * @param {string} orderId order id
     * @param {string} storeId store id
     * @param {InlineObject6} InlineObject6
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payWithAppleWallet: function payWithAppleWallet(orderId, storeId, InlineObject6, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'orderId' is not null or undefined


      if (orderId === null || orderId === undefined) {
        throw new base_1.RequiredError('orderId', 'Required parameter orderId was null or undefined when calling payWithAppleWallet.');
      } // verify required parameter 'storeId' is not null or undefined


      if (storeId === null || storeId === undefined) {
        throw new base_1.RequiredError('storeId', 'Required parameter storeId was null or undefined when calling payWithAppleWallet.');
      } // verify required parameter 'InlineObject6' is not null or undefined


      if (InlineObject6 === null || InlineObject6 === undefined) {
        throw new base_1.RequiredError('InlineObject6', 'Required parameter InlineObject6 was null or undefined when calling payWithAppleWallet.');
      }

      var localVarPath = "/app/ordering/apple-wallets/stores/{storeId}/orders/{orderId}".replace("{" + "orderId" + "}", encodeURIComponent(String(orderId))).replace("{" + "storeId" + "}", encodeURIComponent(String(storeId)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof InlineObject6 !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(InlineObject6 !== undefined ? InlineObject6 : {}) : InlineObject6 || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Submit an order
     * @param {string} storeid The store id to get data from
     * @param {string} X_Request_Recaptcha_Token the captcha token from user verification
     * @param {OnlineOrder} OnlineOrder The Order to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitOrder: function submitOrder(storeid, X_Request_Recaptcha_Token, OnlineOrder, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling submitOrder.');
      } // verify required parameter 'X_Request_Recaptcha_Token' is not null or undefined


      if (X_Request_Recaptcha_Token === null || X_Request_Recaptcha_Token === undefined) {
        throw new base_1.RequiredError('X_Request_Recaptcha_Token', 'Required parameter X_Request_Recaptcha_Token was null or undefined when calling submitOrder.');
      } // verify required parameter 'OnlineOrder' is not null or undefined


      if (OnlineOrder === null || OnlineOrder === undefined) {
        throw new base_1.RequiredError('OnlineOrder', 'Required parameter OnlineOrder was null or undefined when calling submitOrder.');
      }

      var localVarPath = "/app/ordering/{storeid}/order".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (X_Request_Recaptcha_Token !== undefined && X_Request_Recaptcha_Token !== null) {
        localVarHeaderParameter['X-Request-Recaptcha-Token'] = String(X_Request_Recaptcha_Token);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof OnlineOrder !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(OnlineOrder !== undefined ? OnlineOrder : {}) : OnlineOrder || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * OrderingApi - functional programming interface
 * @export
 */


exports.OrderingApiFp = function (configuration) {
  return {
    /**
     * Return true if the order has been handled successfully. Use for submit order by websocket.
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkOrderStatus: function checkOrderStatus(storeid, id, options) {
      var localVarAxiosArgs = exports.OrderingApiAxiosParamCreator(configuration).checkOrderStatus(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the stores available for online ordering
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPublishedStores: function listPublishedStores(options) {
      var localVarAxiosArgs = exports.OrderingApiAxiosParamCreator(configuration).listPublishedStores(options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Load order online detail
     * @param {string} storeid The store id to get data from
     * @param {string} orderId order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadOrder: function loadOrder(storeid, orderId, options) {
      var localVarAxiosArgs = exports.OrderingApiAxiosParamCreator(configuration).loadOrder(storeid, orderId, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Load order online detail
     * @param {string} orderId order id
     * @param {string} storeId store id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadOrderForAppleWallet: function loadOrderForAppleWallet(orderId, storeId, options) {
      var localVarAxiosArgs = exports.OrderingApiAxiosParamCreator(configuration).loadOrderForAppleWallet(orderId, storeId, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return a store menu for ordering
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPublishedStore: function loadPublishedStore(storeid, options) {
      var localVarAxiosArgs = exports.OrderingApiAxiosParamCreator(configuration).loadPublishedStore(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Pay with apple wallet
     * @param {string} orderId order id
     * @param {string} storeId store id
     * @param {InlineObject6} InlineObject6
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payWithAppleWallet: function payWithAppleWallet(orderId, storeId, InlineObject6, options) {
      var localVarAxiosArgs = exports.OrderingApiAxiosParamCreator(configuration).payWithAppleWallet(orderId, storeId, InlineObject6, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Submit an order
     * @param {string} storeid The store id to get data from
     * @param {string} X_Request_Recaptcha_Token the captcha token from user verification
     * @param {OnlineOrder} OnlineOrder The Order to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitOrder: function submitOrder(storeid, X_Request_Recaptcha_Token, OnlineOrder, options) {
      var localVarAxiosArgs = exports.OrderingApiAxiosParamCreator(configuration).submitOrder(storeid, X_Request_Recaptcha_Token, OnlineOrder, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * OrderingApi - factory interface
 * @export
 */


exports.OrderingApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Return true if the order has been handled successfully. Use for submit order by websocket.
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkOrderStatus: function checkOrderStatus(storeid, id, options) {
      return exports.OrderingApiFp(configuration).checkOrderStatus(storeid, id, options)(axios, basePath);
    },

    /**
     * Return all the stores available for online ordering
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPublishedStores: function listPublishedStores(options) {
      return exports.OrderingApiFp(configuration).listPublishedStores(options)(axios, basePath);
    },

    /**
     * Load order online detail
     * @param {string} storeid The store id to get data from
     * @param {string} orderId order id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadOrder: function loadOrder(storeid, orderId, options) {
      return exports.OrderingApiFp(configuration).loadOrder(storeid, orderId, options)(axios, basePath);
    },

    /**
     * Load order online detail
     * @param {string} orderId order id
     * @param {string} storeId store id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadOrderForAppleWallet: function loadOrderForAppleWallet(orderId, storeId, options) {
      return exports.OrderingApiFp(configuration).loadOrderForAppleWallet(orderId, storeId, options)(axios, basePath);
    },

    /**
     * Return a store menu for ordering
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPublishedStore: function loadPublishedStore(storeid, options) {
      return exports.OrderingApiFp(configuration).loadPublishedStore(storeid, options)(axios, basePath);
    },

    /**
     * Pay with apple wallet
     * @param {string} orderId order id
     * @param {string} storeId store id
     * @param {InlineObject6} InlineObject6
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    payWithAppleWallet: function payWithAppleWallet(orderId, storeId, InlineObject6, options) {
      return exports.OrderingApiFp(configuration).payWithAppleWallet(orderId, storeId, InlineObject6, options)(axios, basePath);
    },

    /**
     * Submit an order
     * @param {string} storeid The store id to get data from
     * @param {string} X_Request_Recaptcha_Token the captcha token from user verification
     * @param {OnlineOrder} OnlineOrder The Order to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitOrder: function submitOrder(storeid, X_Request_Recaptcha_Token, OnlineOrder, options) {
      return exports.OrderingApiFp(configuration).submitOrder(storeid, X_Request_Recaptcha_Token, OnlineOrder, options)(axios, basePath);
    }
  };
};
/**
 * OrderingApi - object-oriented interface
 * @export
 * @class OrderingApi
 * @extends {BaseAPI}
 */


var OrderingApi =
/** @class */
function (_super) {
  __extends(OrderingApi, _super);

  function OrderingApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Return true if the order has been handled successfully. Use for submit order by websocket.
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderingApi
   */


  OrderingApi.prototype.checkOrderStatus = function (storeid, id, options) {
    return exports.OrderingApiFp(this.configuration).checkOrderStatus(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the stores available for online ordering
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderingApi
   */


  OrderingApi.prototype.listPublishedStores = function (options) {
    return exports.OrderingApiFp(this.configuration).listPublishedStores(options)(this.axios, this.basePath);
  };
  /**
   * Load order online detail
   * @param {string} storeid The store id to get data from
   * @param {string} orderId order id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderingApi
   */


  OrderingApi.prototype.loadOrder = function (storeid, orderId, options) {
    return exports.OrderingApiFp(this.configuration).loadOrder(storeid, orderId, options)(this.axios, this.basePath);
  };
  /**
   * Load order online detail
   * @param {string} orderId order id
   * @param {string} storeId store id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderingApi
   */


  OrderingApi.prototype.loadOrderForAppleWallet = function (orderId, storeId, options) {
    return exports.OrderingApiFp(this.configuration).loadOrderForAppleWallet(orderId, storeId, options)(this.axios, this.basePath);
  };
  /**
   * Return a store menu for ordering
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderingApi
   */


  OrderingApi.prototype.loadPublishedStore = function (storeid, options) {
    return exports.OrderingApiFp(this.configuration).loadPublishedStore(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Pay with apple wallet
   * @param {string} orderId order id
   * @param {string} storeId store id
   * @param {InlineObject6} InlineObject6
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderingApi
   */


  OrderingApi.prototype.payWithAppleWallet = function (orderId, storeId, InlineObject6, options) {
    return exports.OrderingApiFp(this.configuration).payWithAppleWallet(orderId, storeId, InlineObject6, options)(this.axios, this.basePath);
  };
  /**
   * Submit an order
   * @param {string} storeid The store id to get data from
   * @param {string} X_Request_Recaptcha_Token the captcha token from user verification
   * @param {OnlineOrder} OnlineOrder The Order to be created
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrderingApi
   */


  OrderingApi.prototype.submitOrder = function (storeid, X_Request_Recaptcha_Token, OnlineOrder, options) {
    return exports.OrderingApiFp(this.configuration).submitOrder(storeid, X_Request_Recaptcha_Token, OnlineOrder, options)(this.axios, this.basePath);
  };

  return OrderingApi;
}(base_1.BaseAPI);

exports.OrderingApi = OrderingApi;
/**
 * PasswordApi - axios parameter creator
 * @export
 */

exports.PasswordApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get a password reset request, this should be called when user click on forgot password link from email
     * @param {string} resetPasswordId Reset password request id, this normally is taken from the reset password email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResetPasswordRequest: function getResetPasswordRequest(resetPasswordId, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'resetPasswordId' is not null or undefined


      if (resetPasswordId === null || resetPasswordId === undefined) {
        throw new base_1.RequiredError('resetPasswordId', 'Required parameter resetPasswordId was null or undefined when calling getResetPasswordRequest.');
      }

      var localVarPath = "/password/id/{resetPasswordId}".replace("{" + "resetPasswordId" + "}", encodeURIComponent(String(resetPasswordId)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Submit password reset for a given email.
     * @param {string} email User email for reseting password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestResetPassword: function requestResetPassword(email, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'email' is not null or undefined


      if (email === null || email === undefined) {
        throw new base_1.RequiredError('email', 'Required parameter email was null or undefined when calling requestResetPassword.');
      }

      var localVarPath = "/password/{email}".replace("{" + "email" + "}", encodeURIComponent(String(email)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Submit a new password for the corresponding request.
     * @param {string} resetPasswordId Reset password request id, this normally is taken from the reset password email
     * @param {ChangePasswordRequest} ChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setPassword: function setPassword(resetPasswordId, ChangePasswordRequest, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'resetPasswordId' is not null or undefined


      if (resetPasswordId === null || resetPasswordId === undefined) {
        throw new base_1.RequiredError('resetPasswordId', 'Required parameter resetPasswordId was null or undefined when calling setPassword.');
      } // verify required parameter 'ChangePasswordRequest' is not null or undefined


      if (ChangePasswordRequest === null || ChangePasswordRequest === undefined) {
        throw new base_1.RequiredError('ChangePasswordRequest', 'Required parameter ChangePasswordRequest was null or undefined when calling setPassword.');
      }

      var localVarPath = "/password/id/{resetPasswordId}".replace("{" + "resetPasswordId" + "}", encodeURIComponent(String(resetPasswordId)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof ChangePasswordRequest !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(ChangePasswordRequest !== undefined ? ChangePasswordRequest : {}) : ChangePasswordRequest || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PasswordApi - functional programming interface
 * @export
 */


exports.PasswordApiFp = function (configuration) {
  return {
    /**
     * Get a password reset request, this should be called when user click on forgot password link from email
     * @param {string} resetPasswordId Reset password request id, this normally is taken from the reset password email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResetPasswordRequest: function getResetPasswordRequest(resetPasswordId, options) {
      var localVarAxiosArgs = exports.PasswordApiAxiosParamCreator(configuration).getResetPasswordRequest(resetPasswordId, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Submit password reset for a given email.
     * @param {string} email User email for reseting password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestResetPassword: function requestResetPassword(email, options) {
      var localVarAxiosArgs = exports.PasswordApiAxiosParamCreator(configuration).requestResetPassword(email, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Submit a new password for the corresponding request.
     * @param {string} resetPasswordId Reset password request id, this normally is taken from the reset password email
     * @param {ChangePasswordRequest} ChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setPassword: function setPassword(resetPasswordId, ChangePasswordRequest, options) {
      var localVarAxiosArgs = exports.PasswordApiAxiosParamCreator(configuration).setPassword(resetPasswordId, ChangePasswordRequest, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * PasswordApi - factory interface
 * @export
 */


exports.PasswordApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Get a password reset request, this should be called when user click on forgot password link from email
     * @param {string} resetPasswordId Reset password request id, this normally is taken from the reset password email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResetPasswordRequest: function getResetPasswordRequest(resetPasswordId, options) {
      return exports.PasswordApiFp(configuration).getResetPasswordRequest(resetPasswordId, options)(axios, basePath);
    },

    /**
     * Submit password reset for a given email.
     * @param {string} email User email for reseting password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestResetPassword: function requestResetPassword(email, options) {
      return exports.PasswordApiFp(configuration).requestResetPassword(email, options)(axios, basePath);
    },

    /**
     * Submit a new password for the corresponding request.
     * @param {string} resetPasswordId Reset password request id, this normally is taken from the reset password email
     * @param {ChangePasswordRequest} ChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setPassword: function setPassword(resetPasswordId, ChangePasswordRequest, options) {
      return exports.PasswordApiFp(configuration).setPassword(resetPasswordId, ChangePasswordRequest, options)(axios, basePath);
    }
  };
};
/**
 * PasswordApi - object-oriented interface
 * @export
 * @class PasswordApi
 * @extends {BaseAPI}
 */


var PasswordApi =
/** @class */
function (_super) {
  __extends(PasswordApi, _super);

  function PasswordApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Get a password reset request, this should be called when user click on forgot password link from email
   * @param {string} resetPasswordId Reset password request id, this normally is taken from the reset password email
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordApi
   */


  PasswordApi.prototype.getResetPasswordRequest = function (resetPasswordId, options) {
    return exports.PasswordApiFp(this.configuration).getResetPasswordRequest(resetPasswordId, options)(this.axios, this.basePath);
  };
  /**
   * Submit password reset for a given email.
   * @param {string} email User email for reseting password
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordApi
   */


  PasswordApi.prototype.requestResetPassword = function (email, options) {
    return exports.PasswordApiFp(this.configuration).requestResetPassword(email, options)(this.axios, this.basePath);
  };
  /**
   * Submit a new password for the corresponding request.
   * @param {string} resetPasswordId Reset password request id, this normally is taken from the reset password email
   * @param {ChangePasswordRequest} ChangePasswordRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordApi
   */


  PasswordApi.prototype.setPassword = function (resetPasswordId, ChangePasswordRequest, options) {
    return exports.PasswordApiFp(this.configuration).setPassword(resetPasswordId, ChangePasswordRequest, options)(this.axios, this.basePath);
  };

  return PasswordApi;
}(base_1.BaseAPI);

exports.PasswordApi = PasswordApi;
/**
 * PrinterApi - axios parameter creator
 * @export
 */

exports.PrinterApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a printer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePrinter: function deletePrinter(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deletePrinter.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deletePrinter.');
      }

      var localVarPath = "/printer/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the printers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPrinters: function listPrinters(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listPrinters.');
      }

      var localVarPath = "/printer/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the printer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPrinter: function loadPrinter(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadPrinter.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadPrinter.');
      }

      var localVarPath = "/printer/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create printer
     * @param {string} storeid The store id to get data from
     * @param {Printer} Printer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savePrinter: function savePrinter(storeid, Printer, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling savePrinter.');
      } // verify required parameter 'Printer' is not null or undefined


      if (Printer === null || Printer === undefined) {
        throw new base_1.RequiredError('Printer', 'Required parameter Printer was null or undefined when calling savePrinter.');
      }

      var localVarPath = "/printer/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Printer !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Printer !== undefined ? Printer : {}) : Printer || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PrinterApi - functional programming interface
 * @export
 */


exports.PrinterApiFp = function (configuration) {
  return {
    /**
     * Delete a printer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePrinter: function deletePrinter(storeid, id, options) {
      var localVarAxiosArgs = exports.PrinterApiAxiosParamCreator(configuration).deletePrinter(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the printers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPrinters: function listPrinters(storeid, options) {
      var localVarAxiosArgs = exports.PrinterApiAxiosParamCreator(configuration).listPrinters(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the printer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPrinter: function loadPrinter(storeid, id, options) {
      var localVarAxiosArgs = exports.PrinterApiAxiosParamCreator(configuration).loadPrinter(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create printer
     * @param {string} storeid The store id to get data from
     * @param {Printer} Printer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savePrinter: function savePrinter(storeid, Printer, options) {
      var localVarAxiosArgs = exports.PrinterApiAxiosParamCreator(configuration).savePrinter(storeid, Printer, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * PrinterApi - factory interface
 * @export
 */


exports.PrinterApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a printer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePrinter: function deletePrinter(storeid, id, options) {
      return exports.PrinterApiFp(configuration).deletePrinter(storeid, id, options)(axios, basePath);
    },

    /**
     * Return all the printers belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPrinters: function listPrinters(storeid, options) {
      return exports.PrinterApiFp(configuration).listPrinters(storeid, options)(axios, basePath);
    },

    /**
     * Return the printer with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPrinter: function loadPrinter(storeid, id, options) {
      return exports.PrinterApiFp(configuration).loadPrinter(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create printer
     * @param {string} storeid The store id to get data from
     * @param {Printer} Printer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savePrinter: function savePrinter(storeid, Printer, options) {
      return exports.PrinterApiFp(configuration).savePrinter(storeid, Printer, options)(axios, basePath);
    }
  };
};
/**
 * PrinterApi - object-oriented interface
 * @export
 * @class PrinterApi
 * @extends {BaseAPI}
 */


var PrinterApi =
/** @class */
function (_super) {
  __extends(PrinterApi, _super);

  function PrinterApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a printer with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrinterApi
   */


  PrinterApi.prototype.deletePrinter = function (storeid, id, options) {
    return exports.PrinterApiFp(this.configuration).deletePrinter(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the printers belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrinterApi
   */


  PrinterApi.prototype.listPrinters = function (storeid, options) {
    return exports.PrinterApiFp(this.configuration).listPrinters(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the printer with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrinterApi
   */


  PrinterApi.prototype.loadPrinter = function (storeid, id, options) {
    return exports.PrinterApiFp(this.configuration).loadPrinter(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create printer
   * @param {string} storeid The store id to get data from
   * @param {Printer} Printer
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PrinterApi
   */


  PrinterApi.prototype.savePrinter = function (storeid, Printer, options) {
    return exports.PrinterApiFp(this.configuration).savePrinter(storeid, Printer, options)(this.axios, this.basePath);
  };

  return PrinterApi;
}(base_1.BaseAPI);

exports.PrinterApi = PrinterApi;
/**
 * PromoCodeApi - axios parameter creator
 * @export
 */

exports.PromoCodeApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a promo code with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePromoCode: function deletePromoCode(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deletePromoCode.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deletePromoCode.');
      }

      var localVarPath = "/promocode/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the promo code with given id
     * @param {string} storeid The store id to get data from
     * @param {string} name The promo code name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWebOrderPromoCodeByName: function getWebOrderPromoCodeByName(storeid, name, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getWebOrderPromoCodeByName.');
      } // verify required parameter 'name' is not null or undefined


      if (name === null || name === undefined) {
        throw new base_1.RequiredError('name', 'Required parameter name was null or undefined when calling getWebOrderPromoCodeByName.');
      }

      var localVarPath = "/promocode/{storeid}/name/{name}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "name" + "}", encodeURIComponent(String(name)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the promo codes belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPromoCodes: function listPromoCodes(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listPromoCodes.');
      }

      var localVarPath = "/promocode/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the promo code with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPromoCode: function loadPromoCode(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadPromoCode.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadPromoCode.');
      }

      var localVarPath = "/promocode/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create promo code
     * @param {string} storeid The store id to get data from
     * @param {PromoCode} PromoCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savePromoCode: function savePromoCode(storeid, PromoCode, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling savePromoCode.');
      } // verify required parameter 'PromoCode' is not null or undefined


      if (PromoCode === null || PromoCode === undefined) {
        throw new base_1.RequiredError('PromoCode', 'Required parameter PromoCode was null or undefined when calling savePromoCode.');
      }

      var localVarPath = "/promocode/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof PromoCode !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(PromoCode !== undefined ? PromoCode : {}) : PromoCode || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PromoCodeApi - functional programming interface
 * @export
 */


exports.PromoCodeApiFp = function (configuration) {
  return {
    /**
     * Delete a promo code with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePromoCode: function deletePromoCode(storeid, id, options) {
      var localVarAxiosArgs = exports.PromoCodeApiAxiosParamCreator(configuration).deletePromoCode(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the promo code with given id
     * @param {string} storeid The store id to get data from
     * @param {string} name The promo code name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWebOrderPromoCodeByName: function getWebOrderPromoCodeByName(storeid, name, options) {
      var localVarAxiosArgs = exports.PromoCodeApiAxiosParamCreator(configuration).getWebOrderPromoCodeByName(storeid, name, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the promo codes belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPromoCodes: function listPromoCodes(storeid, options) {
      var localVarAxiosArgs = exports.PromoCodeApiAxiosParamCreator(configuration).listPromoCodes(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the promo code with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPromoCode: function loadPromoCode(storeid, id, options) {
      var localVarAxiosArgs = exports.PromoCodeApiAxiosParamCreator(configuration).loadPromoCode(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create promo code
     * @param {string} storeid The store id to get data from
     * @param {PromoCode} PromoCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savePromoCode: function savePromoCode(storeid, PromoCode, options) {
      var localVarAxiosArgs = exports.PromoCodeApiAxiosParamCreator(configuration).savePromoCode(storeid, PromoCode, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * PromoCodeApi - factory interface
 * @export
 */


exports.PromoCodeApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a promo code with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePromoCode: function deletePromoCode(storeid, id, options) {
      return exports.PromoCodeApiFp(configuration).deletePromoCode(storeid, id, options)(axios, basePath);
    },

    /**
     * Return the promo code with given id
     * @param {string} storeid The store id to get data from
     * @param {string} name The promo code name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWebOrderPromoCodeByName: function getWebOrderPromoCodeByName(storeid, name, options) {
      return exports.PromoCodeApiFp(configuration).getWebOrderPromoCodeByName(storeid, name, options)(axios, basePath);
    },

    /**
     * Return all the promo codes belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPromoCodes: function listPromoCodes(storeid, options) {
      return exports.PromoCodeApiFp(configuration).listPromoCodes(storeid, options)(axios, basePath);
    },

    /**
     * Return the promo code with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPromoCode: function loadPromoCode(storeid, id, options) {
      return exports.PromoCodeApiFp(configuration).loadPromoCode(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create promo code
     * @param {string} storeid The store id to get data from
     * @param {PromoCode} PromoCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savePromoCode: function savePromoCode(storeid, PromoCode, options) {
      return exports.PromoCodeApiFp(configuration).savePromoCode(storeid, PromoCode, options)(axios, basePath);
    }
  };
};
/**
 * PromoCodeApi - object-oriented interface
 * @export
 * @class PromoCodeApi
 * @extends {BaseAPI}
 */


var PromoCodeApi =
/** @class */
function (_super) {
  __extends(PromoCodeApi, _super);

  function PromoCodeApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a promo code with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoCodeApi
   */


  PromoCodeApi.prototype.deletePromoCode = function (storeid, id, options) {
    return exports.PromoCodeApiFp(this.configuration).deletePromoCode(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return the promo code with given id
   * @param {string} storeid The store id to get data from
   * @param {string} name The promo code name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoCodeApi
   */


  PromoCodeApi.prototype.getWebOrderPromoCodeByName = function (storeid, name, options) {
    return exports.PromoCodeApiFp(this.configuration).getWebOrderPromoCodeByName(storeid, name, options)(this.axios, this.basePath);
  };
  /**
   * Return all the promo codes belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoCodeApi
   */


  PromoCodeApi.prototype.listPromoCodes = function (storeid, options) {
    return exports.PromoCodeApiFp(this.configuration).listPromoCodes(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the promo code with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoCodeApi
   */


  PromoCodeApi.prototype.loadPromoCode = function (storeid, id, options) {
    return exports.PromoCodeApiFp(this.configuration).loadPromoCode(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create promo code
   * @param {string} storeid The store id to get data from
   * @param {PromoCode} PromoCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromoCodeApi
   */


  PromoCodeApi.prototype.savePromoCode = function (storeid, PromoCode, options) {
    return exports.PromoCodeApiFp(this.configuration).savePromoCode(storeid, PromoCode, options)(this.axios, this.basePath);
  };

  return PromoCodeApi;
}(base_1.BaseAPI);

exports.PromoCodeApi = PromoCodeApi;
/**
 * PromotionApi - axios parameter creator
 * @export
 */

exports.PromotionApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete an promotion with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePromotion: function deletePromotion(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deletePromotion.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deletePromotion.');
      }

      var localVarPath = "/promotion/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the promotions belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPromotions: function listPromotions(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listPromotions.');
      }

      var localVarPath = "/promotion/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the promotion with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPromotion: function loadPromotion(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadPromotion.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadPromotion.');
      }

      var localVarPath = "/promotion/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create promotion
     * @param {string} storeid The store id to get data from
     * @param {Promotion} Promotion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savePromotion: function savePromotion(storeid, Promotion, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling savePromotion.');
      } // verify required parameter 'Promotion' is not null or undefined


      if (Promotion === null || Promotion === undefined) {
        throw new base_1.RequiredError('Promotion', 'Required parameter Promotion was null or undefined when calling savePromotion.');
      }

      var localVarPath = "/promotion/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Promotion !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Promotion !== undefined ? Promotion : {}) : Promotion || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * PromotionApi - functional programming interface
 * @export
 */


exports.PromotionApiFp = function (configuration) {
  return {
    /**
     * Delete an promotion with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePromotion: function deletePromotion(storeid, id, options) {
      var localVarAxiosArgs = exports.PromotionApiAxiosParamCreator(configuration).deletePromotion(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the promotions belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPromotions: function listPromotions(storeid, options) {
      var localVarAxiosArgs = exports.PromotionApiAxiosParamCreator(configuration).listPromotions(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the promotion with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPromotion: function loadPromotion(storeid, id, options) {
      var localVarAxiosArgs = exports.PromotionApiAxiosParamCreator(configuration).loadPromotion(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create promotion
     * @param {string} storeid The store id to get data from
     * @param {Promotion} Promotion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savePromotion: function savePromotion(storeid, Promotion, options) {
      var localVarAxiosArgs = exports.PromotionApiAxiosParamCreator(configuration).savePromotion(storeid, Promotion, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * PromotionApi - factory interface
 * @export
 */


exports.PromotionApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete an promotion with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePromotion: function deletePromotion(storeid, id, options) {
      return exports.PromotionApiFp(configuration).deletePromotion(storeid, id, options)(axios, basePath);
    },

    /**
     * Return all the promotions belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPromotions: function listPromotions(storeid, options) {
      return exports.PromotionApiFp(configuration).listPromotions(storeid, options)(axios, basePath);
    },

    /**
     * Return the promotion with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadPromotion: function loadPromotion(storeid, id, options) {
      return exports.PromotionApiFp(configuration).loadPromotion(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create promotion
     * @param {string} storeid The store id to get data from
     * @param {Promotion} Promotion
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savePromotion: function savePromotion(storeid, Promotion, options) {
      return exports.PromotionApiFp(configuration).savePromotion(storeid, Promotion, options)(axios, basePath);
    }
  };
};
/**
 * PromotionApi - object-oriented interface
 * @export
 * @class PromotionApi
 * @extends {BaseAPI}
 */


var PromotionApi =
/** @class */
function (_super) {
  __extends(PromotionApi, _super);

  function PromotionApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete an promotion with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromotionApi
   */


  PromotionApi.prototype.deletePromotion = function (storeid, id, options) {
    return exports.PromotionApiFp(this.configuration).deletePromotion(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the promotions belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromotionApi
   */


  PromotionApi.prototype.listPromotions = function (storeid, options) {
    return exports.PromotionApiFp(this.configuration).listPromotions(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the promotion with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromotionApi
   */


  PromotionApi.prototype.loadPromotion = function (storeid, id, options) {
    return exports.PromotionApiFp(this.configuration).loadPromotion(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create promotion
   * @param {string} storeid The store id to get data from
   * @param {Promotion} Promotion
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PromotionApi
   */


  PromotionApi.prototype.savePromotion = function (storeid, Promotion, options) {
    return exports.PromotionApiFp(this.configuration).savePromotion(storeid, Promotion, options)(this.axios, this.basePath);
  };

  return PromotionApi;
}(base_1.BaseAPI);

exports.PromotionApi = PromotionApi;
/**
 * RefundCodeApi - axios parameter creator
 * @export
 */

exports.RefundCodeApiAxiosParamCreator = function (configuration) {
  return {
    /**
     *
     * @param {string} storeid The store id to get data from
     * @param {RefundCodeForm} RefundCodeForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerRefundCode: function triggerRefundCode(storeid, RefundCodeForm, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling triggerRefundCode.');
      } // verify required parameter 'RefundCodeForm' is not null or undefined


      if (RefundCodeForm === null || RefundCodeForm === undefined) {
        throw new base_1.RequiredError('RefundCodeForm', 'Required parameter RefundCodeForm was null or undefined when calling triggerRefundCode.');
      }

      var localVarPath = "/{storeid}/refund-code".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof RefundCodeForm !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(RefundCodeForm !== undefined ? RefundCodeForm : {}) : RefundCodeForm || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * RefundCodeApi - functional programming interface
 * @export
 */


exports.RefundCodeApiFp = function (configuration) {
  return {
    /**
     *
     * @param {string} storeid The store id to get data from
     * @param {RefundCodeForm} RefundCodeForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerRefundCode: function triggerRefundCode(storeid, RefundCodeForm, options) {
      var localVarAxiosArgs = exports.RefundCodeApiAxiosParamCreator(configuration).triggerRefundCode(storeid, RefundCodeForm, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * RefundCodeApi - factory interface
 * @export
 */


exports.RefundCodeApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     *
     * @param {string} storeid The store id to get data from
     * @param {RefundCodeForm} RefundCodeForm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    triggerRefundCode: function triggerRefundCode(storeid, RefundCodeForm, options) {
      return exports.RefundCodeApiFp(configuration).triggerRefundCode(storeid, RefundCodeForm, options)(axios, basePath);
    }
  };
};
/**
 * RefundCodeApi - object-oriented interface
 * @export
 * @class RefundCodeApi
 * @extends {BaseAPI}
 */


var RefundCodeApi =
/** @class */
function (_super) {
  __extends(RefundCodeApi, _super);

  function RefundCodeApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   *
   * @param {string} storeid The store id to get data from
   * @param {RefundCodeForm} RefundCodeForm
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RefundCodeApi
   */


  RefundCodeApi.prototype.triggerRefundCode = function (storeid, RefundCodeForm, options) {
    return exports.RefundCodeApiFp(this.configuration).triggerRefundCode(storeid, RefundCodeForm, options)(this.axios, this.basePath);
  };

  return RefundCodeApi;
}(base_1.BaseAPI);

exports.RefundCodeApi = RefundCodeApi;
/**
 * ReportApi - axios parameter creator
 * @export
 */

exports.ReportApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {TransactionDetail} TransactionDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editTransactionReport: function editTransactionReport(storeid, id, TransactionDetail, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling editTransactionReport.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling editTransactionReport.');
      } // verify required parameter 'TransactionDetail' is not null or undefined


      if (TransactionDetail === null || TransactionDetail === undefined) {
        throw new base_1.RequiredError('TransactionDetail', 'Required parameter TransactionDetail was null or undefined when calling editTransactionReport.');
      }

      var localVarPath = "/order/transaction/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof TransactionDetail !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(TransactionDetail !== undefined ? TransactionDetail : {}) : TransactionDetail || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the daily report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the daily report
     * @param {string} [to_date] The date range of the daily report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDailyReport: function getDailyReport(storeid, from_date, to_date, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getDailyReport.');
      }

      var localVarPath = "/report/{storeid}/daily".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * return daily report pdf
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the daily report
     * @param {string} [to_date] The date range of the daily report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDailyReportPdf: function getDailyReportPdf(storeid, token, from_date, to_date, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getDailyReportPdf.');
      } // verify required parameter 'token' is not null or undefined


      if (token === null || token === undefined) {
        throw new base_1.RequiredError('token', 'Required parameter token was null or undefined when calling getDailyReportPdf.');
      }

      var localVarPath = "/report-pdf/{storeid}/daily/{token}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "token" + "}", encodeURIComponent(String(token)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the detail report
     * @param {string} [to_date] The date range of the detail report
     * @param {string} [shift] The ID of specific shift for the detail report
     * @param {string} [area] The ID of specific area for the detail report
     * @param {string} [employee] The ID of specific employee for the detail report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetailReport: function getDetailReport(storeid, from_date, to_date, shift, area, employee, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getDetailReport.');
      }

      var localVarPath = "/report/{storeid}/payment-type".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      if (shift !== undefined) {
        localVarQueryParameter['shift'] = shift;
      }

      if (area !== undefined) {
        localVarQueryParameter['area'] = area;
      }

      if (employee !== undefined) {
        localVarQueryParameter['employee'] = employee;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the detail report
     * @param {string} [to_date] The date range of the detail report
     * @param {string} [shift] The ID of specific shift for the detail report
     * @param {string} [area] The ID of specific area for the detail report
     * @param {string} [employee] The ID of specific employee for the detail report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetailReportCsv: function getDetailReportCsv(storeid, token, from_date, to_date, shift, area, employee, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getDetailReportCsv.');
      } // verify required parameter 'token' is not null or undefined


      if (token === null || token === undefined) {
        throw new base_1.RequiredError('token', 'Required parameter token was null or undefined when calling getDetailReportCsv.');
      }

      var localVarPath = "/report-csv/{storeid}/payment-type/{token}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "token" + "}", encodeURIComponent(String(token)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      if (shift !== undefined) {
        localVarQueryParameter['shift'] = shift;
      }

      if (area !== undefined) {
        localVarQueryParameter['area'] = area;
      }

      if (employee !== undefined) {
        localVarQueryParameter['employee'] = employee;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the detail report
     * @param {string} [to_date] The date range of the detail report
     * @param {string} [shift] The ID of specific shift for the detail report
     * @param {string} [area] The ID of specific area for the detail report
     * @param {string} [employee] The ID of specific employee for the detail report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetailReportPdf: function getDetailReportPdf(storeid, token, from_date, to_date, shift, area, employee, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getDetailReportPdf.');
      } // verify required parameter 'token' is not null or undefined


      if (token === null || token === undefined) {
        throw new base_1.RequiredError('token', 'Required parameter token was null or undefined when calling getDetailReportPdf.');
      }

      var localVarPath = "/report-pdf/{storeid}/payment-type/{token}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "token" + "}", encodeURIComponent(String(token)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      if (shift !== undefined) {
        localVarQueryParameter['shift'] = shift;
      }

      if (area !== undefined) {
        localVarQueryParameter['area'] = area;
      }

      if (employee !== undefined) {
        localVarQueryParameter['employee'] = employee;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the inventory report
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryReport: function getInventoryReport(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getInventoryReport.');
      }

      var localVarPath = "/report/{storeid}/inventory".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the server report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the server report
     * @param {string} [to_date] The date range of the server report
     * @param {string} [shift] The ID of specific shift for the server report
     * @param {string} [employee] The ID of specific employee for the server report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServerReport: function getServerReport(storeid, from_date, to_date, shift, employee, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getServerReport.');
      }

      var localVarPath = "/report/{storeid}/server".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      if (shift !== undefined) {
        localVarQueryParameter['shift'] = shift;
      }

      if (employee !== undefined) {
        localVarQueryParameter['employee'] = employee;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * return server report pdf
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the daily report
     * @param {string} [to_date] The date range of the daily report
     * @param {string} [shift] The ID of specific shift for the server report
     * @param {string} [employee] The ID of specific employee for the server report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServerReportPdf: function getServerReportPdf(storeid, token, from_date, to_date, shift, employee, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getServerReportPdf.');
      } // verify required parameter 'token' is not null or undefined


      if (token === null || token === undefined) {
        throw new base_1.RequiredError('token', 'Required parameter token was null or undefined when calling getServerReportPdf.');
      }

      var localVarPath = "/report-pdf/{storeid}/server/{token}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "token" + "}", encodeURIComponent(String(token)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      if (shift !== undefined) {
        localVarQueryParameter['shift'] = shift;
      }

      if (employee !== undefined) {
        localVarQueryParameter['employee'] = employee;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the tip report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the tip report
     * @param {string} [to_date] The date range of the tip report
     * @param {string} [employee] The ID of specific employee for the tip report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTipReport: function getTipReport(storeid, from_date, to_date, employee, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getTipReport.');
      }

      var localVarPath = "/report/{storeid}/tip".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      if (employee !== undefined) {
        localVarQueryParameter['employee'] = employee;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the total report
     * @param {string} storeid The store id to get data from
     * @param {string} [totalType] The ID of specific total type for the total report
     * @param {string} [from_date] The date range of the total report
     * @param {string} [to_date] The date range of the total report
     * @param {string} [shift] The ID of specific shift for the total report
     * @param {string} [category] The ID of specific category for the total report
     * @param {boolean} [showItem] The ID of specific category for the total report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTotalReport: function getTotalReport(storeid, totalType, from_date, to_date, shift, category, showItem, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getTotalReport.');
      }

      var localVarPath = "/report/{storeid}/total".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (totalType !== undefined) {
        localVarQueryParameter['totalType'] = totalType;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      if (shift !== undefined) {
        localVarQueryParameter['shift'] = shift;
      }

      if (category !== undefined) {
        localVarQueryParameter['category'] = category;
      }

      if (showItem !== undefined) {
        localVarQueryParameter['showItem'] = showItem;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the total report
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [totalType] The ID of specific total type for the total report
     * @param {string} [from_date] The date range of the total report
     * @param {string} [to_date] The date range of the total report
     * @param {string} [shift] The ID of specific shift for the total report
     * @param {string} [category] The ID of specific category for the total report
     * @param {boolean} [showItem] The ID of specific category for the total report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTotalReportPdf: function getTotalReportPdf(storeid, token, totalType, from_date, to_date, shift, category, showItem, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getTotalReportPdf.');
      } // verify required parameter 'token' is not null or undefined


      if (token === null || token === undefined) {
        throw new base_1.RequiredError('token', 'Required parameter token was null or undefined when calling getTotalReportPdf.');
      }

      var localVarPath = "/report-pdf/{storeid}/total/{token}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "token" + "}", encodeURIComponent(String(token)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (totalType !== undefined) {
        localVarQueryParameter['totalType'] = totalType;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      if (shift !== undefined) {
        localVarQueryParameter['shift'] = shift;
      }

      if (category !== undefined) {
        localVarQueryParameter['category'] = category;
      }

      if (showItem !== undefined) {
        localVarQueryParameter['showItem'] = showItem;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionDetailReport: function getTransactionDetailReport(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getTransactionDetailReport.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling getTransactionDetailReport.');
      }

      var localVarPath = "/order/transaction/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ReportApi - functional programming interface
 * @export
 */


exports.ReportApiFp = function (configuration) {
  return {
    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {TransactionDetail} TransactionDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editTransactionReport: function editTransactionReport(storeid, id, TransactionDetail, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).editTransactionReport(storeid, id, TransactionDetail, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the daily report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the daily report
     * @param {string} [to_date] The date range of the daily report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDailyReport: function getDailyReport(storeid, from_date, to_date, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getDailyReport(storeid, from_date, to_date, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * return daily report pdf
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the daily report
     * @param {string} [to_date] The date range of the daily report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDailyReportPdf: function getDailyReportPdf(storeid, token, from_date, to_date, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getDailyReportPdf(storeid, token, from_date, to_date, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the detail report
     * @param {string} [to_date] The date range of the detail report
     * @param {string} [shift] The ID of specific shift for the detail report
     * @param {string} [area] The ID of specific area for the detail report
     * @param {string} [employee] The ID of specific employee for the detail report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetailReport: function getDetailReport(storeid, from_date, to_date, shift, area, employee, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getDetailReport(storeid, from_date, to_date, shift, area, employee, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the detail report
     * @param {string} [to_date] The date range of the detail report
     * @param {string} [shift] The ID of specific shift for the detail report
     * @param {string} [area] The ID of specific area for the detail report
     * @param {string} [employee] The ID of specific employee for the detail report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetailReportCsv: function getDetailReportCsv(storeid, token, from_date, to_date, shift, area, employee, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getDetailReportCsv(storeid, token, from_date, to_date, shift, area, employee, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the detail report
     * @param {string} [to_date] The date range of the detail report
     * @param {string} [shift] The ID of specific shift for the detail report
     * @param {string} [area] The ID of specific area for the detail report
     * @param {string} [employee] The ID of specific employee for the detail report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetailReportPdf: function getDetailReportPdf(storeid, token, from_date, to_date, shift, area, employee, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getDetailReportPdf(storeid, token, from_date, to_date, shift, area, employee, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the inventory report
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryReport: function getInventoryReport(storeid, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getInventoryReport(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the server report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the server report
     * @param {string} [to_date] The date range of the server report
     * @param {string} [shift] The ID of specific shift for the server report
     * @param {string} [employee] The ID of specific employee for the server report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServerReport: function getServerReport(storeid, from_date, to_date, shift, employee, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getServerReport(storeid, from_date, to_date, shift, employee, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * return server report pdf
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the daily report
     * @param {string} [to_date] The date range of the daily report
     * @param {string} [shift] The ID of specific shift for the server report
     * @param {string} [employee] The ID of specific employee for the server report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServerReportPdf: function getServerReportPdf(storeid, token, from_date, to_date, shift, employee, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getServerReportPdf(storeid, token, from_date, to_date, shift, employee, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the tip report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the tip report
     * @param {string} [to_date] The date range of the tip report
     * @param {string} [employee] The ID of specific employee for the tip report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTipReport: function getTipReport(storeid, from_date, to_date, employee, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getTipReport(storeid, from_date, to_date, employee, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the total report
     * @param {string} storeid The store id to get data from
     * @param {string} [totalType] The ID of specific total type for the total report
     * @param {string} [from_date] The date range of the total report
     * @param {string} [to_date] The date range of the total report
     * @param {string} [shift] The ID of specific shift for the total report
     * @param {string} [category] The ID of specific category for the total report
     * @param {boolean} [showItem] The ID of specific category for the total report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTotalReport: function getTotalReport(storeid, totalType, from_date, to_date, shift, category, showItem, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getTotalReport(storeid, totalType, from_date, to_date, shift, category, showItem, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the total report
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [totalType] The ID of specific total type for the total report
     * @param {string} [from_date] The date range of the total report
     * @param {string} [to_date] The date range of the total report
     * @param {string} [shift] The ID of specific shift for the total report
     * @param {string} [category] The ID of specific category for the total report
     * @param {boolean} [showItem] The ID of specific category for the total report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTotalReportPdf: function getTotalReportPdf(storeid, token, totalType, from_date, to_date, shift, category, showItem, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getTotalReportPdf(storeid, token, totalType, from_date, to_date, shift, category, showItem, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionDetailReport: function getTransactionDetailReport(storeid, id, options) {
      var localVarAxiosArgs = exports.ReportApiAxiosParamCreator(configuration).getTransactionDetailReport(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * ReportApi - factory interface
 * @export
 */


exports.ReportApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {TransactionDetail} TransactionDetail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    editTransactionReport: function editTransactionReport(storeid, id, TransactionDetail, options) {
      return exports.ReportApiFp(configuration).editTransactionReport(storeid, id, TransactionDetail, options)(axios, basePath);
    },

    /**
     * Return the daily report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the daily report
     * @param {string} [to_date] The date range of the daily report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDailyReport: function getDailyReport(storeid, from_date, to_date, options) {
      return exports.ReportApiFp(configuration).getDailyReport(storeid, from_date, to_date, options)(axios, basePath);
    },

    /**
     * return daily report pdf
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the daily report
     * @param {string} [to_date] The date range of the daily report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDailyReportPdf: function getDailyReportPdf(storeid, token, from_date, to_date, options) {
      return exports.ReportApiFp(configuration).getDailyReportPdf(storeid, token, from_date, to_date, options)(axios, basePath);
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the detail report
     * @param {string} [to_date] The date range of the detail report
     * @param {string} [shift] The ID of specific shift for the detail report
     * @param {string} [area] The ID of specific area for the detail report
     * @param {string} [employee] The ID of specific employee for the detail report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetailReport: function getDetailReport(storeid, from_date, to_date, shift, area, employee, options) {
      return exports.ReportApiFp(configuration).getDetailReport(storeid, from_date, to_date, shift, area, employee, options)(axios, basePath);
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the detail report
     * @param {string} [to_date] The date range of the detail report
     * @param {string} [shift] The ID of specific shift for the detail report
     * @param {string} [area] The ID of specific area for the detail report
     * @param {string} [employee] The ID of specific employee for the detail report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetailReportCsv: function getDetailReportCsv(storeid, token, from_date, to_date, shift, area, employee, options) {
      return exports.ReportApiFp(configuration).getDetailReportCsv(storeid, token, from_date, to_date, shift, area, employee, options)(axios, basePath);
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the detail report
     * @param {string} [to_date] The date range of the detail report
     * @param {string} [shift] The ID of specific shift for the detail report
     * @param {string} [area] The ID of specific area for the detail report
     * @param {string} [employee] The ID of specific employee for the detail report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetailReportPdf: function getDetailReportPdf(storeid, token, from_date, to_date, shift, area, employee, options) {
      return exports.ReportApiFp(configuration).getDetailReportPdf(storeid, token, from_date, to_date, shift, area, employee, options)(axios, basePath);
    },

    /**
     * Return the inventory report
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getInventoryReport: function getInventoryReport(storeid, options) {
      return exports.ReportApiFp(configuration).getInventoryReport(storeid, options)(axios, basePath);
    },

    /**
     * Return the server report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the server report
     * @param {string} [to_date] The date range of the server report
     * @param {string} [shift] The ID of specific shift for the server report
     * @param {string} [employee] The ID of specific employee for the server report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServerReport: function getServerReport(storeid, from_date, to_date, shift, employee, options) {
      return exports.ReportApiFp(configuration).getServerReport(storeid, from_date, to_date, shift, employee, options)(axios, basePath);
    },

    /**
     * return server report pdf
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [from_date] The date range of the daily report
     * @param {string} [to_date] The date range of the daily report
     * @param {string} [shift] The ID of specific shift for the server report
     * @param {string} [employee] The ID of specific employee for the server report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServerReportPdf: function getServerReportPdf(storeid, token, from_date, to_date, shift, employee, options) {
      return exports.ReportApiFp(configuration).getServerReportPdf(storeid, token, from_date, to_date, shift, employee, options)(axios, basePath);
    },

    /**
     * Return the tip report
     * @param {string} storeid The store id to get data from
     * @param {string} [from_date] The date range of the tip report
     * @param {string} [to_date] The date range of the tip report
     * @param {string} [employee] The ID of specific employee for the tip report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTipReport: function getTipReport(storeid, from_date, to_date, employee, options) {
      return exports.ReportApiFp(configuration).getTipReport(storeid, from_date, to_date, employee, options)(axios, basePath);
    },

    /**
     * Return the total report
     * @param {string} storeid The store id to get data from
     * @param {string} [totalType] The ID of specific total type for the total report
     * @param {string} [from_date] The date range of the total report
     * @param {string} [to_date] The date range of the total report
     * @param {string} [shift] The ID of specific shift for the total report
     * @param {string} [category] The ID of specific category for the total report
     * @param {boolean} [showItem] The ID of specific category for the total report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTotalReport: function getTotalReport(storeid, totalType, from_date, to_date, shift, category, showItem, options) {
      return exports.ReportApiFp(configuration).getTotalReport(storeid, totalType, from_date, to_date, shift, category, showItem, options)(axios, basePath);
    },

    /**
     * Return the total report
     * @param {string} storeid The store id to get data from
     * @param {string} token authorization token
     * @param {string} [totalType] The ID of specific total type for the total report
     * @param {string} [from_date] The date range of the total report
     * @param {string} [to_date] The date range of the total report
     * @param {string} [shift] The ID of specific shift for the total report
     * @param {string} [category] The ID of specific category for the total report
     * @param {boolean} [showItem] The ID of specific category for the total report
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTotalReportPdf: function getTotalReportPdf(storeid, token, totalType, from_date, to_date, shift, category, showItem, options) {
      return exports.ReportApiFp(configuration).getTotalReportPdf(storeid, token, totalType, from_date, to_date, shift, category, showItem, options)(axios, basePath);
    },

    /**
     * Return the detail report
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransactionDetailReport: function getTransactionDetailReport(storeid, id, options) {
      return exports.ReportApiFp(configuration).getTransactionDetailReport(storeid, id, options)(axios, basePath);
    }
  };
};
/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */


var ReportApi =
/** @class */
function (_super) {
  __extends(ReportApi, _super);

  function ReportApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Return the detail report
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {TransactionDetail} TransactionDetail
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.editTransactionReport = function (storeid, id, TransactionDetail, options) {
    return exports.ReportApiFp(this.configuration).editTransactionReport(storeid, id, TransactionDetail, options)(this.axios, this.basePath);
  };
  /**
   * Return the daily report
   * @param {string} storeid The store id to get data from
   * @param {string} [from_date] The date range of the daily report
   * @param {string} [to_date] The date range of the daily report
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getDailyReport = function (storeid, from_date, to_date, options) {
    return exports.ReportApiFp(this.configuration).getDailyReport(storeid, from_date, to_date, options)(this.axios, this.basePath);
  };
  /**
   * return daily report pdf
   * @param {string} storeid The store id to get data from
   * @param {string} token authorization token
   * @param {string} [from_date] The date range of the daily report
   * @param {string} [to_date] The date range of the daily report
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getDailyReportPdf = function (storeid, token, from_date, to_date, options) {
    return exports.ReportApiFp(this.configuration).getDailyReportPdf(storeid, token, from_date, to_date, options)(this.axios, this.basePath);
  };
  /**
   * Return the detail report
   * @param {string} storeid The store id to get data from
   * @param {string} [from_date] The date range of the detail report
   * @param {string} [to_date] The date range of the detail report
   * @param {string} [shift] The ID of specific shift for the detail report
   * @param {string} [area] The ID of specific area for the detail report
   * @param {string} [employee] The ID of specific employee for the detail report
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getDetailReport = function (storeid, from_date, to_date, shift, area, employee, options) {
    return exports.ReportApiFp(this.configuration).getDetailReport(storeid, from_date, to_date, shift, area, employee, options)(this.axios, this.basePath);
  };
  /**
   * Return the detail report
   * @param {string} storeid The store id to get data from
   * @param {string} token authorization token
   * @param {string} [from_date] The date range of the detail report
   * @param {string} [to_date] The date range of the detail report
   * @param {string} [shift] The ID of specific shift for the detail report
   * @param {string} [area] The ID of specific area for the detail report
   * @param {string} [employee] The ID of specific employee for the detail report
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getDetailReportCsv = function (storeid, token, from_date, to_date, shift, area, employee, options) {
    return exports.ReportApiFp(this.configuration).getDetailReportCsv(storeid, token, from_date, to_date, shift, area, employee, options)(this.axios, this.basePath);
  };
  /**
   * Return the detail report
   * @param {string} storeid The store id to get data from
   * @param {string} token authorization token
   * @param {string} [from_date] The date range of the detail report
   * @param {string} [to_date] The date range of the detail report
   * @param {string} [shift] The ID of specific shift for the detail report
   * @param {string} [area] The ID of specific area for the detail report
   * @param {string} [employee] The ID of specific employee for the detail report
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getDetailReportPdf = function (storeid, token, from_date, to_date, shift, area, employee, options) {
    return exports.ReportApiFp(this.configuration).getDetailReportPdf(storeid, token, from_date, to_date, shift, area, employee, options)(this.axios, this.basePath);
  };
  /**
   * Return the inventory report
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getInventoryReport = function (storeid, options) {
    return exports.ReportApiFp(this.configuration).getInventoryReport(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the server report
   * @param {string} storeid The store id to get data from
   * @param {string} [from_date] The date range of the server report
   * @param {string} [to_date] The date range of the server report
   * @param {string} [shift] The ID of specific shift for the server report
   * @param {string} [employee] The ID of specific employee for the server report
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getServerReport = function (storeid, from_date, to_date, shift, employee, options) {
    return exports.ReportApiFp(this.configuration).getServerReport(storeid, from_date, to_date, shift, employee, options)(this.axios, this.basePath);
  };
  /**
   * return server report pdf
   * @param {string} storeid The store id to get data from
   * @param {string} token authorization token
   * @param {string} [from_date] The date range of the daily report
   * @param {string} [to_date] The date range of the daily report
   * @param {string} [shift] The ID of specific shift for the server report
   * @param {string} [employee] The ID of specific employee for the server report
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getServerReportPdf = function (storeid, token, from_date, to_date, shift, employee, options) {
    return exports.ReportApiFp(this.configuration).getServerReportPdf(storeid, token, from_date, to_date, shift, employee, options)(this.axios, this.basePath);
  };
  /**
   * Return the tip report
   * @param {string} storeid The store id to get data from
   * @param {string} [from_date] The date range of the tip report
   * @param {string} [to_date] The date range of the tip report
   * @param {string} [employee] The ID of specific employee for the tip report
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getTipReport = function (storeid, from_date, to_date, employee, options) {
    return exports.ReportApiFp(this.configuration).getTipReport(storeid, from_date, to_date, employee, options)(this.axios, this.basePath);
  };
  /**
   * Return the total report
   * @param {string} storeid The store id to get data from
   * @param {string} [totalType] The ID of specific total type for the total report
   * @param {string} [from_date] The date range of the total report
   * @param {string} [to_date] The date range of the total report
   * @param {string} [shift] The ID of specific shift for the total report
   * @param {string} [category] The ID of specific category for the total report
   * @param {boolean} [showItem] The ID of specific category for the total report
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getTotalReport = function (storeid, totalType, from_date, to_date, shift, category, showItem, options) {
    return exports.ReportApiFp(this.configuration).getTotalReport(storeid, totalType, from_date, to_date, shift, category, showItem, options)(this.axios, this.basePath);
  };
  /**
   * Return the total report
   * @param {string} storeid The store id to get data from
   * @param {string} token authorization token
   * @param {string} [totalType] The ID of specific total type for the total report
   * @param {string} [from_date] The date range of the total report
   * @param {string} [to_date] The date range of the total report
   * @param {string} [shift] The ID of specific shift for the total report
   * @param {string} [category] The ID of specific category for the total report
   * @param {boolean} [showItem] The ID of specific category for the total report
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getTotalReportPdf = function (storeid, token, totalType, from_date, to_date, shift, category, showItem, options) {
    return exports.ReportApiFp(this.configuration).getTotalReportPdf(storeid, token, totalType, from_date, to_date, shift, category, showItem, options)(this.axios, this.basePath);
  };
  /**
   * Return the detail report
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */


  ReportApi.prototype.getTransactionDetailReport = function (storeid, id, options) {
    return exports.ReportApiFp(this.configuration).getTransactionDetailReport(storeid, id, options)(this.axios, this.basePath);
  };

  return ReportApi;
}(base_1.BaseAPI);

exports.ReportApi = ReportApi;
/**
 * ScreenApi - axios parameter creator
 * @export
 */

exports.ScreenApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a screen with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteScreen: function deleteScreen(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteScreen.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteScreen.');
      }

      var localVarPath = "/screen/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * return list of available DS Screen inside a store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDSScreen: function listDSScreen(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listDSScreen.');
      }

      var localVarPath = "/app/store/{storeid}/screens".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the screens belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listScreens: function listScreens(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listScreens.');
      }

      var localVarPath = "/screen/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * return detail of a DS Screen
     * @param {string} storeid The store id to get data from
     * @param {string} screenid The screen id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadDSScreen: function loadDSScreen(storeid, screenid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadDSScreen.');
      } // verify required parameter 'screenid' is not null or undefined


      if (screenid === null || screenid === undefined) {
        throw new base_1.RequiredError('screenid', 'Required parameter screenid was null or undefined when calling loadDSScreen.');
      }

      var localVarPath = "/app/store/{storeid}/screen/{screenid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "screenid" + "}", encodeURIComponent(String(screenid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * return the ffd detail of this store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadFrontFacingDisplay: function loadFrontFacingDisplay(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadFrontFacingDisplay.');
      }

      var localVarPath = "/app/store/{storeid}/ffd".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the screen with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadScreen: function loadScreen(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadScreen.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadScreen.');
      }

      var localVarPath = "/screen/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update or Create screen
     * @param {string} storeid The store id to get data from
     * @param {Screen} Screen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveScreen: function saveScreen(storeid, Screen, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveScreen.');
      } // verify required parameter 'Screen' is not null or undefined


      if (Screen === null || Screen === undefined) {
        throw new base_1.RequiredError('Screen', 'Required parameter Screen was null or undefined when calling saveScreen.');
      }

      var localVarPath = "/screen/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Screen !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Screen !== undefined ? Screen : {}) : Screen || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ScreenApi - functional programming interface
 * @export
 */


exports.ScreenApiFp = function (configuration) {
  return {
    /**
     * Delete a screen with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteScreen: function deleteScreen(storeid, id, options) {
      var localVarAxiosArgs = exports.ScreenApiAxiosParamCreator(configuration).deleteScreen(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * return list of available DS Screen inside a store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDSScreen: function listDSScreen(storeid, options) {
      var localVarAxiosArgs = exports.ScreenApiAxiosParamCreator(configuration).listDSScreen(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the screens belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listScreens: function listScreens(storeid, options) {
      var localVarAxiosArgs = exports.ScreenApiAxiosParamCreator(configuration).listScreens(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * return detail of a DS Screen
     * @param {string} storeid The store id to get data from
     * @param {string} screenid The screen id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadDSScreen: function loadDSScreen(storeid, screenid, options) {
      var localVarAxiosArgs = exports.ScreenApiAxiosParamCreator(configuration).loadDSScreen(storeid, screenid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * return the ffd detail of this store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadFrontFacingDisplay: function loadFrontFacingDisplay(storeid, options) {
      var localVarAxiosArgs = exports.ScreenApiAxiosParamCreator(configuration).loadFrontFacingDisplay(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the screen with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadScreen: function loadScreen(storeid, id, options) {
      var localVarAxiosArgs = exports.ScreenApiAxiosParamCreator(configuration).loadScreen(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update or Create screen
     * @param {string} storeid The store id to get data from
     * @param {Screen} Screen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveScreen: function saveScreen(storeid, Screen, options) {
      var localVarAxiosArgs = exports.ScreenApiAxiosParamCreator(configuration).saveScreen(storeid, Screen, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * ScreenApi - factory interface
 * @export
 */


exports.ScreenApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a screen with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteScreen: function deleteScreen(storeid, id, options) {
      return exports.ScreenApiFp(configuration).deleteScreen(storeid, id, options)(axios, basePath);
    },

    /**
     * return list of available DS Screen inside a store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listDSScreen: function listDSScreen(storeid, options) {
      return exports.ScreenApiFp(configuration).listDSScreen(storeid, options)(axios, basePath);
    },

    /**
     * Return all the screens belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listScreens: function listScreens(storeid, options) {
      return exports.ScreenApiFp(configuration).listScreens(storeid, options)(axios, basePath);
    },

    /**
     * return detail of a DS Screen
     * @param {string} storeid The store id to get data from
     * @param {string} screenid The screen id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadDSScreen: function loadDSScreen(storeid, screenid, options) {
      return exports.ScreenApiFp(configuration).loadDSScreen(storeid, screenid, options)(axios, basePath);
    },

    /**
     * return the ffd detail of this store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadFrontFacingDisplay: function loadFrontFacingDisplay(storeid, options) {
      return exports.ScreenApiFp(configuration).loadFrontFacingDisplay(storeid, options)(axios, basePath);
    },

    /**
     * Return the screen with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadScreen: function loadScreen(storeid, id, options) {
      return exports.ScreenApiFp(configuration).loadScreen(storeid, id, options)(axios, basePath);
    },

    /**
     * Update or Create screen
     * @param {string} storeid The store id to get data from
     * @param {Screen} Screen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveScreen: function saveScreen(storeid, Screen, options) {
      return exports.ScreenApiFp(configuration).saveScreen(storeid, Screen, options)(axios, basePath);
    }
  };
};
/**
 * ScreenApi - object-oriented interface
 * @export
 * @class ScreenApi
 * @extends {BaseAPI}
 */


var ScreenApi =
/** @class */
function (_super) {
  __extends(ScreenApi, _super);

  function ScreenApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a screen with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */


  ScreenApi.prototype.deleteScreen = function (storeid, id, options) {
    return exports.ScreenApiFp(this.configuration).deleteScreen(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * return list of available DS Screen inside a store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */


  ScreenApi.prototype.listDSScreen = function (storeid, options) {
    return exports.ScreenApiFp(this.configuration).listDSScreen(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return all the screens belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */


  ScreenApi.prototype.listScreens = function (storeid, options) {
    return exports.ScreenApiFp(this.configuration).listScreens(storeid, options)(this.axios, this.basePath);
  };
  /**
   * return detail of a DS Screen
   * @param {string} storeid The store id to get data from
   * @param {string} screenid The screen id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */


  ScreenApi.prototype.loadDSScreen = function (storeid, screenid, options) {
    return exports.ScreenApiFp(this.configuration).loadDSScreen(storeid, screenid, options)(this.axios, this.basePath);
  };
  /**
   * return the ffd detail of this store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */


  ScreenApi.prototype.loadFrontFacingDisplay = function (storeid, options) {
    return exports.ScreenApiFp(this.configuration).loadFrontFacingDisplay(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the screen with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */


  ScreenApi.prototype.loadScreen = function (storeid, id, options) {
    return exports.ScreenApiFp(this.configuration).loadScreen(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update or Create screen
   * @param {string} storeid The store id to get data from
   * @param {Screen} Screen
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */


  ScreenApi.prototype.saveScreen = function (storeid, Screen, options) {
    return exports.ScreenApiFp(this.configuration).saveScreen(storeid, Screen, options)(this.axios, this.basePath);
  };

  return ScreenApi;
}(base_1.BaseAPI);

exports.ScreenApi = ScreenApi;
/**
 * SettingsApi - axios parameter creator
 * @export
 */

exports.SettingsApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * check the order status board is applied or not.
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    isAppliedStatusBoard: function isAppliedStatusBoard(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling isAppliedStatusBoard.');
      }

      var localVarPath = "/settings/{storeid}/statusboard".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * load settings for a store.
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadSettings: function loadSettings(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadSettings.');
      }

      var localVarPath = "/settings/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * saving store settings.
     * @param {string} storeid The store id to get data from
     * @param {Settings} Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveSettings: function saveSettings(storeid, Settings, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveSettings.');
      } // verify required parameter 'Settings' is not null or undefined


      if (Settings === null || Settings === undefined) {
        throw new base_1.RequiredError('Settings', 'Required parameter Settings was null or undefined when calling saveSettings.');
      }

      var localVarPath = "/settings/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Settings !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Settings !== undefined ? Settings : {}) : Settings || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * SettingsApi - functional programming interface
 * @export
 */


exports.SettingsApiFp = function (configuration) {
  return {
    /**
     * check the order status board is applied or not.
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    isAppliedStatusBoard: function isAppliedStatusBoard(storeid, options) {
      var localVarAxiosArgs = exports.SettingsApiAxiosParamCreator(configuration).isAppliedStatusBoard(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * load settings for a store.
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadSettings: function loadSettings(storeid, options) {
      var localVarAxiosArgs = exports.SettingsApiAxiosParamCreator(configuration).loadSettings(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * saving store settings.
     * @param {string} storeid The store id to get data from
     * @param {Settings} Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveSettings: function saveSettings(storeid, Settings, options) {
      var localVarAxiosArgs = exports.SettingsApiAxiosParamCreator(configuration).saveSettings(storeid, Settings, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * SettingsApi - factory interface
 * @export
 */


exports.SettingsApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * check the order status board is applied or not.
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    isAppliedStatusBoard: function isAppliedStatusBoard(storeid, options) {
      return exports.SettingsApiFp(configuration).isAppliedStatusBoard(storeid, options)(axios, basePath);
    },

    /**
     * load settings for a store.
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadSettings: function loadSettings(storeid, options) {
      return exports.SettingsApiFp(configuration).loadSettings(storeid, options)(axios, basePath);
    },

    /**
     * saving store settings.
     * @param {string} storeid The store id to get data from
     * @param {Settings} Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveSettings: function saveSettings(storeid, Settings, options) {
      return exports.SettingsApiFp(configuration).saveSettings(storeid, Settings, options)(axios, basePath);
    }
  };
};
/**
 * SettingsApi - object-oriented interface
 * @export
 * @class SettingsApi
 * @extends {BaseAPI}
 */


var SettingsApi =
/** @class */
function (_super) {
  __extends(SettingsApi, _super);

  function SettingsApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * check the order status board is applied or not.
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SettingsApi
   */


  SettingsApi.prototype.isAppliedStatusBoard = function (storeid, options) {
    return exports.SettingsApiFp(this.configuration).isAppliedStatusBoard(storeid, options)(this.axios, this.basePath);
  };
  /**
   * load settings for a store.
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SettingsApi
   */


  SettingsApi.prototype.loadSettings = function (storeid, options) {
    return exports.SettingsApiFp(this.configuration).loadSettings(storeid, options)(this.axios, this.basePath);
  };
  /**
   * saving store settings.
   * @param {string} storeid The store id to get data from
   * @param {Settings} Settings
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SettingsApi
   */


  SettingsApi.prototype.saveSettings = function (storeid, Settings, options) {
    return exports.SettingsApiFp(this.configuration).saveSettings(storeid, Settings, options)(this.axios, this.basePath);
  };

  return SettingsApi;
}(base_1.BaseAPI);

exports.SettingsApi = SettingsApi;
/**
 * ShopApi - axios parameter creator
 * @export
 */

exports.ShopApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Load shop history
     * @param {string} storeid The store id to get data from
     * @param {string} from_date
     * @param {string} to_date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopHistory: function loadShopHistory(storeid, from_date, to_date, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadShopHistory.');
      } // verify required parameter 'from_date' is not null or undefined


      if (from_date === null || from_date === undefined) {
        throw new base_1.RequiredError('from_date', 'Required parameter from_date was null or undefined when calling loadShopHistory.');
      } // verify required parameter 'to_date' is not null or undefined


      if (to_date === null || to_date === undefined) {
        throw new base_1.RequiredError('to_date', 'Required parameter to_date was null or undefined when calling loadShopHistory.');
      }

      var localVarPath = "/app/shop/{storeid}/history".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (from_date !== undefined) {
        localVarQueryParameter['from_date'] = from_date;
      }

      if (to_date !== undefined) {
        localVarQueryParameter['to_date'] = to_date;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return shop items for store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopInfo: function loadShopInfo(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadShopInfo.');
      }

      var localVarPath = "/app/shop/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Submit a shop order
     * @param {string} storeid The store id to get data from
     * @param {string} X_Request_Recaptcha_Token the captcha token from user verification
     * @param {ShopOrder} ShopOrder The shop order to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitShopOrder: function submitShopOrder(storeid, X_Request_Recaptcha_Token, ShopOrder, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling submitShopOrder.');
      } // verify required parameter 'X_Request_Recaptcha_Token' is not null or undefined


      if (X_Request_Recaptcha_Token === null || X_Request_Recaptcha_Token === undefined) {
        throw new base_1.RequiredError('X_Request_Recaptcha_Token', 'Required parameter X_Request_Recaptcha_Token was null or undefined when calling submitShopOrder.');
      } // verify required parameter 'ShopOrder' is not null or undefined


      if (ShopOrder === null || ShopOrder === undefined) {
        throw new base_1.RequiredError('ShopOrder', 'Required parameter ShopOrder was null or undefined when calling submitShopOrder.');
      }

      var localVarPath = "/app/shop/{storeid}/order".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (X_Request_Recaptcha_Token !== undefined && X_Request_Recaptcha_Token !== null) {
        localVarHeaderParameter['X-Request-Recaptcha-Token'] = String(X_Request_Recaptcha_Token);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof ShopOrder !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(ShopOrder !== undefined ? ShopOrder : {}) : ShopOrder || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ShopApi - functional programming interface
 * @export
 */


exports.ShopApiFp = function (configuration) {
  return {
    /**
     * Load shop history
     * @param {string} storeid The store id to get data from
     * @param {string} from_date
     * @param {string} to_date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopHistory: function loadShopHistory(storeid, from_date, to_date, options) {
      var localVarAxiosArgs = exports.ShopApiAxiosParamCreator(configuration).loadShopHistory(storeid, from_date, to_date, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return shop items for store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopInfo: function loadShopInfo(storeid, options) {
      var localVarAxiosArgs = exports.ShopApiAxiosParamCreator(configuration).loadShopInfo(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Submit a shop order
     * @param {string} storeid The store id to get data from
     * @param {string} X_Request_Recaptcha_Token the captcha token from user verification
     * @param {ShopOrder} ShopOrder The shop order to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitShopOrder: function submitShopOrder(storeid, X_Request_Recaptcha_Token, ShopOrder, options) {
      var localVarAxiosArgs = exports.ShopApiAxiosParamCreator(configuration).submitShopOrder(storeid, X_Request_Recaptcha_Token, ShopOrder, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * ShopApi - factory interface
 * @export
 */


exports.ShopApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Load shop history
     * @param {string} storeid The store id to get data from
     * @param {string} from_date
     * @param {string} to_date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopHistory: function loadShopHistory(storeid, from_date, to_date, options) {
      return exports.ShopApiFp(configuration).loadShopHistory(storeid, from_date, to_date, options)(axios, basePath);
    },

    /**
     * Return shop items for store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopInfo: function loadShopInfo(storeid, options) {
      return exports.ShopApiFp(configuration).loadShopInfo(storeid, options)(axios, basePath);
    },

    /**
     * Submit a shop order
     * @param {string} storeid The store id to get data from
     * @param {string} X_Request_Recaptcha_Token the captcha token from user verification
     * @param {ShopOrder} ShopOrder The shop order to be created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitShopOrder: function submitShopOrder(storeid, X_Request_Recaptcha_Token, ShopOrder, options) {
      return exports.ShopApiFp(configuration).submitShopOrder(storeid, X_Request_Recaptcha_Token, ShopOrder, options)(axios, basePath);
    }
  };
};
/**
 * ShopApi - object-oriented interface
 * @export
 * @class ShopApi
 * @extends {BaseAPI}
 */


var ShopApi =
/** @class */
function (_super) {
  __extends(ShopApi, _super);

  function ShopApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Load shop history
   * @param {string} storeid The store id to get data from
   * @param {string} from_date
   * @param {string} to_date
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopApi
   */


  ShopApi.prototype.loadShopHistory = function (storeid, from_date, to_date, options) {
    return exports.ShopApiFp(this.configuration).loadShopHistory(storeid, from_date, to_date, options)(this.axios, this.basePath);
  };
  /**
   * Return shop items for store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopApi
   */


  ShopApi.prototype.loadShopInfo = function (storeid, options) {
    return exports.ShopApiFp(this.configuration).loadShopInfo(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Submit a shop order
   * @param {string} storeid The store id to get data from
   * @param {string} X_Request_Recaptcha_Token the captcha token from user verification
   * @param {ShopOrder} ShopOrder The shop order to be created
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopApi
   */


  ShopApi.prototype.submitShopOrder = function (storeid, X_Request_Recaptcha_Token, ShopOrder, options) {
    return exports.ShopApiFp(this.configuration).submitShopOrder(storeid, X_Request_Recaptcha_Token, ShopOrder, options)(this.axios, this.basePath);
  };

  return ShopApi;
}(base_1.BaseAPI);

exports.ShopApi = ShopApi;
/**
 * ShopItemApi - axios parameter creator
 * @export
 */

exports.ShopItemApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a shop item with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteShopItem: function deleteShopItem(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteShopItem.');
      }

      var localVarPath = "/shopitem/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the shop items belong to given store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listShopItems: function listShopItems(options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/shopitem";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the shop item with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopItem: function loadShopItem(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadShopItem.');
      }

      var localVarPath = "/shopitem/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create shop item
     * @param {ShopItem} ShopItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveShopItem: function saveShopItem(ShopItem, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'ShopItem' is not null or undefined


      if (ShopItem === null || ShopItem === undefined) {
        throw new base_1.RequiredError('ShopItem', 'Required parameter ShopItem was null or undefined when calling saveShopItem.');
      }

      var localVarPath = "/shopitem";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof ShopItem !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(ShopItem !== undefined ? ShopItem : {}) : ShopItem || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ShopItemApi - functional programming interface
 * @export
 */


exports.ShopItemApiFp = function (configuration) {
  return {
    /**
     * Delete a shop item with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteShopItem: function deleteShopItem(id, options) {
      var localVarAxiosArgs = exports.ShopItemApiAxiosParamCreator(configuration).deleteShopItem(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the shop items belong to given store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listShopItems: function listShopItems(options) {
      var localVarAxiosArgs = exports.ShopItemApiAxiosParamCreator(configuration).listShopItems(options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the shop item with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopItem: function loadShopItem(id, options) {
      var localVarAxiosArgs = exports.ShopItemApiAxiosParamCreator(configuration).loadShopItem(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create shop item
     * @param {ShopItem} ShopItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveShopItem: function saveShopItem(ShopItem, options) {
      var localVarAxiosArgs = exports.ShopItemApiAxiosParamCreator(configuration).saveShopItem(ShopItem, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * ShopItemApi - factory interface
 * @export
 */


exports.ShopItemApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a shop item with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteShopItem: function deleteShopItem(id, options) {
      return exports.ShopItemApiFp(configuration).deleteShopItem(id, options)(axios, basePath);
    },

    /**
     * Return all the shop items belong to given store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listShopItems: function listShopItems(options) {
      return exports.ShopItemApiFp(configuration).listShopItems(options)(axios, basePath);
    },

    /**
     * Return the shop item with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopItem: function loadShopItem(id, options) {
      return exports.ShopItemApiFp(configuration).loadShopItem(id, options)(axios, basePath);
    },

    /**
     * Update/Create shop item
     * @param {ShopItem} ShopItem
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveShopItem: function saveShopItem(ShopItem, options) {
      return exports.ShopItemApiFp(configuration).saveShopItem(ShopItem, options)(axios, basePath);
    }
  };
};
/**
 * ShopItemApi - object-oriented interface
 * @export
 * @class ShopItemApi
 * @extends {BaseAPI}
 */


var ShopItemApi =
/** @class */
function (_super) {
  __extends(ShopItemApi, _super);

  function ShopItemApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a shop item with given id
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopItemApi
   */


  ShopItemApi.prototype.deleteShopItem = function (id, options) {
    return exports.ShopItemApiFp(this.configuration).deleteShopItem(id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the shop items belong to given store
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopItemApi
   */


  ShopItemApi.prototype.listShopItems = function (options) {
    return exports.ShopItemApiFp(this.configuration).listShopItems(options)(this.axios, this.basePath);
  };
  /**
   * Return the shop item with given id
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopItemApi
   */


  ShopItemApi.prototype.loadShopItem = function (id, options) {
    return exports.ShopItemApiFp(this.configuration).loadShopItem(id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create shop item
   * @param {ShopItem} ShopItem
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopItemApi
   */


  ShopItemApi.prototype.saveShopItem = function (ShopItem, options) {
    return exports.ShopItemApiFp(this.configuration).saveShopItem(ShopItem, options)(this.axios, this.basePath);
  };

  return ShopItemApi;
}(base_1.BaseAPI);

exports.ShopItemApi = ShopItemApi;
/**
 * ShopOrderApi - axios parameter creator
 * @export
 */

exports.ShopOrderApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Apply shop order
     * @param {ShopOrder} ShopOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyShopOrder: function applyShopOrder(ShopOrder, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'ShopOrder' is not null or undefined


      if (ShopOrder === null || ShopOrder === undefined) {
        throw new base_1.RequiredError('ShopOrder', 'Required parameter ShopOrder was null or undefined when calling applyShopOrder.');
      }

      var localVarPath = "/shoporder/apply";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof ShopOrder !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(ShopOrder !== undefined ? ShopOrder : {}) : ShopOrder || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Delete a shop order with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteShopOrder: function deleteShopOrder(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteShopOrder.');
      }

      var localVarPath = "/shoporder/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the shop orders belong to given store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listShopOrders: function listShopOrders(options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/shoporder";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the shop order with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopOrder: function loadShopOrder(id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadShopOrder.');
      }

      var localVarPath = "/shoporder/{id}".replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create shop order
     * @param {ShopOrder} ShopOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveShopOrder: function saveShopOrder(ShopOrder, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'ShopOrder' is not null or undefined


      if (ShopOrder === null || ShopOrder === undefined) {
        throw new base_1.RequiredError('ShopOrder', 'Required parameter ShopOrder was null or undefined when calling saveShopOrder.');
      }

      var localVarPath = "/shoporder";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof ShopOrder !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(ShopOrder !== undefined ? ShopOrder : {}) : ShopOrder || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * ShopOrderApi - functional programming interface
 * @export
 */


exports.ShopOrderApiFp = function (configuration) {
  return {
    /**
     * Apply shop order
     * @param {ShopOrder} ShopOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyShopOrder: function applyShopOrder(ShopOrder, options) {
      var localVarAxiosArgs = exports.ShopOrderApiAxiosParamCreator(configuration).applyShopOrder(ShopOrder, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Delete a shop order with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteShopOrder: function deleteShopOrder(id, options) {
      var localVarAxiosArgs = exports.ShopOrderApiAxiosParamCreator(configuration).deleteShopOrder(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the shop orders belong to given store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listShopOrders: function listShopOrders(options) {
      var localVarAxiosArgs = exports.ShopOrderApiAxiosParamCreator(configuration).listShopOrders(options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the shop order with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopOrder: function loadShopOrder(id, options) {
      var localVarAxiosArgs = exports.ShopOrderApiAxiosParamCreator(configuration).loadShopOrder(id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create shop order
     * @param {ShopOrder} ShopOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveShopOrder: function saveShopOrder(ShopOrder, options) {
      var localVarAxiosArgs = exports.ShopOrderApiAxiosParamCreator(configuration).saveShopOrder(ShopOrder, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * ShopOrderApi - factory interface
 * @export
 */


exports.ShopOrderApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Apply shop order
     * @param {ShopOrder} ShopOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applyShopOrder: function applyShopOrder(ShopOrder, options) {
      return exports.ShopOrderApiFp(configuration).applyShopOrder(ShopOrder, options)(axios, basePath);
    },

    /**
     * Delete a shop order with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteShopOrder: function deleteShopOrder(id, options) {
      return exports.ShopOrderApiFp(configuration).deleteShopOrder(id, options)(axios, basePath);
    },

    /**
     * Return all the shop orders belong to given store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listShopOrders: function listShopOrders(options) {
      return exports.ShopOrderApiFp(configuration).listShopOrders(options)(axios, basePath);
    },

    /**
     * Return the shop order with given id
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadShopOrder: function loadShopOrder(id, options) {
      return exports.ShopOrderApiFp(configuration).loadShopOrder(id, options)(axios, basePath);
    },

    /**
     * Update/Create shop order
     * @param {ShopOrder} ShopOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveShopOrder: function saveShopOrder(ShopOrder, options) {
      return exports.ShopOrderApiFp(configuration).saveShopOrder(ShopOrder, options)(axios, basePath);
    }
  };
};
/**
 * ShopOrderApi - object-oriented interface
 * @export
 * @class ShopOrderApi
 * @extends {BaseAPI}
 */


var ShopOrderApi =
/** @class */
function (_super) {
  __extends(ShopOrderApi, _super);

  function ShopOrderApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Apply shop order
   * @param {ShopOrder} ShopOrder
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopOrderApi
   */


  ShopOrderApi.prototype.applyShopOrder = function (ShopOrder, options) {
    return exports.ShopOrderApiFp(this.configuration).applyShopOrder(ShopOrder, options)(this.axios, this.basePath);
  };
  /**
   * Delete a shop order with given id
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopOrderApi
   */


  ShopOrderApi.prototype.deleteShopOrder = function (id, options) {
    return exports.ShopOrderApiFp(this.configuration).deleteShopOrder(id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the shop orders belong to given store
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopOrderApi
   */


  ShopOrderApi.prototype.listShopOrders = function (options) {
    return exports.ShopOrderApiFp(this.configuration).listShopOrders(options)(this.axios, this.basePath);
  };
  /**
   * Return the shop order with given id
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopOrderApi
   */


  ShopOrderApi.prototype.loadShopOrder = function (id, options) {
    return exports.ShopOrderApiFp(this.configuration).loadShopOrder(id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create shop order
   * @param {ShopOrder} ShopOrder
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShopOrderApi
   */


  ShopOrderApi.prototype.saveShopOrder = function (ShopOrder, options) {
    return exports.ShopOrderApiFp(this.configuration).saveShopOrder(ShopOrder, options)(this.axios, this.basePath);
  };

  return ShopOrderApi;
}(base_1.BaseAPI);

exports.ShopOrderApi = ShopOrderApi;
/**
 * StationApi - axios parameter creator
 * @export
 */

exports.StationApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete a station with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStation: function deleteStation(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteStation.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteStation.');
      }

      var localVarPath = "/station/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return all the stations belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listStations: function listStations(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling listStations.');
      }

      var localVarPath = "/station/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the main station of the store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMainStation: function loadMainStation(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadMainStation.');
      }

      var localVarPath = "/mainstation/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the station with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadStation: function loadStation(storeid, id, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadStation.');
      } // verify required parameter 'id' is not null or undefined


      if (id === null || id === undefined) {
        throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling loadStation.');
      }

      var localVarPath = "/station/{storeid}/{id}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid))).replace("{" + "id" + "}", encodeURIComponent(String(id)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create station
     * @param {string} storeid The store id to get data from
     * @param {Station} Station
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveStation: function saveStation(storeid, Station, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling saveStation.');
      } // verify required parameter 'Station' is not null or undefined


      if (Station === null || Station === undefined) {
        throw new base_1.RequiredError('Station', 'Required parameter Station was null or undefined when calling saveStation.');
      }

      var localVarPath = "/station/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Station !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Station !== undefined ? Station : {}) : Station || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * StationApi - functional programming interface
 * @export
 */


exports.StationApiFp = function (configuration) {
  return {
    /**
     * Delete a station with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStation: function deleteStation(storeid, id, options) {
      var localVarAxiosArgs = exports.StationApiAxiosParamCreator(configuration).deleteStation(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return all the stations belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listStations: function listStations(storeid, options) {
      var localVarAxiosArgs = exports.StationApiAxiosParamCreator(configuration).listStations(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the main station of the store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMainStation: function loadMainStation(storeid, options) {
      var localVarAxiosArgs = exports.StationApiAxiosParamCreator(configuration).loadMainStation(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the station with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadStation: function loadStation(storeid, id, options) {
      var localVarAxiosArgs = exports.StationApiAxiosParamCreator(configuration).loadStation(storeid, id, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create station
     * @param {string} storeid The store id to get data from
     * @param {Station} Station
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveStation: function saveStation(storeid, Station, options) {
      var localVarAxiosArgs = exports.StationApiAxiosParamCreator(configuration).saveStation(storeid, Station, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * StationApi - factory interface
 * @export
 */


exports.StationApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete a station with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStation: function deleteStation(storeid, id, options) {
      return exports.StationApiFp(configuration).deleteStation(storeid, id, options)(axios, basePath);
    },

    /**
     * Return all the stations belong to given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listStations: function listStations(storeid, options) {
      return exports.StationApiFp(configuration).listStations(storeid, options)(axios, basePath);
    },

    /**
     * Return the main station of the store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadMainStation: function loadMainStation(storeid, options) {
      return exports.StationApiFp(configuration).loadMainStation(storeid, options)(axios, basePath);
    },

    /**
     * Return the station with given id
     * @param {string} storeid The store id to get data from
     * @param {string} id The object id to load for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadStation: function loadStation(storeid, id, options) {
      return exports.StationApiFp(configuration).loadStation(storeid, id, options)(axios, basePath);
    },

    /**
     * Update/Create station
     * @param {string} storeid The store id to get data from
     * @param {Station} Station
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveStation: function saveStation(storeid, Station, options) {
      return exports.StationApiFp(configuration).saveStation(storeid, Station, options)(axios, basePath);
    }
  };
};
/**
 * StationApi - object-oriented interface
 * @export
 * @class StationApi
 * @extends {BaseAPI}
 */


var StationApi =
/** @class */
function (_super) {
  __extends(StationApi, _super);

  function StationApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete a station with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StationApi
   */


  StationApi.prototype.deleteStation = function (storeid, id, options) {
    return exports.StationApiFp(this.configuration).deleteStation(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Return all the stations belong to given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StationApi
   */


  StationApi.prototype.listStations = function (storeid, options) {
    return exports.StationApiFp(this.configuration).listStations(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the main station of the store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StationApi
   */


  StationApi.prototype.loadMainStation = function (storeid, options) {
    return exports.StationApiFp(this.configuration).loadMainStation(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Return the station with given id
   * @param {string} storeid The store id to get data from
   * @param {string} id The object id to load for
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StationApi
   */


  StationApi.prototype.loadStation = function (storeid, id, options) {
    return exports.StationApiFp(this.configuration).loadStation(storeid, id, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create station
   * @param {string} storeid The store id to get data from
   * @param {Station} Station
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StationApi
   */


  StationApi.prototype.saveStation = function (storeid, Station, options) {
    return exports.StationApiFp(this.configuration).saveStation(storeid, Station, options)(this.axios, this.basePath);
  };

  return StationApi;
}(base_1.BaseAPI);

exports.StationApi = StationApi;
/**
 * StatusBoardApi - axios parameter creator
 * @export
 */

exports.StatusBoardApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Return speech for ready order by orderNo
     * @param {string} storeid The store id to get data from
     * @param {number} orderNo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSpeechForReadyOrder: function getSpeechForReadyOrder(storeid, orderNo, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling getSpeechForReadyOrder.');
      } // verify required parameter 'orderNo' is not null or undefined


      if (orderNo === null || orderNo === undefined) {
        throw new base_1.RequiredError('orderNo', 'Required parameter orderNo was null or undefined when calling getSpeechForReadyOrder.');
      }

      var localVarPath = "/app/statusboard/speech/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};

      if (orderNo !== undefined) {
        localVarQueryParameter['orderNo'] = orderNo;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * StatusBoardApi - functional programming interface
 * @export
 */


exports.StatusBoardApiFp = function (configuration) {
  return {
    /**
     * Return speech for ready order by orderNo
     * @param {string} storeid The store id to get data from
     * @param {number} orderNo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSpeechForReadyOrder: function getSpeechForReadyOrder(storeid, orderNo, options) {
      var localVarAxiosArgs = exports.StatusBoardApiAxiosParamCreator(configuration).getSpeechForReadyOrder(storeid, orderNo, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * StatusBoardApi - factory interface
 * @export
 */


exports.StatusBoardApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Return speech for ready order by orderNo
     * @param {string} storeid The store id to get data from
     * @param {number} orderNo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSpeechForReadyOrder: function getSpeechForReadyOrder(storeid, orderNo, options) {
      return exports.StatusBoardApiFp(configuration).getSpeechForReadyOrder(storeid, orderNo, options)(axios, basePath);
    }
  };
};
/**
 * StatusBoardApi - object-oriented interface
 * @export
 * @class StatusBoardApi
 * @extends {BaseAPI}
 */


var StatusBoardApi =
/** @class */
function (_super) {
  __extends(StatusBoardApi, _super);

  function StatusBoardApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Return speech for ready order by orderNo
   * @param {string} storeid The store id to get data from
   * @param {number} orderNo
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StatusBoardApi
   */


  StatusBoardApi.prototype.getSpeechForReadyOrder = function (storeid, orderNo, options) {
    return exports.StatusBoardApiFp(this.configuration).getSpeechForReadyOrder(storeid, orderNo, options)(this.axios, this.basePath);
  };

  return StatusBoardApi;
}(base_1.BaseAPI);

exports.StatusBoardApi = StatusBoardApi;
/**
 * StoreApi - axios parameter creator
 * @export
 */

exports.StoreApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Delete the given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStore: function deleteStore(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling deleteStore.');
      }

      var localVarPath = "/store/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'DELETE'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * 1. If the current role is Merchant, then return all Stores belong to this Merchant. 2. If the current role is (Super)Admin, then return all Stores from all Merchant.  **Note**&#58; Not yet support for pagination.
     * @param {number} [page] Page number
     * @param {number} [count] Total per page
     * @param {string} [query] Filter by name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listStores: function listStores(page, count, query, options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/store";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (count !== undefined) {
        localVarQueryParameter['count'] = count;
      }

      if (query !== undefined) {
        localVarQueryParameter['query'] = query;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Return the store with given ID
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadStore: function loadStore(storeid, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadStore.');
      }

      var localVarPath = "/store/{storeid}".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Update/Create Store
     * @param {Store} Store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveStore: function saveStore(Store, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'Store' is not null or undefined


      if (Store === null || Store === undefined) {
        throw new base_1.RequiredError('Store', 'Required parameter Store was null or undefined when calling saveStore.');
      }

      var localVarPath = "/store";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof Store !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(Store !== undefined ? Store : {}) : Store || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * StoreApi - functional programming interface
 * @export
 */


exports.StoreApiFp = function (configuration) {
  return {
    /**
     * Delete the given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStore: function deleteStore(storeid, options) {
      var localVarAxiosArgs = exports.StoreApiAxiosParamCreator(configuration).deleteStore(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * 1. If the current role is Merchant, then return all Stores belong to this Merchant. 2. If the current role is (Super)Admin, then return all Stores from all Merchant.  **Note**&#58; Not yet support for pagination.
     * @param {number} [page] Page number
     * @param {number} [count] Total per page
     * @param {string} [query] Filter by name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listStores: function listStores(page, count, query, options) {
      var localVarAxiosArgs = exports.StoreApiAxiosParamCreator(configuration).listStores(page, count, query, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Return the store with given ID
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadStore: function loadStore(storeid, options) {
      var localVarAxiosArgs = exports.StoreApiAxiosParamCreator(configuration).loadStore(storeid, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Update/Create Store
     * @param {Store} Store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveStore: function saveStore(Store, options) {
      var localVarAxiosArgs = exports.StoreApiAxiosParamCreator(configuration).saveStore(Store, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * StoreApi - factory interface
 * @export
 */


exports.StoreApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Delete the given store
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteStore: function deleteStore(storeid, options) {
      return exports.StoreApiFp(configuration).deleteStore(storeid, options)(axios, basePath);
    },

    /**
     * 1. If the current role is Merchant, then return all Stores belong to this Merchant. 2. If the current role is (Super)Admin, then return all Stores from all Merchant.  **Note**&#58; Not yet support for pagination.
     * @param {number} [page] Page number
     * @param {number} [count] Total per page
     * @param {string} [query] Filter by name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listStores: function listStores(page, count, query, options) {
      return exports.StoreApiFp(configuration).listStores(page, count, query, options)(axios, basePath);
    },

    /**
     * Return the store with given ID
     * @param {string} storeid The store id to get data from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadStore: function loadStore(storeid, options) {
      return exports.StoreApiFp(configuration).loadStore(storeid, options)(axios, basePath);
    },

    /**
     * Update/Create Store
     * @param {Store} Store
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveStore: function saveStore(Store, options) {
      return exports.StoreApiFp(configuration).saveStore(Store, options)(axios, basePath);
    }
  };
};
/**
 * StoreApi - object-oriented interface
 * @export
 * @class StoreApi
 * @extends {BaseAPI}
 */


var StoreApi =
/** @class */
function (_super) {
  __extends(StoreApi, _super);

  function StoreApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Delete the given store
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StoreApi
   */


  StoreApi.prototype.deleteStore = function (storeid, options) {
    return exports.StoreApiFp(this.configuration).deleteStore(storeid, options)(this.axios, this.basePath);
  };
  /**
   * 1. If the current role is Merchant, then return all Stores belong to this Merchant. 2. If the current role is (Super)Admin, then return all Stores from all Merchant.  **Note**&#58; Not yet support for pagination.
   * @param {number} [page] Page number
   * @param {number} [count] Total per page
   * @param {string} [query] Filter by name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StoreApi
   */


  StoreApi.prototype.listStores = function (page, count, query, options) {
    return exports.StoreApiFp(this.configuration).listStores(page, count, query, options)(this.axios, this.basePath);
  };
  /**
   * Return the store with given ID
   * @param {string} storeid The store id to get data from
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StoreApi
   */


  StoreApi.prototype.loadStore = function (storeid, options) {
    return exports.StoreApiFp(this.configuration).loadStore(storeid, options)(this.axios, this.basePath);
  };
  /**
   * Update/Create Store
   * @param {Store} Store
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StoreApi
   */


  StoreApi.prototype.saveStore = function (Store, options) {
    return exports.StoreApiFp(this.configuration).saveStore(Store, options)(this.axios, this.basePath);
  };

  return StoreApi;
}(base_1.BaseAPI);

exports.StoreApi = StoreApi;
/**
 * SubscriptionApi - axios parameter creator
 * @export
 */

exports.SubscriptionApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * data billing subscription
     * @param {string} storeid The store id to get data from
     * @param {string} [date] filter by date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingSubscription: function loadBillingSubscription(storeid, date, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'storeid' is not null or undefined


      if (storeid === null || storeid === undefined) {
        throw new base_1.RequiredError('storeid', 'Required parameter storeid was null or undefined when calling loadBillingSubscription.');
      }

      var localVarPath = "/v2/store/{storeid}/billing/subscription".replace("{" + "storeid" + "}", encodeURIComponent(String(storeid)));
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] = date;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * data billing subscription
     * @param {string} [date] filter by date
     * @param {string} [name] filter by store name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportBilling: function reportBilling(date, name, options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/v2/billing/reports";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] = date;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * SubscriptionApi - functional programming interface
 * @export
 */


exports.SubscriptionApiFp = function (configuration) {
  return {
    /**
     * data billing subscription
     * @param {string} storeid The store id to get data from
     * @param {string} [date] filter by date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingSubscription: function loadBillingSubscription(storeid, date, options) {
      var localVarAxiosArgs = exports.SubscriptionApiAxiosParamCreator(configuration).loadBillingSubscription(storeid, date, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * data billing subscription
     * @param {string} [date] filter by date
     * @param {string} [name] filter by store name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportBilling: function reportBilling(date, name, options) {
      var localVarAxiosArgs = exports.SubscriptionApiAxiosParamCreator(configuration).reportBilling(date, name, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * SubscriptionApi - factory interface
 * @export
 */


exports.SubscriptionApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * data billing subscription
     * @param {string} storeid The store id to get data from
     * @param {string} [date] filter by date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadBillingSubscription: function loadBillingSubscription(storeid, date, options) {
      return exports.SubscriptionApiFp(configuration).loadBillingSubscription(storeid, date, options)(axios, basePath);
    },

    /**
     * data billing subscription
     * @param {string} [date] filter by date
     * @param {string} [name] filter by store name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportBilling: function reportBilling(date, name, options) {
      return exports.SubscriptionApiFp(configuration).reportBilling(date, name, options)(axios, basePath);
    }
  };
};
/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */


var SubscriptionApi =
/** @class */
function (_super) {
  __extends(SubscriptionApi, _super);

  function SubscriptionApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * data billing subscription
   * @param {string} storeid The store id to get data from
   * @param {string} [date] filter by date
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */


  SubscriptionApi.prototype.loadBillingSubscription = function (storeid, date, options) {
    return exports.SubscriptionApiFp(this.configuration).loadBillingSubscription(storeid, date, options)(this.axios, this.basePath);
  };
  /**
   * data billing subscription
   * @param {string} [date] filter by date
   * @param {string} [name] filter by store name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */


  SubscriptionApi.prototype.reportBilling = function (date, name, options) {
    return exports.SubscriptionApiFp(this.configuration).reportBilling(date, name, options)(this.axios, this.basePath);
  };

  return SubscriptionApi;
}(base_1.BaseAPI);

exports.SubscriptionApi = SubscriptionApi;
/**
 * SuperAdminApi - axios parameter creator
 * @export
 */

exports.SuperAdminApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Get Super Admin Account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSuperAdmin: function getSuperAdmin(options) {
      if (options === void 0) {
        options = {};
      }

      var localVarPath = "/v2/saccount";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'GET'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    },

    /**
     * Saving Super Admin Account
     * @param {SuperAdmin} SuperAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveSuperAdmin: function saveSuperAdmin(SuperAdmin, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'SuperAdmin' is not null or undefined


      if (SuperAdmin === null || SuperAdmin === undefined) {
        throw new base_1.RequiredError('SuperAdmin', 'Required parameter SuperAdmin was null or undefined when calling saveSuperAdmin.');
      }

      var localVarPath = "/v2/saccount";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {}; // authentication bearerAuth required
      // http bearer authentication required

      if (configuration && configuration.accessToken) {
        var accessToken = typeof configuration.accessToken === 'function' ? configuration.accessToken() : configuration.accessToken;
        localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof SuperAdmin !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(SuperAdmin !== undefined ? SuperAdmin : {}) : SuperAdmin || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * SuperAdminApi - functional programming interface
 * @export
 */


exports.SuperAdminApiFp = function (configuration) {
  return {
    /**
     * Get Super Admin Account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSuperAdmin: function getSuperAdmin(options) {
      var localVarAxiosArgs = exports.SuperAdminApiAxiosParamCreator(configuration).getSuperAdmin(options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    },

    /**
     * Saving Super Admin Account
     * @param {SuperAdmin} SuperAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveSuperAdmin: function saveSuperAdmin(SuperAdmin, options) {
      var localVarAxiosArgs = exports.SuperAdminApiAxiosParamCreator(configuration).saveSuperAdmin(SuperAdmin, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * SuperAdminApi - factory interface
 * @export
 */


exports.SuperAdminApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Get Super Admin Account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSuperAdmin: function getSuperAdmin(options) {
      return exports.SuperAdminApiFp(configuration).getSuperAdmin(options)(axios, basePath);
    },

    /**
     * Saving Super Admin Account
     * @param {SuperAdmin} SuperAdmin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveSuperAdmin: function saveSuperAdmin(SuperAdmin, options) {
      return exports.SuperAdminApiFp(configuration).saveSuperAdmin(SuperAdmin, options)(axios, basePath);
    }
  };
};
/**
 * SuperAdminApi - object-oriented interface
 * @export
 * @class SuperAdminApi
 * @extends {BaseAPI}
 */


var SuperAdminApi =
/** @class */
function (_super) {
  __extends(SuperAdminApi, _super);

  function SuperAdminApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Get Super Admin Account
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SuperAdminApi
   */


  SuperAdminApi.prototype.getSuperAdmin = function (options) {
    return exports.SuperAdminApiFp(this.configuration).getSuperAdmin(options)(this.axios, this.basePath);
  };
  /**
   * Saving Super Admin Account
   * @param {SuperAdmin} SuperAdmin
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SuperAdminApi
   */


  SuperAdminApi.prototype.saveSuperAdmin = function (SuperAdmin, options) {
    return exports.SuperAdminApiFp(this.configuration).saveSuperAdmin(SuperAdmin, options)(this.axios, this.basePath);
  };

  return SuperAdminApi;
}(base_1.BaseAPI);

exports.SuperAdminApi = SuperAdminApi;
/**
 * UserApi - axios parameter creator
 * @export
 */

exports.UserApiAxiosParamCreator = function (configuration) {
  return {
    /**
     * Authenticate a user by username and password
     * @param {AuthenticateRequest} AuthenticateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticate: function authenticate(AuthenticateRequest, options) {
      if (options === void 0) {
        options = {};
      } // verify required parameter 'AuthenticateRequest' is not null or undefined


      if (AuthenticateRequest === null || AuthenticateRequest === undefined) {
        throw new base_1.RequiredError('AuthenticateRequest', 'Required parameter AuthenticateRequest was null or undefined when calling authenticate.');
      }

      var localVarPath = "/authenticate";
      var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      var baseOptions;

      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      var localVarRequestOptions = __assign(__assign({
        method: 'POST'
      }, baseOptions), options);

      var localVarHeaderParameter = {};
      var localVarQueryParameter = {};
      localVarHeaderParameter['Content-Type'] = 'application/json';
      localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

      delete localVarUrlObj.search;
      localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
      var needsSerialization = typeof AuthenticateRequest !== "string" || localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization ? JSON.stringify(AuthenticateRequest !== undefined ? AuthenticateRequest : {}) : AuthenticateRequest || "";
      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};
/**
 * UserApi - functional programming interface
 * @export
 */


exports.UserApiFp = function (configuration) {
  return {
    /**
     * Authenticate a user by username and password
     * @param {AuthenticateRequest} AuthenticateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticate: function authenticate(AuthenticateRequest, options) {
      var localVarAxiosArgs = exports.UserApiAxiosParamCreator(configuration).authenticate(AuthenticateRequest, options);
      return function (axios, basePath) {
        if (axios === void 0) {
          axios = axios_1.default;
        }

        if (basePath === void 0) {
          basePath = base_1.BASE_PATH;
        }

        var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), {
          url: basePath + localVarAxiosArgs.url
        });

        return axios.request(axiosRequestArgs);
      };
    }
  };
};
/**
 * UserApi - factory interface
 * @export
 */


exports.UserApiFactory = function (configuration, basePath, axios) {
  return {
    /**
     * Authenticate a user by username and password
     * @param {AuthenticateRequest} AuthenticateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authenticate: function authenticate(AuthenticateRequest, options) {
      return exports.UserApiFp(configuration).authenticate(AuthenticateRequest, options)(axios, basePath);
    }
  };
};
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */


var UserApi =
/** @class */
function (_super) {
  __extends(UserApi, _super);

  function UserApi() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Authenticate a user by username and password
   * @param {AuthenticateRequest} AuthenticateRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */


  UserApi.prototype.authenticate = function (AuthenticateRequest, options) {
    return exports.UserApiFp(this.configuration).authenticate(AuthenticateRequest, options)(this.axios, this.basePath);
  };

  return UserApi;
}(base_1.BaseAPI);

exports.UserApi = UserApi;